// ════════════════════════════════════════════════════════
//  CONFIG — globale instellingen
// ════════════════════════════════════════════════════════
var CONFIG = {
  freeShippingThreshold: 80,
  shippingCost: 6.75,   // v25: gecorrigeerd naar werkelijk Shopify-tarief (was 5.95)
  vatRate: 0.21,
  ctaLabel: 'Bestel direct',
  ctaSubline: 'Werkdagen vóór 16:00 besteld = vandaag verzonden',
  outOfStockLabel: 'Tijdelijk uitverkocht',
  themeVersion: 'v152-hero-paars36-korting-20260803'
};

// Theme version marker. Geen geforceerde reloads: sneller en rustiger voor bezoekers.
window.__MOOZERS_THEME_VERSION = CONFIG.themeVersion;



var MZ_JOINT_MESH_LIVE = window.__MOOZERS_JOINT_MESH || {};
var MZ_JOINT_MESH_IMAGES = MZ_JOINT_MESH_LIVE.images || {};
var MZ_JOINT_MESH_STANDING = MZ_JOINT_MESH_IMAGES.standing || 'jointmeshgaasbandstaand.png';
var MZ_JOINT_MESH_LIGGEND = MZ_JOINT_MESH_IMAGES.liggend || 'jointmeshgaasbandliggend.png';

// ════════════════════════════════════════════════════════
//  CATALOG — alle producten, volledig data-driven
//  Voeg hier nieuwe producten toe of pas bestaande aan.
//  Prijzen excl. BTW (= incl / 1.21), afgerond op 3 decimalen.
// ════════════════════════════════════════════════════════
var CATALOG = {

  // ── Washi Schilderstape Geel ────────────────────────
  // Staffelkorting 19/24/36mm: 24–71 rollen -3%, ≥72 rollen -10%
  // Staffelkorting 50mm:       24–53 rollen -3%, ≥54 rollen -7%
  'washi-tape': {
    id: 'washi-tape',
    brand: 'MOOZERS®',
    category: 'Schilderstape',
    navLink: 'https://www.moozers.nl/collections/washi-tape',
    reviewScore: 4.8,
    reviewCount: 143,
    colorVariants: [{label:'Geel',productId:'washi-tape',color:'#f5c200'},{label:'Paars',productId:'washi-tape-paars',color:'#8b5cf6'}],
    activeColorIndex: 0,
    variantLabel: 'Breedte',
    variantUnit: 'mm',
    variantSuffix: ' · 50m',
    defaultVariantIndex: 1,
    unit: 'rollen',
    variants: [
      { size:'19', label:'19 mm', priceExcl:1.529, priceIncl:1.85,
        img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_19mm_x_50m.png', imgV:'1781333745',
        title:'Washi Schilderstape Geel — 19mm × 50m', inStock:true },
      { size:'24', label:'24 mm', priceExcl:2.008, priceIncl:2.43,
        img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781333549',
        title:'Washi Schilderstape Geel — 24mm × 50m', inStock:true },
      { size:'36', label:'36 mm', priceExcl:2.950, priceIncl:3.57,
        img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_36mm_x_50m.png', imgV:'1781333528',
        title:'Washi Schilderstape Geel — 36mm × 50m', inStock:false },
      { size:'50', label:'50 mm', priceExcl:4.570, priceIncl:5.53,
        img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_50mm_x_50m.png', imgV:'1781333478',
        title:'Washi Schilderstape Geel — 50mm × 50m', inStock:true,
        staffelTiers: [
          { min:1,  max:23,  discount:0    },
          { min:24, max:53,  discount:0.03 },
          { min:54, max:999, discount:0.07 }
        ]
      }
    ],
    staffelTiers: [
      { min:1,  max:23,  discount:0    },
      { min:24, max:71,  discount:0.03 },
      { min:72, max:999, discount:0.10 }
    ],
    usps: [
      'Geen lijmresten, ook na 14 dagen',
      'Werkdagen vóór 16:00 besteld = <strong>vandaag verzonden</strong>',
      '3% korting v.a. 24 rollen · 10% v.a. 72 rollen'
    ],
    specs: [
      '<strong>Breedte:</strong> 19 / 24 / 36 / 50 mm',
      '<strong>Lengte:</strong> 50 meter per rol',
      '<strong>UV-bestendig:</strong> tot 14 dagen buiten',
      '<strong>Dikte:</strong> 100 micron',
      '<strong>Geschikt voor:</strong> hout, glas en stucwerk',
      '<strong>Geen lijmresten:</strong> ook na 14 dagen plakken',
      '<strong>Scheurbestendig:</strong> gemakkelijk en prettig te verwerken'
    ],
    specsNote: '*Niet gebruiken op natuursteen met open structuur.',
    reviews: [
      { name:'Kees V. — Schilder ZZP', stars:5,
        text:'"Al 2 jaar mijn vaste tape. Hecht perfect op hout, metaal en geschilderd stucwerk. Verwijdert strak zonder lijmresten — ook na een week plakken. Bestel nu altijd per doos voor de staffelkorting."',
        date:'mei 2025' },
      { name:'Sandra de W. — Doe-het-zelver', stars:5,
        text:'"Eindelijk schilderstape die strak afplakt langs kozijnen. Geen lak die eronder kruipt. Besteld op maandag, dinsdag al in huis. Enorm blij mee!"',
        date:'april 2025' }
    ],
    crossSells: [
      { name:'Maskeerfolie 1500mm × 30m',    img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png', imgV:'1781333455', priceExcl:4.12,  priceIncl:4.99,  link:'/collections/maskeerfolie',                             label:'1500mm × 30m', fullTitle:'MOOZERS® Maskeerfolie'  },
      { name:'Maskeerpapier 300mm × 20m',    img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png',                                imgV:'1781331618', priceExcl:3.71,  priceIncl:4.49,  link:'/collections/maskeerfolie',                             label:'300mm × 20m',  fullTitle:'MOOZERS® Maskeerpapier' },
      { name:'Schuurpad Dubbelzijdig P120',   img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg',                            imgV:'1781377934', priceExcl:0.93,  priceIncl:1.13,  link:'/products/moozers-schuurpad-dubbelzijdig-p120',       label:'P120',         fullTitle:'MOOZERS® Schuurpad'     },
      { name:'Schuurpapier P100 · 50 stuks', img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49, link:'/products/moozers-apex-abrasives-p100-100x150mm', label:'P100', fullTitle:'MOOZERS® Schuurpapier' }
    ]
  },

  // ── Washi Schilderstape Paars ───────────────────────
  // Staffelkorting: 24–71 rollen -3%, ≥72 rollen -10%
  'washi-tape-paars': {
    id: 'washi-tape-paars',
    brand: 'MOOZERS®',
    category: 'Schilderstape',
    navLink: 'https://www.moozers.nl/collections/washi-tape',
    reviewScore: 4.8,
    reviewCount: 89,
    colorVariants: [{label:'Geel',productId:'washi-tape',color:'#f5c200'},{label:'Paars',productId:'washi-tape-paars',color:'#8b5cf6'}],
    activeColorIndex: 1,
    variantLabel: 'Breedte',
    variantUnit: 'mm',
    variantSuffix: ' · 50m',
    defaultVariantIndex: 0,
    unit: 'rollen',
    variants: [
      { size:'24', label:'24 mm', priceExcl:2.198, priceIncl:2.66,
        img:'MOOZERS_-_Washi_-_Schilderstape_Paars_-_24mm_x_50m.png', imgV:'1781377963',
        title:'Washi Schilderstape Paars — 24mm × 50m', inStock:true },
      { size:'36', label:'36 mm', priceExcl:2.61, priceIncl:3.16,
        img:'MOOZERS_-_Washi_-_Schilderstape_Paars_-_36mm_x_50m.png', imgV:'1781332518',
        title:'Washi Schilderstape Paars — 36mm × 50m',
        shopifyHandle:'moozers-washi-tape-paars-36mm', inStock:false }
    ],
    staffelTiers: [
      { min:1,  max:23,  discount:0    },
      { min:24, max:71,  discount:0.03 },
      { min:72, max:999, discount:0.10 }
    ],
    usps: [
      'Geen lijmresten, ook na 14 dagen',
      'Werkdagen vóór 16:00 besteld = <strong>vandaag verzonden</strong>',
      '3% korting v.a. 24 rollen · 10% v.a. 72 rollen'
    ],
    specs: [
      '<strong>Kleur:</strong> Paars',
      '<strong>Breedte:</strong> 24 / 36 mm',
      '<strong>Lengte:</strong> 50 meter per rol',
      '<strong>UV-bestendig:</strong> tot 14 dagen buiten',
      '<strong>Dikte:</strong> 100 micron',
      '<strong>Geschikt voor:</strong> hout, glas en stucwerk',
      '<strong>Geen lijmresten:</strong> ook na 14 dagen plakken'
    ],
    specsNote: '*Niet gebruiken op natuursteen met open structuur.',
    reviews: [
      { name:'Mark L. — Schilder ZZP', stars:5,
        text:'"Gebruik paars naast geel om bijv. kozijn en deurstijl apart af te plakken. Werkt perfect samen."',
        date:'april 2025' },
      { name:'Ingrid B. — Doe-het-zelver', stars:5,
        text:'"Fijn dat er nu ook paars is. Makkelijk te onderscheiden van de gele tape op het werk."',
        date:'maart 2025' }
    ],
    crossSells: [
      { name:'Washi Tape Geel 24mm × 50m',  img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781333549', priceExcl:2.008, priceIncl:2.43,  link:'/collections/washi-tape',                             label:'24mm geel', fullTitle:'MOOZERS® Washi Tape Geel' },
      { name:'Maskeerfolie 1500mm × 30m',   img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png',    imgV:'1781333455', priceExcl:4.12,  priceIncl:4.99,  link:'/collections/maskeerfolie',                           label:'1500mm',    fullTitle:'MOOZERS® Maskeerfolie'    },
      { name:'Maskeerpapier 300mm × 20m',   img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png',                                   imgV:'1781331618', priceExcl:3.71,  priceIncl:4.49,  link:'/collections/maskeerfolie',                           label:'300mm',     fullTitle:'MOOZERS® Maskeerpapier'   },
      { name:'Schuurpad Dubbelzijdig P120', img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg',                               imgV:'1781377934', priceExcl:0.93,  priceIncl:1.13,  link:'/products/moozers-schuurpad-dubbelzijdig-p120',     label:'P120',      fullTitle:'MOOZERS® Schuurpad'       }
    ]
  },

  // ── Maskeerfolie ────────────────────────────────────
  // Staffelkorting: 12–24 rollen -3%, 25–49 -5%, ≥50 -10%
  'maskeerfolie': {
    id: 'maskeerfolie',
    brand: 'MOOZERS®',
    category: 'Maskeerfolie',
    navLink: 'https://www.moozers.nl/collections/maskeerfolie',
    reviewScore: 4.8,
    reviewCount: 64,
    variantLabel: 'Formaat',
    variantUnit: '',
    variantSuffix: '',
    defaultVariantIndex: 0,
    unit: 'rollen',
    variants: [
      { size:'1500mm × 30m', label:'1500mm × 30m', priceExcl:4.12, priceIncl:4.99,
        img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png', imgV:'1781333455',
        title:'MOOZERS® Maskeerfolie 1500mm × 30m', inStock:true },
      { size:'2700mm × 20m', label:'2700mm × 20m', priceExcl:4.752, priceIncl:5.75,
        img:'MOOZERS_-_Maskeerfolie_-_2700MM_x_20M.png', imgV:'1781333437',
        title:'MOOZERS® Maskeerfolie 2700mm × 20m', inStock:false }
    ],
    staffelTiers: [
      { min:1,  max:11,  discount:0    },
      { min:12, max:24,  discount:0.03 },
      { min:25, max:49,  discount:0.05 },
      { min:50, max:999, discount:0.10 }
    ],
    usps: [
      'Sterke hechting – geen lek langs de randen',
      'Werkdagen vóór 16:00 besteld = <strong>vandaag verzonden</strong>'
    ],
    specs: [
      '<strong>Materiaal:</strong> PE folie (12 micron)',
      '<strong>Formaten:</strong> 1500mm × 30m · 2700mm × 20m',
      '<strong>Toepassing:</strong> afdekken ramen, vloeren en meubels',
      '<strong>Hersluitbaar:</strong> eenvoudig te hergebruiken',
      '<strong>Combineer met:</strong> washi tape voor optimale afdekking'
    ],
    specsNote: null,
    reviews: [
      { name:'Marco H. — Schilder ZZP', stars:5,
        text:'"Perfecte folie voor binnen- en buitenwerk. Goed te vouwen en te snijden. Geen scheuren in de hoeken."',
        date:'mei 2025' },
      { name:'Lotte V. — Klusser', stars:5,
        text:'"Super handig formaat voor ramen. Plakt goed op tape, snel opgezet."',
        date:'maart 2025' }
    ],
    crossSells: [
      { name:'Washi Tape 24mm × 50m',       img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781333549', priceExcl:2.008, priceIncl:2.43,  link:'/collections/washi-tape',                             label:'24mm',   fullTitle:'MOOZERS® Washi Tape'    },
      { name:'Maskeerpapier 300mm × 20m',   img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png',                                   imgV:'1781331618', priceExcl:3.71,  priceIncl:4.49,  link:'/collections/maskeerfolie',                           label:'300mm',  fullTitle:'MOOZERS® Maskeerpapier' },
      { name:'Washi Tape 50mm × 50m',       img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_50mm_x_50m.png', imgV:'1781333478', priceExcl:4.570, priceIncl:5.53,  link:'/collections/washi-tape',                             label:'50mm',   fullTitle:'MOOZERS® Washi Tape'    },
      { name:'Schuurpad Dubbelzijdig P120', img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg',                               imgV:'1781377934', priceExcl:0.93,  priceIncl:1.13,  link:'/products/moozers-schuurpad-dubbelzijdig-p120',     label:'P120',   fullTitle:'MOOZERS® Schuurpad'     }
    ]
  },

  // ── Maskeerpapier ───────────────────────────────────
  // Staffelkorting: 12–24 rollen -3%, 25–49 -5%, ≥50 -10%
  'maskeerpapier': {
    id: 'maskeerpapier',
    brand: 'MOOZERS®',
    category: 'Maskeerpapier',
    navLink: 'https://www.moozers.nl/collections/maskeerfolie',
    reviewScore: 4.8,
    reviewCount: 41,
    variantLabel: 'Breedte',
    variantUnit: '',
    variantSuffix: '',
    defaultVariantIndex: 0,
    unit: 'rollen',
    variants: [
      { size:'300mm × 20m', label:'300mm × 20m', priceExcl:3.71, priceIncl:4.49,
        img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png', imgV:'1781331618',
        title:'MOOZERS® Maskeerpapier 300mm × 20m', inStock:true }
    ],
    noStaffel: true, // v24: geen staffelkorting voor Maskeerpapier
    staffelTiers: [
      { min:1, max:999, discount:0 } // altijd vaste prijs; geen volumekorting
    ],
    usps: [
      'Beschermt tegen verf- en lakspetters',
      'Werkdagen vóór 16:00 besteld = <strong>vandaag verzonden</strong>'
    ],
    specs: [
      '<strong>Materiaal:</strong> ambachtelijk maskeerpapier',
      '<strong>Breedte:</strong> 300mm',
      '<strong>Lengte:</strong> 20 meter per rol',
      '<strong>Toepassing:</strong> Beschermen en afdekken tijdens schilderwerk',
      '<strong>Gebruik:</strong> Kozijnen, ramen, deuren, plinten'
    ],
    specsNote: null,
    reviews: [
      { name:'Tom B. — ZZP Schilder', stars:5,
        text:'"Altijd in combinatie met washi tape. Perfect formaat voor kozijnen."',
        date:'april 2025' },
      { name:'Annemiek L. — Particulier', stars:4,
        text:'"Stevig papier, beschermt goed. Eenvoudig te snijden."',
        date:'februari 2025' }
    ],
    crossSells: [
      { name:'Washi Tape 24mm × 50m',        img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png',       imgV:'1781333549', priceExcl:2.008, priceIncl:2.43,  link:'/collections/washi-tape',                              label:'24mm',   fullTitle:'MOOZERS® Washi Tape'    },
      { name:'Maskeerfolie 1500mm × 30m',    img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png',          imgV:'1781333455', priceExcl:4.12,  priceIncl:4.99,  link:'/collections/maskeerfolie',                            label:'1500mm', fullTitle:'MOOZERS® Maskeerfolie'  },
      { name:'Washi Tape 50mm × 50m',        img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_50mm_x_50m.png',       imgV:'1781333478', priceExcl:4.570, priceIncl:5.53,  link:'/collections/washi-tape',                              label:'50mm',   fullTitle:'MOOZERS® Washi Tape'    },
      { name:'Schuurpapier P100 · 50 stuks', img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49, link:'/products/moozers-apex-abrasives-p100-100x150mm',    label:'P100',   fullTitle:'MOOZERS® Schuurpapier'  }
    ]
  },


  // ── Joint Mesh Gaasband ─────────────────────────────
  'joint-mesh-gaasband': {
    id: 'joint-mesh-gaasband',
    brand: 'MOOZERS®',
    category: 'Gaasband',
    navLink: '/collections/gereedschap',
    reviewScore: 4.8,
    reviewCount: 143,
    variantLabel: 'Formaat',
    variantUnit: '',
    variantSuffix: '',
    defaultVariantIndex: 0,
    unit: 'rollen',
    noStaffel: true,
    variants: [
      { size:'50mm × 90m', label:'50mm × 90m',
        priceExcl:(MZ_JOINT_MESH_LIVE.priceExclCents ? MZ_JOINT_MESH_LIVE.priceExclCents / 100 : 6.45),
        priceIncl:(MZ_JOINT_MESH_LIVE.priceInclCents ? MZ_JOINT_MESH_LIVE.priceInclCents / 100 : 7.80),
        img:MZ_JOINT_MESH_STANDING,
        imgs:[MZ_JOINT_MESH_STANDING, MZ_JOINT_MESH_LIGGEND],
        title:'MOOZERS® Joint Mesh Gaasband - 50mm x 90m',
        shopifyHandle:'moozers®-joint-mesh-gaasband-50mm-x-90m',
        variantId:MZ_JOINT_MESH_LIVE.variantId || null,
        inStock:MZ_JOINT_MESH_LIVE.available !== false }
    ],
    descriptionHtml:
      '<p>Moozers Gaasband is vervaardigd uit sterke glasvezeldraden en ontwikkeld voor het wapenen van naden en scheuren in gipskarton- en gipsvezelplaten. De stevig geweven gaasstructuur heeft een hoge treksterkte en helpt spanningen over het oppervlak te verdelen. Hierdoor wordt de kans op scheurvorming in afgewerkte wanden en plafonds verkleind.</p>' +
      '<p>De band is geschikt voor professioneel gebruik bij nieuwbouw, renovatie en reparatiewerkzaamheden.</p>' +
      '<h3>Sterke zelfklevende laag</h3>' +
      '<p>De gaasband is voorzien van een watergedragen acrylaatbelijming. Hierdoor hecht de band goed op schone, droge en stofvrije ondergronden en blijft hij tijdens het afwerken stevig op zijn plaats.</p>' +
      '<p>Na het aanbrengen wordt de gaasband volledig bedekt met een geschikte voegenvuller, plamuur of pleister. De open structuur zorgt ervoor dat het afwerkmateriaal goed door en rondom het gaas wordt opgenomen.</p>' +
      '<h3>Geschikt voor naden, scheuren en stucwerk</h3>' +
      '<ul><li>Het wapenen van naden tussen gipskartonplaten</li><li>Het afwerken van naden tussen gipsvezelplaten</li><li>Het verstevigen van kleine scheuren in stabiel stucwerk</li><li>Reparaties aan wanden en plafonds</li><li>Het verdelen van spanning rondom herstelde naden en scheuren</li></ul>' +
      '<h3>Verwerking</h3>' +
      '<p>Breng de gaasband gecentreerd aan over een schone, droge en stofvrije naad of scheur. Druk de band goed aan en bedek hem vervolgens volledig met een geschikte voegenvuller, plamuur of pleister. Werk het oppervlak vlak af en laat het materiaal drogen volgens de voorschriften van het gebruikte afwerkproduct.</p>',
    usps: [
      'Sterke glasvezelstructuur met hoge treksterkte',
      'Zelfklevend en direct te verwerken',
      'Voor gipskarton, gipsvezelplaten en stabiel stucwerk'
    ],
    specs: [
      '<strong>Materiaal:</strong> sterke glasvezeldraden',
      '<strong>Breedte:</strong> 50 mm',
      '<strong>Lengte:</strong> 90 meter per rol',
      '<strong>Belijming:</strong> watergedragen acrylaat',
      '<strong>Structuur:</strong> open gaas voor goede opname van voegenvuller of pleister',
      '<strong>Toepassing:</strong> naden, scheuren en reparaties in wanden en plafonds',
      '<strong>Ondergronden:</strong> gipskarton, gipsvezelplaten en stabiel stucwerk'
    ],
    specsNote: 'Breng alleen aan op een schone, droge en stofvrije ondergrond en dek de gaasband volledig af met een geschikt afwerkmateriaal.',
    reviews: [],
    crossSells: [
      { name:'Schuurpapier P180 · 50 stuks', img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49, link:'/products/moozers-apex-abrasives-p180-100x150mm', label:'P180', fullTitle:'MOOZERS® Schuurpapier' },
      { name:'Schuurpad Dubbelzijdig P120', img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg', imgV:'1781377934', priceExcl:0.93, priceIncl:1.13, link:'/products/moozers-schuurpad-dubbelzijdig-p120', label:'P120', fullTitle:'MOOZERS® Schuurpad' }
    ]
  },

  // ── Schuurpad Dubbelzijdig ──────────────────────────
  // Staffelkorting: 2–3 stuks -2%, ≥4 stuks -5%
  'schuurpad': {
    id: 'schuurpad',
    brand: 'MOOZERS®',
    category: 'Schuurpads',
    navLink: 'https://www.moozers.nl/products/moozers-schuurpad-dubbelzijdig-p120',
    reviewScore: 4.7,
    reviewCount: 38,
    variantLabel: 'Korrel',
    variantUnit: '',
    variantSuffix: '',
    defaultVariantIndex: 0,
    unit: 'stuks',
    variants: [
      { size:'P120', label:'P120', priceExcl:0.93, priceIncl:1.13,
        img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg', imgV:'1781377934',
        title:'MOOZERS® Schuurpad Dubbelzijdig P120', inStock:true },
      { size:'P180', label:'P180', priceExcl:0.93, priceIncl:1.13,
        img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P180.jpg', imgV:'1781377907',
        title:'MOOZERS® Schuurpad Dubbelzijdig P180', inStock:true },
      { size:'P220', label:'P220', priceExcl:0.93, priceIncl:1.13,
        img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P220.jpg', imgV:'1781377885',
        title:'MOOZERS® Schuurpad Dubbelzijdig P220', inStock:true },
      { size:'P320', label:'P320', priceExcl:0.93, priceIncl:1.13,
        img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P320.jpg', imgV:'1781377844',
        title:'MOOZERS® Schuurpad Dubbelzijdig P320', inStock:true }
    ],
    staffelTiers: [
      { min:1, max:999, discount:0 }
    ],
    usps: [
      'Dubbelzijdig — beide kanten bruikbaar',
      'Werkdagen vóór 16:00 besteld = <strong>vandaag verzonden</strong>'
    ],
    specs: [
      '<strong>Type:</strong> Dubbelzijdig schuurpad',
      '<strong>Korrels:</strong> P120 / P180 / P220 / P320',
      '<strong>Afmeting:</strong> 140 × 100 mm',
      '<strong>Toepassing:</strong> hout, stucwerk, gips, polyester',
      '<strong>Dubbelzijdig:</strong> beide kanten voorzien van schuurmateriaal'
    ],
    specsNote: null,
    reviews: [
      { name:'Pieter K. — Stucadoor', stars:5,
        text:'"Goed schuurpad voor stuc. Beide kanten werken prima, goedkoop en duurzaam."',
        date:'mei 2025' },
      { name:'Yvonne M. — DIY', stars:4,
        text:'"Handig formaat en stevig. Slijt minder snel dan andere merken."',
        date:'maart 2025' }
    ],
    crossSells: [
      { name:'Schuurpapier P100 · 50 stuks', img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49, link:'/products/moozers-apex-abrasives-p100-100x150mm', label:'P100',   fullTitle:'MOOZERS® Schuurpapier'  },
      { name:'Washi Tape 24mm × 50m',        img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png',      imgV:'1781333549', priceExcl:2.008, priceIncl:2.43,  link:'/collections/washi-tape',                             label:'24mm',   fullTitle:'MOOZERS® Washi Tape'    },
      { name:'Maskeerfolie 1500mm × 30m',    img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png',         imgV:'1781333455', priceExcl:4.12,  priceIncl:4.99,  link:'/collections/maskeerfolie',                           label:'1500mm', fullTitle:'MOOZERS® Maskeerfolie'  },
      { name:'Maskeerpapier 300mm × 20m',    img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png',                                        imgV:'1781331618', priceExcl:3.71,  priceIncl:4.49,  link:'/collections/maskeerfolie',                           label:'300mm',  fullTitle:'MOOZERS® Maskeerpapier' }
    ]
  },

  // ── Schuurpapier Delta ──────────────────────────────
  // Staffelkorting: 2–3 dozen -2%, ≥4 dozen -5%
  'schuurpapier': {
    id: 'schuurpapier',
    brand: 'MOOZERS®',
    category: 'Schuurpapier',
    navLink: 'https://www.moozers.nl/collections/schuur-materialen',
    reviewScore: 4.8,
    reviewCount: 52,
    variantLabel: 'Korrel',
    variantUnit: '',
    variantSuffix: '',
    defaultVariantIndex: 1,
    unit: 'dozen',
    noStaffel: true,
    variants: [
      { size:'P80',  label:'P80 · 50 stuks',  priceExcl:11.98, priceIncl:14.49,
        img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914',
        title:'MOOZERS® Apex Abrasives P80 · 100×150mm · 50 stuks',  inStock:true  },
      { size:'P100', label:'P100 · 50 stuks', priceExcl:11.98, priceIncl:14.49,
        img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914',
        title:'MOOZERS® Apex Abrasives P100 · 100×150mm · 50 stuks', inStock:true  },
      { size:'P120', label:'P120 · 50 stuks', priceExcl:11.98, priceIncl:14.49,
        img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914',
        title:'MOOZERS® Apex Abrasives P120 · 100×150mm · 50 stuks', inStock:false },
      { size:'P150', label:'P150 · 50 stuks', priceExcl:11.98, priceIncl:14.49,
        img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914',
        title:'MOOZERS® Apex Abrasives P150 · 100×150mm · 50 stuks', inStock:false },
      { size:'P180', label:'P180 · 50 stuks', priceExcl:11.98, priceIncl:14.49,
        img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914',
        title:'MOOZERS® Apex Abrasives P180 · 100×150mm · 50 stuks', inStock:false },
      { size:'P220', label:'P220 · 50 stuks', priceExcl:11.98, priceIncl:14.49,
        img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914',
        title:'MOOZERS® Apex Abrasives P220 · 100×150mm · 50 stuks', inStock:true  },
      { size:'P240', label:'P240 · 50 stuks', priceExcl:11.98, priceIncl:14.49,
        img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914',
        title:'MOOZERS® Apex Abrasives P240 · 100×150mm · 50 stuks', inStock:true  }
    ],
    staffelTiers: [
      { min:1, max:1,   discount:0    },
      { min:2, max:3,   discount:0.02 },
      { min:4, max:999, discount:0.05 }
    ],
    usps: [
      'Professioneel resultaat op hout en verf',
      'Werkdagen vóór 16:00 besteld = <strong>vandaag verzonden</strong>'
    ],
    specs: [
      '<strong>Type:</strong> Delta schuurpapier (100×150mm)',
      '<strong>Korrels:</strong> P80 / P100 / P120 / P150 / P180 / P220 / P240',
      '<strong>Inhoud:</strong> 50 vellen per doos',
      '<strong>Geschikt voor:</strong> delta-schuurmachines',
      '<strong>Toepassing:</strong> hout, verf, plamuur, stucwerk'
    ],
    specsNote: null,
    reviews: [
      { name:'Robin D. — Schilder', stars:5,
        text:'"Goede kwaliteit voor de prijs. Haalt prima verf en plamuur weg. Bestel per doos voor de beste prijs."',
        date:'april 2025' },
      { name:'Fleur K. — Particulier', stars:4,
        text:'"Fijn formaat voor mijn delta schuurmachine. Goed resultaat op hout."',
        date:'februari 2025' }
    ],
    crossSells: [
      { name:'Schuurpad Dubbelzijdig P120',   img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg',                                          imgV:'1781377934', priceExcl:0.93,  priceIncl:1.13,  link:'/products/moozers-schuurpad-dubbelzijdig-p120',       label:'P120',   fullTitle:'MOOZERS® Schuurpad'     },
      { name:'Washi Tape 24mm × 50m',        img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png',            imgV:'1781333549', priceExcl:2.008, priceIncl:2.43,  link:'/collections/washi-tape',                              label:'24mm',   fullTitle:'MOOZERS® Washi Tape'    },
      { name:'Maskeerfolie 1500mm × 30m',    img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png',               imgV:'1781333455', priceExcl:4.12,  priceIncl:4.99,  link:'/collections/maskeerfolie',                            label:'1500mm', fullTitle:'MOOZERS® Maskeerfolie'  },
      { name:'Maskeerpapier 300mm × 20m',    img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png',                                              imgV:'1781331618', priceExcl:3.71,  priceIncl:4.49,  link:'/collections/maskeerfolie',                            label:'300mm',  fullTitle:'MOOZERS® Maskeerpapier' }
    ]
  }

  ,

  // ── Schuurschijf Rond 150mm ──────────────────────────────
  // Alleen actieve Shopify-producten tonen; lage voorraad = zichtbaar maar niet actief pushen.
  'schuurschijf': {
    id: 'schuurschijf',
    brand: 'MOOZERS®',
    category: 'Schuurschijven',
    navLink: 'https://www.moozers.nl/collections/schuur-materialen',
    reviewScore: 4.7,
    reviewCount: 18,
    variantLabel: 'Korrel',
    variantUnit: '',
    variantSuffix: '',
    defaultVariantIndex: 1,
    unit: 'dozen',
    noStaffel: true,
    variants: [
      { size:'P600', label:'P600 · 100 stuks', priceExcl:24.79, priceIncl:29.99,
        img:'schuurschijf_a086baaa-626f-4143-a9d9-eeb4c1c26d45.png', imgV:'1756201546',
        title:'MOOZERS® Apex Abrasives Schuurschijf 150mm P600 · 100 stuks', inStock:true },
      { size:'P800', label:'P800 · 100 stuks', priceExcl:24.79, priceIncl:29.99,
        img:'schuurschijf_a086baaa-626f-4143-a9d9-eeb4c1c26d45.png', imgV:'1756201546',
        title:'MOOZERS® Apex Abrasives Schuurschijf 150mm P800 · 100 stuks', inStock:true },
      { size:'P1200', label:'P1200 · 100 stuks', priceExcl:24.79, priceIncl:29.99,
        img:'schuurschijf_a086baaa-626f-4143-a9d9-eeb4c1c26d45.png', imgV:'1756201546',
        title:'MOOZERS® Apex Abrasives Schuurschijf 150mm P1200 · 100 stuks', inStock:false },
      { size:'P3000', label:'P3000 · 100 stuks', priceExcl:24.79, priceIncl:29.99,
        img:'schuurschijf_a086baaa-626f-4143-a9d9-eeb4c1c26d45.png', imgV:'1756201546',
        title:'MOOZERS® Apex Abrasives Schuurschijf 150mm P3000 · 100 stuks', inStock:true }
    ],
    usps: [
      'Ronde 150mm schuurschijven voor professioneel fijnschuurwerk',
      'Werkdagen vóór 16:00 besteld = <strong>vandaag verzonden</strong>'
    ],
    specs: [
      '<strong>Type:</strong> ronde schuurschijf',
      '<strong>Diameter:</strong> 150mm',
      '<strong>Korrels:</strong> P600 / P800 / P1200 / P3000',
      '<strong>Inhoud:</strong> 100 stuks per doos',
      '<strong>Toepassing:</strong> fijnschuren en afwerken van lak, verf en ondergronden'
    ],
    specsNote: 'Let op: enkele korrels hebben beperkte voorraad. Niet actief promoten zonder voorraadcheck.',
    reviews: [
      { name:'Jeroen V. — Autoschadeherstel', stars:5,
        text:'"Fijne schijven voor strak afwerken. Vooral de fijne korrels geven een mooi egaal resultaat."',
        date:'mei 2025' },
      { name:'Marco B. — Schilder', stars:4,
        text:'"Handig voor fijner schuurwerk en lakvoorbereiding. Goede prijs per 100 stuks."',
        date:'april 2025' }
    ],
    crossSells: [
      { name:'Schuurpapier P220 · 50 stuks', img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49, link:'/products/moozers-apex-abrasives-p220-100x150mm', label:'P220', fullTitle:'MOOZERS® Schuurpapier' },
      { name:'Schuurpad Dubbelzijdig P120', img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg', imgV:'1781377934', priceExcl:0.93, priceIncl:1.13, link:'/products/moozers-schuurpad-dubbelzijdig-p120', label:'P120', fullTitle:'MOOZERS® Schuurpad' },
      { name:'Washi Tape 24mm × 50m', img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781333549', priceExcl:2.008, priceIncl:2.43, link:'/collections/washi-tape', label:'24mm', fullTitle:'MOOZERS® Washi Tape' }
    ]
  },


  // ── Dozen Schilderstape ─────────────────────────────
  // Geel: 19/24/36/50mm × 36r/72r (50mm: 24r/54r)
  // Paars: 24/36mm × 36r/72r
  // Prijzen incl. BTW geverifieerd via Shopify Admin
  'dozen-tape': {
    id: 'dozen-tape',
    variantType: 'dozen',
    brand: 'MOOZERS®',
    category: 'Dozen Schilderstape',
    navLink: 'https://www.moozers.nl/collections/dozen-washi-tape',
    reviewScore: 4.8,
    reviewCount: 143,
    variantLabel: 'Samenstelling',
    variantUnit: '',
    variantSuffix: '',
    defaultVariantIndex: 2,
    unit: 'dozen',
    variants: [
      // ── Geel 19mm ──
      { kleur:'Geel', breedte:'19', inhoud:36,
        size:'Geel 19mm 36r', label:'Geel · 19mm · 36 rollen',
        priceExcl:53.39, priceIncl:64.60,
        img:'DOOS_MOOZERS_-_36_Rollen_-_Washi_-_Schilderstape_geel_-_19mm_x_50m.png', imgV:'1781077379',
        title:'DOOS MOOZERS® Washi Tape Geel 19mm × 36 rollen', inStock:true },
      { kleur:'Geel', breedte:'19', inhoud:72,
        size:'Geel 19mm 72r', label:'Geel · 19mm · 72 rollen',
        priceExcl:99.07, priceIncl:119.88,
        img:'DOOS_MOOZERS_-_72_Rollen_-_Washi_-_Schilderstape_geel_-_19mm_x_50m.png', imgV:'1781332411',
        title:'DOOS MOOZERS® Washi Tape Geel 19mm × 72 rollen', inStock:true },
      // ── Geel 24mm ──
      { kleur:'Geel', breedte:'24', inhoud:36,
        size:'Geel 24mm 36r', label:'Geel · 24mm · 36 rollen',
        priceExcl:70.13, priceIncl:84.86,
        img:'DOOS_MOOZERS_-_36_Rollen_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781332823',
        title:'DOOS MOOZERS® Washi Tape Geel 24mm × 36 rollen', inStock:true },
      { kleur:'Geel', breedte:'24', inhoud:72,
        size:'Geel 24mm 72r', label:'Geel · 24mm · 72 rollen',
        priceExcl:130.13, priceIncl:157.46,
        img:'DOOS_MOOZERS_-_72_Rollen_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781332795',
        title:'DOOS MOOZERS® Washi Tape Geel 24mm × 72 rollen', inStock:true },
      // ── Geel 36mm ──
      { kleur:'Geel', breedte:'36', inhoud:36,
        size:'Geel 36mm 36r', label:'Geel · 36mm · 36 rollen',
        priceExcl:103.02, priceIncl:124.66,
        img:'DOOSMOOZERS_-36Rollen-Washi-Schilderstapegeel-36mmx50m.png', imgV:'1781333395',
        title:'DOOS MOOZERS® Washi Tape Geel 36mm × 36 rollen', inStock:false },
      { kleur:'Geel', breedte:'36', inhoud:72,
        size:'Geel 36mm 72r', label:'Geel · 36mm · 72 rollen',
        priceExcl:191.19, priceIncl:231.34,
        img:'DOOS_MOOZERS_-_72_Rollen_-_Washi_-_Schilderstape_geel_-_36mm_x_50m.png', imgV:'1781332844',
        title:'DOOS MOOZERS® Washi Tape Geel 36mm × 72 rollen', inStock:false },
      // ── Geel 50mm ──
      { kleur:'Geel', breedte:'50', inhoud:24,
        size:'Geel 50mm 24r', label:'Geel · 50mm · 24 rollen',
        priceExcl:106.40, priceIncl:128.74,
        img:'DOOS_MOOZERS_-_24_Rollen_-_Washi_-_Schilderstape_geel_-_50mm_x_50m.png', imgV:'1781332353',
        title:'DOOS MOOZERS® Washi Tape Geel 50mm × 24 rollen', inStock:false },
      { kleur:'Geel', breedte:'50', inhoud:54,
        size:'Geel 50mm 54r', label:'Geel · 50mm · 54 rollen',
        priceExcl:229.52, priceIncl:277.72,
        img:'DOOS_MOOZERS_-_24_Rollen_-_Washi_-_Schilderstape_geel_-_50mm_x_50m.png', imgV:'1781332353',
        title:'DOOS MOOZERS® Washi Tape Geel 50mm × 54 rollen', inStock:true },
      // ── Paars 24mm ──
      { kleur:'Paars', breedte:'24', inhoud:36,
        size:'Paars 24mm 36r', label:'Paars · 24mm · 36 rollen',
        priceExcl:76.77, priceIncl:92.89,
        img:'DOOSMOOZERS_-36Rollen-Washi-Schilderstapepaars-24mmx50m.png', imgV:'1781076964',
        title:'DOOS MOOZERS® Washi Tape Paars 24mm × 36 rollen', inStock:true },
      { kleur:'Paars', breedte:'24', inhoud:72,
        size:'Paars 24mm 72r', label:'Paars · 24mm · 72 rollen',
        priceExcl:142.45, priceIncl:172.37,
        img:'DOOS_MOOZERS_72_Rollen_Washi_Schilderstape_paars_24mm_x_50m.png', imgV:'1781331965',
        title:'DOOS MOOZERS® Washi Tape Paars 24mm × 72 rollen', inStock:true },
      // ── Paars 36mm ──
      { kleur:'Paars', breedte:'36', inhoud:36,
        size:'Paars 36mm 36r', label:'Paars · 36mm · 36 rollen',
        priceExcl:101.30, priceIncl:122.57,
        img:'DOOS_MOOZERS_36_Rollen_Washi_Paars_Schilderstape_36mm_x_50m.png', imgV:'1781332121',
        title:'DOOS MOOZERS® Washi Tape Paars 36mm × 36 rollen',
        shopifyHandle:'doos-moozers-washi-tape-paars-36mm-36rollen', inStock:false },
      { kleur:'Paars', breedte:'36', inhoud:72,
        size:'Paars 36mm 72r', label:'Paars · 36mm · 72 rollen',
        priceExcl:187.98, priceIncl:227.45,
        img:'DOOS_MOOZERS_72_Rollen_Washi_Schilderstape_paars_36mm_x_50m.png', imgV:'1781332063',
        title:'DOOS MOOZERS® Washi Tape Paars 36mm × 72 rollen',
        shopifyHandle:'doos-moozers-washi-tape-paars-36mm-72rollen', inStock:false }
    ],
    staffelTiers: [
      { min:1, max:999, discount:0 }
    ],
    usps: [
      'Bulk voordeel — al geprijsd als volumebestelling',
      'Werkdagen vóór 16:00 besteld = <strong>vandaag verzonden</strong>'
    ],
    specs: [
      '<strong>Kleuren:</strong> Geel, Paars',
      '<strong>Breedtes:</strong> 19 / 24 / 36 / 50 mm',
      '<strong>Inhoud:</strong> 24 t/m 72 rollen per doos · 50m per rol',
      '<strong>Geen lijmresten:</strong> ook na 14 dagen plakken',
      '<strong>UV-bestendig:</strong> tot 14 dagen buiten',
      '<strong>Geschikt voor:</strong> hout, glas en stucwerk'
    ],
    specsNote: null,
    reviews: [
      { name:'Kees V. — Schilder ZZP', stars:5,
        text:'"Altijd een doos van 72 rollen 24mm geel in de bus. Nooit meer uitverkopen, mooi geprijsd en snel geleverd."',
        date:'mei 2025' },
      { name:'Tim O. — Schildersbedrijf', stars:5,
        text:'"Bestel dozen voor het hele team. Levering de volgende dag. Kwaliteit altijd consistent."',
        date:'april 2025' }
    ],
    crossSells: [
      { name:'Maskeerfolie 1500mm × 30m',    img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png', imgV:'1781333455', priceExcl:4.12,  priceIncl:4.99,  link:'/collections/maskeerfolie',                             label:'1500mm', fullTitle:'MOOZERS® Maskeerfolie'  },
      { name:'Maskeerpapier 300mm × 20m',    img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png',                                imgV:'1781331618', priceExcl:3.71,  priceIncl:4.49,  link:'/collections/maskeerfolie',                             label:'300mm',  fullTitle:'MOOZERS® Maskeerpapier' },
      { name:'Schuurpapier P100 · 50 stuks', img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49, link:'/products/moozers-apex-abrasives-p100-100x150mm', label:'P100', fullTitle:'MOOZERS® Schuurpapier' },
      { name:'Schuurpad Dubbelzijdig P120',  img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg',                            imgV:'1781377934', priceExcl:0.93,  priceIncl:1.13,  link:'/products/moozers-schuurpad-dubbelzijdig-p120',       label:'P120',   fullTitle:'MOOZERS® Schuurpad'     }
    ]
  },

  // ── Gereedschap: Glasschraper ───────────────────────
  'glasschraper': {
    id: 'glasschraper',
    brand: 'MOOZERS®',
    category: 'Gereedschap',
    navLink: '/collections/gereedschap',
    reviewScore: 4.8,
    reviewCount: 143,
    variantLabel: 'Variant',
    variantUnit: '',
    variantSuffix: '',
    defaultVariantIndex: 0,
    unit: 'stuks',
    variants: [
      { size:'Standaard', label:'Standaard', priceExcl:3.512, priceIncl:4.25,
        img:'glasschraperrrrr_d60d8760-1c4f-42fa-bdc0-18c42b93a386.png', imgV:'1756201398',
        title:'MOOZERS® Glasschraper', inStock:true }
    ],
    staffelTiers: [
      { min:1, max:999, discount:0 }
    ],
    usps: [
      'Handig voor glas, kookplaten en hardnekkige resten',
      'Vervangbaar mesje en stevige metalen uitvoering'
    ],
    specs: [
      '<strong>Product:</strong> glasschraper / verfschraper',
      '<strong>Toepassing:</strong> glas, keramische kookplaten, stickers, verf- en lijmresten',
      '<strong>Materiaal:</strong> stevige metalen schraper met vervangbaar mesje',
      '<strong>Gebruik:</strong> voorzichtig onder een vlakke hoek gebruiken'
    ],
    specsNote: '*Gebruik altijd voorzichtig en test eerst op een onopvallende plek.',
    reviews: [
      { name:'MOOZERS klant', stars:5,
        text:'"Handig gereedschap voor het verwijderen van hardnekkige resten."',
        date:'mei 2025' }
    ],
    crossSells: [
      { name:'Washi Tape Geel 24mm × 50m',  img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781333549', priceExcl:2.008, priceIncl:2.43,  link:'/products/moozers-washi-tape-geel-24mm', label:'24mm', fullTitle:'MOOZERS® Washi Tape' },
      { name:'Maskeerpapier 300mm × 20m',    img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png', imgV:'1781331618', priceExcl:3.71, priceIncl:4.49, link:'/products/moozers-maskeerpapier-300mm-x-20m', label:'300mm', fullTitle:'MOOZERS® Maskeerpapier' }
    ]
  },


  'apex-mesh-rond': {
    id: 'apex-mesh-rond',
    brand: 'MOOZERS®',
    category: 'Schuurgaas',
    navLink: '/collections/apex-mesh',
    reviewScore: 4.8,
    reviewCount: 143,
    noStaffel: true,
    variantType: 'mesh-rond',
    defaultVariantIndex: 0,
    variantLabel: 'Maat',
    unit: 'stuks',
    desc: 'MOOZERS® Apex Mesh schuurgaas 125mm en 150mm is geschikt voor professioneel gebruik in gipswerk, stucwerk en hout. Het open gaasontwerp voorkomt verstoppingen en zorgt voor een lange levensduur. Leverbaar in 125mm en 150mm, vijf korrels. Verpakt per 50 stuks.',
    usps: [
      '50 stuks per verpakking',
      'Anti-verstopping door open gaasstructuur',
      'Geschikt voor gips, stucwerk en hout',
      'Geschikt voor excentrische schuurmachines (ø125mm / ø150mm)' // v11: gecorrigeerd van 'driehoekige'
    ],
    specs: [
      '<strong>Type:</strong> Apex Mesh schuurgaas',
      '<strong>Maten:</strong> 150mm en 125mm',
      '<strong>Korrels:</strong> P150 · P180 · P220 · P240 · P320',
      '<strong>Inhoud:</strong> 50 stuks per verpakking',
      '<strong>Gebruik:</strong> Gips, stucwerk, hout – excentrische schuurmachines' // v11: gecorrigeerd
    ],
    reviews: [
      { name:'MOOZERS klant', stars:5,
        text:'"Prima schuurgaas voor gipskarton. Verstopping nagenoeg nul."',
        date:'juni 2026' }
    ],
    crossSells: [
      { name:'Delta Schuurpapier 50 stuks',  img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49, link:'/products/moozers-apex-abrasives-p80-100x150mm', label:'P80', fullTitle:'MOOZERS® Schuurpapier' },
      { name:'Schuurpad Dubbelzijdig P120',   img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg', imgV:'1781377934', priceExcl:0.93, priceIncl:1.13, link:'/products/moozers-schuurpad-dubbelzijdig-p120', label:'P120', fullTitle:'MOOZERS® Schuurpad' }
    ],
    variants: [
      // ── 150mm (Shopify €29,02 incl. BTW / €23,98 excl. BTW) ───────────────────
      { maat:'150mm', korrel:'P150', size:'150mm', label:'P150',
        title:'MOOZERS® - Apex Mesh- P150 - 150MM - Schuurgaas - 50 stuks',
        priceExcl:23.98, priceIncl:29.02, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p150-150mm-schuurgaas-50-stuks',
        variantId:'54146767061325', sku:'2026150MR150' },
      { maat:'150mm', korrel:'P180', size:'150mm', label:'P180',
        title:'MOOZERS® - Apex Mesh- P180 - 150MM - Schuurgaas - 50 stuks',
        priceExcl:23.98, priceIncl:29.02, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p180-150mm-schuurgaas-50-stuks',
        variantId:'54146770108749', sku:'2026150MR180' },
      { maat:'150mm', korrel:'P220', size:'150mm', label:'P220',
        title:'MOOZERS® - Apex Mesh- P220 - 150MM - Schuurgaas - 50 stuks',
        priceExcl:23.98, priceIncl:29.02, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p220-150mm-schuurgaas-50-stuks-kopie',
        variantId:'54146826535245', sku:'2026150MR220' },
      { maat:'150mm', korrel:'P240', size:'150mm', label:'P240',
        title:'MOOZERS® - Apex Mesh- P240 - 150MM - Schuurgaas - 50 stuks',
        priceExcl:23.98, priceIncl:29.02, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p240-150mm-schuurgaas-50-stuks-kopie-kopie',
        variantId:'54146827092301', sku:'2026150MR240' },
      { maat:'150mm', korrel:'P320', size:'150mm', label:'P320',
        title:'MOOZERS® - Apex Mesh- P320 - 150MM - Schuurgaas - 50 stuks',
        priceExcl:23.98, priceIncl:29.02, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p320-150mm-schuurgaas-50-stuks-kopie-kopie-kopie',
        variantId:'54146903474509', sku:'2026150MR320' },
      // ── 125mm (Shopify €22,98 incl. BTW / €18,99 excl. BTW) ───────────────────
      { maat:'125mm', korrel:'P150', size:'125mm', label:'P150',
        title:'MOOZERS® - Apex Mesh- P150 - 125MM - Schuurgaas - 50 stuks',
        priceExcl:18.99, priceIncl:22.98, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p150-125mm-schuurgaas-50-stuks',
        variantId:'54146913468749', sku:'2026125MR150' },
      { maat:'125mm', korrel:'P180', size:'125mm', label:'P180',
        title:'MOOZERS® - Apex Mesh- P180 - 125MM - Schuurgaas - 50 stuks',
        priceExcl:18.99, priceIncl:22.98, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p180-125mm-schuurgaas-50-stuks',
        variantId:'54146920972621', sku:'2026125MR180' },
      { maat:'125mm', korrel:'P220', size:'125mm', label:'P220',
        title:'MOOZERS® - Apex Mesh- P220 - 125MM - Schuurgaas - 50 stuks',
        priceExcl:18.99, priceIncl:22.98, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p220-125mm-schuurgaas-50-stuks',
        variantId:'54146923594061', sku:'2026125MR220' },
      { maat:'125mm', korrel:'P240', size:'125mm', label:'P240',
        title:'MOOZERS® - Apex Mesh- P240 - 125MM - Schuurgaas - 50 stuks',
        priceExcl:18.99, priceIncl:22.98, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p240-125mm-schuurgaas-50-stuks',
        variantId:'54146924577101', sku:'2026125MR240' },
      { maat:'125mm', korrel:'P320', size:'125mm', label:'P320',
        title:'MOOZERS® - Apex Mesh- P320 - 125MM - Schuurgaas - 50 stuks',
        priceExcl:18.99, priceIncl:22.98, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_1.png', imgV:'1782133797',
        shopifyHandle:'moozers®-apex-mesh-p320-125mm-schuurgaas-50-stuks',
        variantId:'54146924872013', sku:'2026125MR320' }
    ]
  },


  'apex-mesh-80x133': {
    id: 'apex-mesh-80x133', brand: 'MOOZERS®', category: 'Schuurgaas',
    navLink: '/collections/apex-mesh',
    reviewScore: 4.8, reviewCount: 143,
    noStaffel: true,
    variantType: 'mesh-vierkant',
    defaultVariantIndex: 0, variantLabel: 'Korrel', unit: 'stuks',
    desc: 'MOOZERS® Apex Mesh schuurgaas 80×133mm is geschikt voor deltaschuriers en handschuurvlakken. Het open gaasontwerp voorkomt verstoppingen en zorgt voor een lange levensduur. Verpakt per 50 stuks.',
    usps: [
      '50 stuks per verpakking',
      'Anti-verstopping door open gaasstructuur',
      'Geschikt voor deltaschuurmachines',
      'Maat 80×133mm voor vlakke oppervlakken'
    ],
    specs: [
      '<strong>Type:</strong> Apex Mesh schuurgaas – rechthoekig',
      '<strong>Maat:</strong> 80×133mm',
      '<strong>Korrels:</strong> P150 · P180 · P220 · P240 · P320',
      '<strong>Inhoud:</strong> 50 stuks per verpakking',
      '<strong>Gebruik:</strong> Gips, stucwerk, hout, deltaschuurmachines'
    ],
    reviews: [
      { name:'MOOZERS klant', stars:5,
        text:'"Prima schuurgaas voor delta-schuurmachine. Verstopping nagenoeg nul."',
        date:'juni 2026' }
    ],
    crossSells: [
      { name:'Delta Schuurpapier 50 stuks',  img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49, link:'/products/moozers-apex-abrasives-p80-100x150mm', label:'P80', fullTitle:'MOOZERS® Schuurpapier' },
      { name:'Schuurpad Dubbelzijdig P120',   img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg', imgV:'1781377934', priceExcl:0.93, priceIncl:1.13, link:'/products/moozers-schuurpad-dubbelzijdig-p120', label:'P120', fullTitle:'MOOZERS® Schuurpad' }
    ],
    variants: [
      { maat:'80×133mm', korrel:'P150', size:'80×133mm', label:'P150',
        title:'MOOZERS® - Apex Mesh- P150 - 80x133MM - Schuurgaas - 50 stuks',
        priceExcl:15.98, priceIncl:19.34, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_3_128f3bdb-fe7c-4fc6-b4da-733fee121b3d.png', imgV:'1782139512',
        shopifyHandle:'moozers®-apex-mesh-p150-80x133mm-schuurgaas-50-stuks',
        variantId:'54146927853901', sku:'2026MV150' },
      { maat:'80×133mm', korrel:'P180', size:'80×133mm', label:'P180',
        title:'MOOZERS® - Apex Mesh- P180 - 80x133MM - Schuurgaas - 50 stuks',
        priceExcl:15.98, priceIncl:19.34, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_3.png', imgV:'1782139491',
        shopifyHandle:'moozers®-apex-mesh-p180-80x133mm-schuurgaas-50-stuks',
        variantId:'54147040051533', sku:'2026MV180' },
      { maat:'80×133mm', korrel:'P220', size:'80×133mm', label:'P220',
        title:'MOOZERS® - Apex Mesh- P220 - 80x133MM - Schuurgaas - 50 stuks',
        priceExcl:15.98, priceIncl:19.34, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_3.png', imgV:'1782139491',
        shopifyHandle:'moozers®-apex-mesh-p220-80x133mm-schuurgaas-50-stuks',
        variantId:'54147052732749', sku:'2026MV220' },
      { maat:'80×133mm', korrel:'P240', size:'80×133mm', label:'P240',
        title:'MOOZERS® - Apex Mesh- P240 - 80x133MM - Schuurgaas - 50 stuks',
        priceExcl:15.98, priceIncl:19.34, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_3.png', imgV:'1782139491',
        shopifyHandle:'moozers®-apex-mesh-p240-80x133mm-schuurgaas-50-stuks',
        variantId:'54147056533837', sku:'2026MV240' },
      { maat:'80×133mm', korrel:'P320', size:'80×133mm', label:'P320',
        title:'MOOZERS® - Apex Mesh- P320 - 80x133MM - Schuurgaas - 50 stuks',
        priceExcl:15.98, priceIncl:19.34, inStock:false,
        img:'ChatGPTImage22jun2026_15_09_32_3.png', imgV:'1782139491',
        shopifyHandle:'moozers®-apex-mesh-p320-80x133mm-schuurgaas-50-stuks',
        variantId:'54147057353037', sku:'2026MV320' }
    ]
  }

}; // end CATALOG

// v75: voorraad wordt niet meer statisch geblokkeerd in de prototypecatalogus.
// Shopify checkout blijft de echte voorraadbron; zo voorkomen we foutieve 'uitverkocht'-meldingen
// wanneer de voorraad in Shopify alweer is aangevuld.
try {
  Object.keys(CATALOG || {}).forEach(function(pid) {
    var product = CATALOG[pid];
    if (!product || !Array.isArray(product.variants)) return;
    product.variants.forEach(function(v) {
      // v87: inStock-override verwijderd — Shopify-status mag false zijn voor uitverkochte varianten
    });
  });
} catch(e) {}


// ════════════════════════════════════════════════════════
//  STATE
// ════════════════════════════════════════════════════════
var currentProduct = null;
var cart = [];
var cv   = null; // current variant
var qty  = 1;

// Bewaar de visuele Moozers-winkelwagen binnen hetzelfde browsertabblad.
// De Shopify-checkout is een aparte pagina; zonder deze opslag gaat de in-memory
// `cart` verloren bij een volledige reload of terugnavigatie vanuit checkout.
var MZ_CART_SESSION_KEY = 'moozers_visual_cart_v1';
var MZ_CHECKOUT_RETURN_KEY = 'moozers_checkout_departed_v1';
var MZ_CART_BROWSER_SESSION_COOKIE = 'moozers_cart_browser_session_v1';
var mzFreshBrowserCartSession = false;
var mzBrowserCartSessionReady = Promise.resolve();

// Een sessiecookie heeft bewust geen Expires/Max-Age. Daardoor blijft de cart
// behouden bij navigeren, refreshen, checkout en meerdere tabs binnen dezelfde
// browsersessie, maar wordt de sessie bij een normale volledige browsersluiting
// beëindigd. Bij de eerstvolgende start wissen we ook de echte Shopify-cart.
function mzHasBrowserCartSession() {
  try {
    var prefix = MZ_CART_BROWSER_SESSION_COOKIE + '=';
    return String(document.cookie || '').split(';').some(function(part) {
      return part.trim().indexOf(prefix) === 0;
    });
  } catch(e) {
    return false;
  }
}

function mzSetBrowserCartSession() {
  try {
    var cookie = MZ_CART_BROWSER_SESSION_COOKIE + '=1; Path=/; SameSite=Lax';
    if (window.location && window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  } catch(e) {}
}

function mzCartStorageItem(item) {
  if (!item) return null;
  var out = {};
  [
    'title','label','img','imgV','imageUrl','basePriceExcl','basePriceIncl','priceExcl','priceIncl',
    'qty','emoji','productId','variantSize','shopifyHandle','staffelTiers','tierGroupKey',
    '_mzVariantId','_lineInclCents','_lineExclCents','_lineTaxCents'
  ].forEach(function(key) {
    if (item[key] !== undefined) out[key] = item[key];
  });
  out.qty = Math.max(1, Math.min(999, parseInt(out.qty, 10) || 1));
  return out;
}

function mzPersistCartState() {
  try {
    var items = Array.isArray(cart) ? cart.map(mzCartStorageItem).filter(Boolean) : [];
    sessionStorage.setItem(MZ_CART_SESSION_KEY, JSON.stringify({ version: 1, items: items }));
  } catch(e) {}
}

function mzRestoreCartState() {
  try {
    var raw = sessionStorage.getItem(MZ_CART_SESSION_KEY);
    if (!raw) return false;
    var data = JSON.parse(raw);
    if (!data || data.version !== 1 || !Array.isArray(data.items)) return false;
    cart = data.items.slice(0, 100).map(function(item) {
      item.qty = Math.max(1, Math.min(999, parseInt(item.qty, 10) || 1));
      return item;
    });
    return cart.length > 0;
  } catch(e) {
    return false;
  }
}

function mzFilenameFromShopifyImage(src) {
  var value = String(src || '');
  var match = value.match(/\/files\/([^?]+)/i);
  if (!match || !match[1]) return '';
  try { return decodeURIComponent(match[1]); } catch(e) { return match[1]; }
}

function mzShopifyLineImageUrl(line) {
  if (!line) return '';
  var source = line.image || line.featured_image || '';
  if (source && typeof source === 'object') {
    source = source.url || source.src || source.original_src || '';
  }
  source = String(source || '').trim();
  if (source.indexOf('//') === 0) source = 'https:' + source;
  return /^https?:\/\//i.test(source) ? source : '';
}

function mzCartItemImageUrl(item) {
  if (!item) return '';
  var direct = String(item.imageUrl || '').trim();
  if (direct.indexOf('//') === 0) direct = 'https:' + direct;
  if (/^https?:\/\//i.test(direct) || direct.charAt(0) === '/') return direct;
  var raw = String(item.img || '').trim();
  if (!raw) return '';
  if (raw.indexOf('//') === 0) raw = 'https:' + raw;
  if (/^https?:\/\//i.test(raw) || raw.charAt(0) === '/') return raw;
  var url = IMG_BASE + raw;
  if (item.imgV) url += (url.indexOf('?') > -1 ? '&' : '?') + 'v=' + encodeURIComponent(item.imgV);
  return url;
}

function mzHydrateCartFromShopify(realCart) {
  if (!realCart || !Array.isArray(realCart.items) || !realCart.items.length) return false;
  cart = realCart.items.map(function(line) {
    var quantity = Math.max(1, parseInt(line.quantity, 10) || 1);
    var lineInclCents = Math.max(0, parseInt(
      line.final_line_price != null ? line.final_line_price : line.line_price,
      10
    ) || 0);
    var unitInclCents = Math.max(0, parseInt(
      line.final_price != null ? line.final_price : (line.original_price != null ? line.original_price : Math.round(lineInclCents / quantity)),
      10
    ) || 0);
    var unitIncl = unitInclCents / 100;
    var properties = line.properties || {};
    var imageUrl = mzShopifyLineImageUrl(line);
    return {
      title: line.product_title || line.title || 'Product',
      label: line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '',
      img: mzFilenameFromShopifyImage(imageUrl),
      imgV: '',
      imageUrl: imageUrl,
      basePriceIncl: unitIncl,
      basePriceExcl: mzExclFloatFromInclFloat(unitIncl),
      priceIncl: unitIncl,
      priceExcl: mzExclFloatFromInclFloat(unitIncl),
      qty: quantity,
      emoji: null,
      productId: null,
      variantSize: line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '',
      shopifyHandle: line.handle || properties['_shopify_handle_source'] || '',
      tierGroupKey: line.handle || properties['_shopify_handle_source'] || String(line.variant_id || ''),
      _mzVariantId: line.variant_id ? String(line.variant_id) : null,
      _lineInclCents: lineInclCents,
      _lineExclCents: mzInclToExclCents(lineInclCents),
      _lineTaxCents: lineInclCents - mzInclToExclCents(lineInclCents)
    };
  });
  mzPersistCartState();
  return cart.length > 0;
}

// Start iedere normale browserstart met een lege cart. Binnen dezelfde
// browsersessie blijft de cart wel behouden via sessionStorage en Shopify.
// De echte Shopify-cart wordt bij een nieuwe browsersessie direct gewist, zodat
// een oude Shopify-cookie de cart niet opnieuw kan vullen.
if (mzHasBrowserCartSession()) {
  mzRestoreCartState();
} else {
  mzFreshBrowserCartSession = true;
  mzSetBrowserCartSession();
  try {
    sessionStorage.removeItem(MZ_CART_SESSION_KEY);
    sessionStorage.removeItem(MZ_CHECKOUT_RETURN_KEY);
  } catch(e) {}
  cart = [];
  mzPersistCartState();
  mzBrowserCartSessionReady = fetch('/cart/clear.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' }
  }).then(function(res) {
    if (!res.ok) throw new Error('Shopify-cart kon bij een nieuwe browsersessie niet worden gewist.');
    return res.json();
  }).catch(function(err) {
    // Houd de zichtbare cart leeg. Een latere cart-sync wacht op deze Promise en
    // bouwt de echte Shopify-cart alsnog correct opnieuw op zodra iets wordt toegevoegd.
    console.warn('Moozers session cart reset failed:', err);
    return false;
  });
}

// Dozen-picker state
var dozenKleur   = 'Geel';
var dozenBreedte = '24';
var dozenInhoud  = 72;
var IMG_BASE = 'https://www.moozers.nl/cdn/shop/files/';

function imgUrl(v)  {
  if (!v || !v.img) return '';
  var raw = String(v.img || '').trim();
  if (raw.indexOf('//') === 0) raw = 'https:' + raw;
  if (/^https?:\/\//i.test(raw) || raw.charAt(0) === '/') {
    return raw + (raw.indexOf('width=') === -1 ? ((raw.indexOf('?') > -1 ? '&' : '?') + 'width=800') : '');
  }
  var url = IMG_BASE + raw;
  if (v.imgV) return url + (url.indexOf('?') > -1 ? '&' : '?') + 'v=' + v.imgV + '&width=800';
  return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=800';
}
// Alle prijzen in Shopify zijn INCL. BTW ingevoerd.
// Daarom rekenen we visuele excl.-btw bedragen altijd terug vanuit incl.-btw centen.
// Zo blijft de website/cart gelijk aan Shopify Checkout en voorkomen we 1–2 cent verschil.
function mzToCents(n) {
  n = parseFloat(n);
  if (!isFinite(n)) n = 0;
  return Math.round((n + Number.EPSILON) * 100);
}
function mzRoundHalfEven(n) {
  var floor = Math.floor(n);
  var diff = n - floor;
  var eps = 1e-9;
  if (diff > 0.5 + eps) return floor + 1;
  if (diff < 0.5 - eps) return floor;
  return (floor % 2 === 0) ? floor : floor + 1;
}
function mzVatFactor() { return 1 + (parseFloat(CONFIG.vatRate) || 0.21); }
function mzInclToExclCents(inclCents) {
  inclCents = Math.max(0, parseInt(inclCents, 10) || 0);
  return mzRoundHalfEven(inclCents / mzVatFactor());
}
function mzFormatCents(cents) {
  cents = Math.round(parseFloat(cents) || 0);
  return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
}
function fmt(n) { return mzFormatCents(mzToCents(n)); }
function mzRenderProductPrice(product, variant) {
  var main = document.getElementById('p-price');
  var meta = document.getElementById('p-price-meta');
  if (!main || !meta || !variant) return;
  var state = (typeof mzVariantStockState === 'function') ? mzVariantStockState(variant) : (variant.stockStatus || 'unknown');
  // Toon nooit een mogelijk verouderde fallbackprijs. Pas zodra Shopify live heeft
  // geantwoord wordt de verkoopprijs zichtbaar. Zo kunnen productpagina, staffel,
  // winkelwagen en checkout niet tijdelijk verschillende bedragen tonen.
  if (state !== 'loaded') {
    if (state === 'error') {
      main.classList.remove('mz-price-pending');
      meta.classList.remove('mz-price-pending');
      main.textContent = 'Prijs tijdelijk niet beschikbaar';
      meta.textContent = '';
    } else {
      main.classList.add('mz-price-pending');
      meta.classList.add('mz-price-pending');
      main.innerHTML = '&nbsp;';
      meta.innerHTML = '&nbsp;';
    }
    try { if (typeof mzSetSaleBadgeElement === 'function') mzSetSaleBadgeElement(document.getElementById('p-sale-badge'), null); } catch(e) {}
    return;
  }
  main.classList.remove('mz-price-pending');
  meta.classList.remove('mz-price-pending');
  main.textContent = fmt(variant.priceExcl);
  meta.textContent = 'excl. BTW · ' + fmt(variant.priceIncl) + ' incl. BTW';
  setTimeout(function(){ try { if (typeof mzUpdateProductSaleBadge === 'function') mzUpdateProductSaleBadge(product, variant); } catch(e) {} }, 0);
}
function mzInclFloatFromVariant(v, fallbackExcl) {
  if (v && v.priceIncl != null) return parseFloat(v.priceIncl) || 0;
  return (parseFloat(fallbackExcl) || 0) * mzVatFactor();
}
function mzExclFloatFromInclFloat(priceIncl) {
  return mzInclToExclCents(mzToCents(priceIncl)) / 100;
}
function mzItemLineInclCents(item) {
  if (!item) return 0;
  if (item._lineInclCents != null) return Math.max(0, parseInt(item._lineInclCents, 10) || 0);
  var qty = Math.max(0, parseInt(item.qty, 10) || 0);
  var unitIncl = item.priceIncl != null ? parseFloat(item.priceIncl) : ((parseFloat(item.priceExcl) || 0) * mzVatFactor());
  return mzToCents(unitIncl) * qty;
}
function mzItemLineExclCents(item) { return mzInclToExclCents(mzItemLineInclCents(item)); }
function mzItemLineTaxCents(item)  { return mzItemLineInclCents(item) - mzItemLineExclCents(item); }
function mzItemUnitExclForDisplay(item) {
  var qty = Math.max(1, parseInt(item && item.qty, 10) || 1);
  return (mzItemLineExclCents(item) / qty) / 100;
}
function stars(n)   { var s = ''; for (var i = 0; i < n; i++) s += '★'; return s; }


// ════════════════════════════════════════════════════════
//  LIVE SHOPIFY CHECKOUT BRIDGE
//  Visuele winkelwagen wordt vóór checkout omgezet naar de echte Shopify cart.
// ════════════════════════════════════════════════════════
function mzText(v) { return String(v || '').toLowerCase(); }
function mzCleanHandlePart(v) {
  return mzText(v).replace(/®/g,'').replace(/×/g,'x').replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'').replace(/-+/g,'-').replace(/^-|-$/g,'');
}

function mzBuildShopifyHandle(product, variant) {
  if (!product || !variant) return null;
  if (variant.shopifyHandle) return String(variant.shopifyHandle).replace(/^\/products\//, '').replace(/^\/+|\/+$/g, '');
  var size = mzText(variant.size || variant.label || variant.title);
  var kleur = mzText(variant.kleur || '').indexOf('paars') >= 0 ? 'paars' : 'geel';
  var breedte = variant.breedte || (size.match(/(19|24|36|50)\s*mm/) || [null,null])[1];
  var inhoud = variant.inhoud || (size.match(/(24|36|54|72)\s*r/) || size.match(/(24|36|54|72)\s*rollen/) || [null,null])[1];

  if (product.id === 'washi-tape')       return 'moozers-washi-tape-geel-' + variant.size + 'mm';
  if (product.id === 'washi-tape-paars') return 'moozers-washi-tape-paars-' + variant.size + 'mm';
  if (product.id === 'maskeerfolie') {
    var mm = (size.match(/(1500|2700)\s*mm/) || [null,'1500'])[1];
    return 'moozers-maskeerfolie-' + mm + 'mm';
  }
  if (product.id === 'maskeerpapier') return 'moozers-maskeerpapier-300mm-x-20m';
  if (product.id === 'joint-mesh-gaasband') return 'moozers®-joint-mesh-gaasband-50mm-x-90m';
  if (product.id === 'schuurpad') return 'moozers-schuurpad-dubbelzijdig-' + mzCleanHandlePart(variant.size || variant.label);
  if (product.id === 'schuurpapier') return 'moozers-apex-abrasives-' + mzCleanHandlePart(variant.size || variant.label).split('-')[0] + '-100x150mm';
  if (product.id === 'schuurschijf') return 'moozers-apex-abrasives-schuurschijf-150mm-' + mzCleanHandlePart(variant.size || variant.label).split('-')[0];
  if (product.id === 'apex-mesh-rond' || product.id === 'apex-mesh-80x133') return variant.shopifyHandle || null;
  if (product.id === 'glasschraper') return 'moozers-glasschraper';
  if (product.id === 'dozen-tape' && breedte && inhoud) return 'doos-moozers-washi-tape-' + kleur + '-' + breedte + 'mm-' + inhoud + 'rollen';
  return null;
}

function mzInferShopifyHandle(title, label, img) {
  var s = mzText([title, label, img].join(' '));
  var mm = (s.match(/(19|24|36|50)\s*mm/) || [null,null])[1];
  var p  = (s.match(/p\s*(40|60|80|100|120|150|180|220|240|320|400|600|800|1200|3000)/) || [null,null])[1];
  var rollen = (s.match(/(24|36|54|72)\s*rollen/) || s.match(/(24|36|54|72)r/) || [null,null])[1];

  if (s.indexOf('doos') >= 0 && mm && rollen) {
    return 'doos-moozers-washi-tape-' + (s.indexOf('paars') >= 0 ? 'paars' : 'geel') + '-' + mm + 'mm-' + rollen + 'rollen';
  }
  if (s.indexOf('washi') >= 0 && mm) {
    return 'moozers-washi-tape-' + (s.indexOf('paars') >= 0 ? 'paars' : 'geel') + '-' + mm + 'mm';
  }
  if (s.indexOf('maskeerfolie') >= 0) {
    return 'moozers-maskeerfolie-' + (s.indexOf('2700') >= 0 ? '2700' : '1500') + 'mm';
  }
  if (s.indexOf('maskeerpapier') >= 0) return 'moozers-maskeerpapier-300mm-x-20m';
  if (s.indexOf('joint mesh') >= 0 || s.indexOf('gaasband') >= 0) return 'moozers®-joint-mesh-gaasband-50mm-x-90m';
  if (s.indexOf('schuurpad') >= 0 && p) return 'moozers-schuurpad-dubbelzijdig-p' + p;
  if (s.indexOf('schuurschijf') >= 0 && p) return 'moozers-apex-abrasives-schuurschijf-150mm-p' + p;
  if ((s.indexOf('schuurpapier') >= 0 || s.indexOf('abrasives') >= 0 || s.indexOf('apex') >= 0) && p) return 'moozers-apex-abrasives-p' + p + '-100x150mm';
  if (s.indexOf('glasschraper') >= 0 || s.indexOf('glas schraper') >= 0) return 'moozers-glasschraper';
  return null;
}

function mzFindVariantByImage(productId, img, wantedText) {
  var product = CATALOG[productId];
  if (!product || !product.variants) return null;
  var wanted = mzText(wantedText || '');
  if (wanted) {
    for (var w = 0; w < product.variants.length; w++) {
      var vtxt = mzText([product.variants[w].size, product.variants[w].label, product.variants[w].title].join(' '));
      if (vtxt.indexOf(wanted) >= 0 || wanted.indexOf(vtxt) >= 0) return product.variants[w];
    }
  }
  for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].img === img) return product.variants[i];
  }
  return product.variants[product.defaultVariantIndex || 0] || product.variants[0];
}

function mzCartItemFromVariant(product, variant, quantity, unitPriceExcl) {
  var basePriceExcl = parseFloat(variant && variant.priceExcl != null ? variant.priceExcl : unitPriceExcl) || 0;
  var basePriceIncl = mzInclFloatFromVariant(variant, basePriceExcl);
  // Excl. prijs altijd afleiden van de incl.-btw Shopify-prijs.
  // Hierdoor is 72 × €2,43 incl. exact gelijk aan Shopify Checkout.
  basePriceExcl = mzExclFloatFromInclFloat(basePriceIncl);
  var tiers = variant && variant.staffelTiers ? variant.staffelTiers : (product && product.staffelTiers ? product.staffelTiers : null);
  var handle = mzBuildShopifyHandle(product, variant) || mzInferShopifyHandle(variant.title, variant.label, variant.img);
  return {
    title: variant.title,
    label: variant.label,
    img: variant.img,
    imgV: variant.imgV,
    // Basisprijs bewaren. De zichtbare prijs wordt bij iedere cart-render opnieuw berekend
    // op basis van het TOTALE aantal van exact dezelfde Shopify-variant.
    basePriceExcl: basePriceExcl,
    basePriceIncl: basePriceIncl,
    priceExcl: basePriceExcl,
    priceIncl: basePriceIncl,
    qty: Math.max(1, parseInt(quantity, 10) || 1),
    emoji: null,
    productId: product ? product.id : null,
    variantSize: variant.size || variant.label || '',
    shopifyHandle: handle,
    staffelTiers: tiers ? tiers.slice() : null,
    tierGroupKey: handle || ((product ? product.id : '') + '|' + (variant.size || variant.label || variant.title || '')),
    _mzVariantId: (variant && variant.variantId) ? String(variant.variantId) : null // v11: directe variant-ID voor cart bypass
  };
}

function mzResolveShopifyVariant(item) {
  if (item && item._shopifyCheckoutSkip) return Promise.resolve(null);
  var checkoutQty = item && item._shopifyCheckoutQty != null
    ? Math.max(0, parseInt(item._shopifyCheckoutQty, 10) || 0)
    : Math.max(0, parseInt(item && item.qty, 10) || 0);
  if (checkoutQty <= 0) return Promise.resolve(null);
  // v11: directe variantId bypass — sla handle-fetch en tekst-matching over
  if (item._mzVariantId) {
    return Promise.resolve({
      id: parseInt(item._mzVariantId, 10),
      quantity: Math.max(1, checkoutQty),
      properties: {
        '_shopify_handle_source': item.shopifyHandle || '',
        '_moozers_display_item': 'Los product'
      },
      _mzDisplayName: (typeof mzCheckoutItemName === 'function') ? mzCheckoutItemName(item) : (item.title || ''),
      _mzCartItem: item
    });
  }
  var handle = item._shopifyCheckoutHandle || item.shopifyHandle || mzInferShopifyHandle(item.title, item.label, item.img);
  if (!handle) return Promise.reject(new Error('Geen Shopify-product gekoppeld voor: ' + (item.title || 'onbekend product')));

  return fetch('/products/' + encodeURIComponent(handle) + '.js', {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' }
  }).then(function(res) {
    if (!res.ok) throw new Error('Product niet gevonden in Shopify: ' + handle);
    return res.json();
  }).then(function(product) {
    var variants = product.variants || [];
    var wanted = mzText(item._shopifyCheckoutVariantSize || item.variantSize || item.label || item.title);
    var found = null;

    if (wanted) {
      for (var i = 0; i < variants.length; i++) {
        var vtxt = mzText([variants[i].title, variants[i].option1, variants[i].option2, variants[i].option3].join(' '));
        if (vtxt.indexOf(wanted) >= 0 || wanted.indexOf(vtxt) >= 0) { found = variants[i]; break; }
      }
    }
    if (!found) {
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].available !== false) { found = variants[j]; break; }
      }
    }
    if (!found && variants.length) found = variants[0];
    if (!found || !found.id) throw new Error('Geen variant gevonden voor: ' + (item.title || handle));
    if (found.available === false) throw new Error('Uitverkocht in Shopify: ' + (item.title || product.title));
    item._mzVariantId = String(found.id);
    item.shopifyHandle = item.shopifyHandle || handle;
    mzPersistCartState();

    return {
      id: found.id,
      quantity: Math.max(1, checkoutQty),
      properties: {
        '_shopify_handle_source': handle,
        '_moozers_display_item': item._boxPriceMatch ? 'Doosprijs vanuit losse rollen' : 'Los product'
      },
      _mzDisplayName: mzCheckoutItemName(item),
      _mzCartItem: item
    };
  });
}


// ════════════════════════════════════════════════════════
//  SHOPIFY LIVE PRICE SYNC
//  De hardcoded themeprijzen zijn alleen fallback. Voor winkelwagen/checkout
//  halen we de actuele Shopify-prijs op, zodat admin-wijzigingen geen
//  centverschillen of oude doosprijzen veroorzaken.
// ════════════════════════════════════════════════════════
var mzShopifyProductCache = {};
var mzLivePriceSyncState = { running:false, timer:null, lastKey:'' };
// Eén unieke token per paginalaad voorkomt dat de Shopify theme editor of browser
// een oudere productprijs uit HTTP-cache toont. Binnen dezelfde pagina blijft de
// in-memory cache actief, zodat iedere producthandle maximaal één keer wordt opgehaald.
var mzPricePageToken = Date.now();

function mzFetchShopifyProduct(handle, options) {
  options = options || {};
  handle = String(handle || '').replace(/^\/products\//, '').replace(/^\/+|\/+$/g, '');
  if (!handle) return Promise.resolve(null);

  // Prijs-sync mag kort cachen; voorraadcontrole vraagt altijd een verse Shopify-response.
  if (!options.force && mzShopifyProductCache[handle]) return mzShopifyProductCache[handle];

  var url = '/products/' + encodeURIComponent(handle) + '.js';
  url += (url.indexOf('?') > -1 ? '&' : '?') + (options.force ? 'mz_stock=' + Date.now() : 'mz_price=' + mzPricePageToken);

  var request = fetch(url, {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      'Accept': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache'
    }
  }).then(function(res) {
    if (!res.ok) throw new Error('Product niet gevonden in Shopify: ' + handle);
    return res.json();
  }).catch(function(err) {
    if (!options.force) delete mzShopifyProductCache[handle];
    throw err;
  });

  if (!options.force) mzShopifyProductCache[handle] = request;
  return request;
}

function mzFindShopifyVariant(product, wantedText) {
  if (!product || !Array.isArray(product.variants)) return null;
  var variants = product.variants || [];
  var wanted = mzText(wantedText || '');
  var found = null;
  if (wanted) {
    for (var i = 0; i < variants.length; i++) {
      var vtxt = mzText([variants[i].title, variants[i].option1, variants[i].option2, variants[i].option3].join(' '));
      if (vtxt.indexOf(wanted) >= 0 || wanted.indexOf(vtxt) >= 0) { found = variants[i]; break; }
    }
  }
  if (!found) {
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].available !== false) { found = variants[j]; break; }
    }
  }
  return found || variants[0] || null;
}

function mzShopifyVariantPriceCents(v) {
  if (!v) return null;
  var raw = v.price != null ? v.price : v.compare_at_price;
  var cents = Math.round(parseFloat(raw) || 0);
  return cents > 0 ? cents : null;
}


// Shopify is de enige prijsbron voor alle zichtbare productvermeldingen.
// Deze helper kiest de exacte gewenste variant of, bij een productkaart zonder
// variantkeuze, de laagste beschikbare Shopify-prijs.
function mzShopifyProductPriceSummary(shopProduct, wantedText) {
  if (!shopProduct || !Array.isArray(shopProduct.variants) || !shopProduct.variants.length) return null;
  var variants = shopProduct.variants.filter(function(v){ return v && mzShopifyVariantPriceCents(v); });
  if (!variants.length) return null;

  var chosen = null;
  if (wantedText) chosen = mzFindShopifyVariant(shopProduct, wantedText);
  if (!chosen || !mzShopifyVariantPriceCents(chosen)) {
    var available = variants.filter(function(v){ return v.available !== false; });
    var pool = available.length ? available : variants;
    chosen = pool.reduce(function(best, v){
      return !best || mzShopifyVariantPriceCents(v) < mzShopifyVariantPriceCents(best) ? v : best;
    }, null);
  }
  if (!chosen) return null;

  var poolForRange = variants.filter(function(v){ return v.available !== false; });
  if (!poolForRange.length) poolForRange = variants;
  var prices = poolForRange.map(mzShopifyVariantPriceCents).filter(function(c){ return c > 0; });
  var inclCents = mzShopifyVariantPriceCents(chosen);
  return {
    variant: chosen,
    priceInclCents: inclCents,
    priceExclCents: mzInclToExclCents(inclCents),
    hasRange: prices.length > 1 && Math.min.apply(Math, prices) !== Math.max.apply(Math, prices)
  };
}

function mzSetLivePricePair(priceEl, vatEl, summary, useFromPrice) {
  if (!priceEl || !summary) return;
  var prefix = useFromPrice ? 'v.a. ' : '';
  priceEl.textContent = prefix + mzFormatCents(summary.priceExclCents);
  priceEl.setAttribute('data-mz-shopify-price', String(summary.priceInclCents));
  if (vatEl) vatEl.textContent = 'excl. BTW · ' + prefix + mzFormatCents(summary.priceInclCents) + ' incl. BTW';
}

// ══════════════════════════════════════════════════════════
//  Automatisch kortingslabel op basis van Shopify compare_at_price
//  Veilig geïsoleerd: geen click handlers, geen overlays en geen parallelle
//  product-fetches tijdens de kritieke navigatie-initialisatie.
// ══════════════════════════════════════════════════════════
function mzGetSaleBadgeData(price, compareAtPrice) {
  var currentPrice = Number(price);
  var originalPrice = Number(compareAtPrice);
  if (!isFinite(currentPrice) || !isFinite(originalPrice) ||
      currentPrice < 0 || originalPrice <= 0 || originalPrice <= currentPrice) {
    return null;
  }
  var percentage = Math.round(((originalPrice - currentPrice) / originalPrice) * 100);
  if (!isFinite(percentage) || percentage <= 0) return null;
  return { percentage: percentage, text: '-' + percentage + '% korting' };
}

function mzSaleFromShopifyVariant(sv) {
  if (!sv) return null;
  return mzGetSaleBadgeData(sv.price, sv.compare_at_price);
}

function mzResolveVariantSale(handle, wantedText) {
  handle = String(handle || '').replace(/^\/products\//, '').replace(/^\/+|\/+$/g, '');
  if (!handle) return Promise.resolve(null);
  try {
    return Promise.resolve(mzFetchShopifyProduct(handle)).then(function(sp){
      return mzSaleFromShopifyVariant(mzFindShopifyVariant(sp, wantedText || ''));
    }).catch(function(){ return null; });
  } catch (e) {
    return Promise.resolve(null);
  }
}

// Werk verkooplabels één voor één af. Zo kunnen tientallen productkaarten nooit
// de navigatie of andere knoppen vertragen door gelijktijdige productrequests.
var mzSaleBadgeQueue = Promise.resolve();
function mzQueueSaleBadgeTask(task) {
  var run = mzSaleBadgeQueue.catch(function(){}).then(function(){
    try { return task(); } catch (e) { return null; }
  });
  mzSaleBadgeQueue = Promise.resolve(run).catch(function(){});
  return run;
}
function mzRunSaleBadgeLater(task, delay) {
  delay = Math.max(0, parseInt(delay, 10) || 0);
  setTimeout(function(){
    mzQueueSaleBadgeTask(task).catch(function(){});
  }, delay);
}
function mzSetSaleBadgeElement(el, badge) {
  if (!el) return;
  el.setAttribute('aria-hidden', 'true');
  if (badge && badge.text) {
    el.textContent = badge.text;
    el.style.display = 'inline-flex';
  } else {
    el.textContent = '';
    el.style.display = 'none';
  }
}

// Productpagina: hetzelfde badge-element wordt hergebruikt bij variantwissels.
var mzProductSaleToken = 0;
function mzUpdateProductSaleBadge(product, variant) {
  var ids = ['p-sale-badge'];
  ids.forEach(function(id){ mzSetSaleBadgeElement(document.getElementById(id), null); });
  if (!product || !variant) return;
  if (variant.stockStatus === 'loaded' && Object.prototype.hasOwnProperty.call(variant, '_saleBadge')) {
    ids.forEach(function(id){ mzSetSaleBadgeElement(document.getElementById(id), variant._saleBadge); });
    return;
  }
  var handle = '';
  try { handle = mzBuildShopifyHandle(product, variant) || mzInferShopifyHandle(variant.title, variant.label, variant.img); } catch(e) {}
  if (!handle) return;
  var wanted = variant.size || variant.label || variant.title || '';
  var token = ++mzProductSaleToken;
  mzRunSaleBadgeLater(function(){
    return mzResolveVariantSale(handle, wanted).then(function(badge){
      if (token !== mzProductSaleToken) return;
      if (variant) variant._saleBadge = badge;
      ids.forEach(function(id){ mzSetSaleBadgeElement(document.getElementById(id), badge); });
    });
  }, 0);
}

function mzEnsureSaleBadgeBefore(priceEl, extraClass) {
  if (!priceEl || !priceEl.parentNode) return null;
  var container = priceEl.parentNode;
  var existing = container.querySelector(':scope > .mz-sale-badge');
  if (existing) return existing;
  var badge = document.createElement('span');
  badge.className = 'mz-sale-badge ' + (extraClass || '');
  badge.style.display = 'none';
  badge.setAttribute('aria-hidden', 'true');
  container.insertBefore(badge, priceEl);
  return badge;
}

// Productkaarten: pas na volledige paginalaad en sequentieel. Er wordt niets aan
// href, onclick, pointer-events van de kaart of de globale router gewijzigd.
function mzApplyCardSaleBadges(root) {
  var scope = root || document;
  var cards;
  try { cards = scope.querySelectorAll('a.prod-card[href*="/products/"]'); } catch(e) { return; }
  Array.prototype.forEach.call(cards, function(card, index){
    if (!card || card.__mzShopifyCardSyncScheduled) return;
    card.__mzShopifyCardSyncScheduled = true;
    var handle = mzProductHandleFromHref(card.getAttribute('href') || '');
    var priceEl = card.querySelector('.pcb-price');
    var vatEl = card.querySelector('.pcb-vat');
    if (!handle || !priceEl) return;

    var originalPriceText = String(priceEl.textContent || '');
    var preserveFrom = /v\.?\s*a\.?/i.test(originalPriceText) || priceEl.classList.contains('dozen-vanaf-excl');
    var isDozenOverview = priceEl.classList.contains('dozen-vanaf-excl');
    var badgeEl = mzEnsureSaleBadgeBefore(priceEl, 'mz-sale-badge-card');
    card.classList.remove('mz-price-ready');

    mzRunSaleBadgeLater(function(){
      return mzFetchShopifyProduct(handle).then(function(shopProduct){
        var summary = mzShopifyProductPriceSummary(shopProduct, '');
        if (!summary) {
          mzSetSaleBadgeElement(badgeEl, null);
          if (!isDozenOverview) { priceEl.textContent = 'Bekijk actuele prijs'; if (vatEl) vatEl.textContent = ''; card.classList.add('mz-price-ready'); }
          return null;
        }
        // Dozen-overzicht heeft een aparte minimumprijs over meerdere Shopify-producten.
        if (!isDozenOverview) {
          mzSetLivePricePair(priceEl, vatEl, summary, preserveFrom || summary.hasRange);
          card.classList.add('mz-price-ready');
        }
        mzSetSaleBadgeElement(badgeEl, mzSaleFromShopifyVariant(summary.variant));
        return summary;
      }).catch(function(){
        mzSetSaleBadgeElement(badgeEl, null);
        if (!isDozenOverview) { priceEl.textContent = 'Bekijk actuele prijs'; if (vatEl) vatEl.textContent = ''; card.classList.add('mz-price-ready'); }
        return null;
      });
    }, index * 25);
  });
}

function mzApplyCartSaleBadges() {
  var nodes;
  try { nodes = document.querySelectorAll('#cart-items .cart-item[data-mz-idx]'); } catch(e) { return; }
  Array.prototype.forEach.call(nodes, function(node, index){
    var idx = parseInt(node.getAttribute('data-mz-idx'), 10);
    var item = (typeof cart !== 'undefined' && cart && cart[idx]) ? cart[idx] : null;
    var nameEl = node.querySelector('.ci-name');
    if (!item || !nameEl) return;
    var existing = node.querySelector('.mz-sale-badge-cart');
    if (!existing) {
      existing = document.createElement('span');
      existing.className = 'mz-sale-badge mz-sale-badge-cart';
      existing.style.display = 'none';
      existing.setAttribute('aria-hidden', 'true');
      nameEl.parentNode.insertBefore(existing, nameEl.nextSibling);
    }
    var handle = '';
    try { handle = item.shopifyHandle || item._shopifyCheckoutHandle || mzInferShopifyHandle(item.title, item.label, item.img); } catch(e) {}
    if (!handle) { mzSetSaleBadgeElement(existing, null); return; }
    var wanted = item.size || item.label || item.title || '';
    (function(badgeEl, h, w, wait){
      mzRunSaleBadgeLater(function(){
        return mzResolveVariantSale(h, w).then(function(badge){ mzSetSaleBadgeElement(badgeEl, badge); });
      }, wait);
    })(existing, handle, wanted, index * 20);
  });
}

function mzApplySearchSaleBadges() {
  var nodes;
  try { nodes = document.querySelectorAll('#search-results .search-result[data-mz-pid]'); } catch(e) { return; }
  Array.prototype.forEach.call(nodes, function(node, index){
    var productId = node.getAttribute('data-mz-pid');
    var prod = (typeof CATALOG !== 'undefined') ? CATALOG[productId] : null;
    var priceEl = node.querySelector('.search-result-price');
    if (!prod || !priceEl || !Array.isArray(prod.variants) || !prod.variants.length) return;
    var vsizeRaw = node.getAttribute('data-mz-vsize') || '';
    var vsize = vsizeRaw.toLowerCase();
    var variant = null;
    for (var i = 0; vsize && i < prod.variants.length; i++) {
      if (String(prod.variants[i].size || prod.variants[i].label || '').toLowerCase() === vsize) { variant = prod.variants[i]; break; }
    }
    if (!variant) variant = prod.variants[prod.defaultVariantIndex] || prod.variants[0];
    if (!variant) return;
    var handle = '';
    try { handle = mzBuildShopifyHandle(prod, variant) || mzInferShopifyHandle(variant.title, variant.label, variant.img); } catch(e) {}
    if (!handle) return;
    var badgeEl = mzEnsureSaleBadgeBefore(priceEl, 'mz-sale-badge-card');

    (function(h, wanted, el, wait, catalogVariant, pid, sizeKey, resultNode){
      mzRunSaleBadgeLater(function(){
        return mzFetchShopifyProduct(h).then(function(shopProduct){
          var summary = mzShopifyProductPriceSummary(shopProduct, wanted);
          if (!summary) { mzSetSaleBadgeElement(el, null); return null; }
          mzApplyInclCentsToCatalogVariant(catalogVariant, summary.priceInclCents);

          if (typeof searchableProducts !== 'undefined') {
            searchableProducts.forEach(function(entry){
              if (entry.id === pid && String(entry.variantSize || '').toLowerCase() === String(sizeKey || '').toLowerCase()) {
                entry.priceIncl = summary.priceInclCents / 100;
                entry.priceExcl = summary.priceExclCents / 100;
              }
            });
          }

          priceEl.classList.remove('mz-price-pending');
          priceEl.removeAttribute('aria-hidden');
          priceEl.innerHTML = mzFormatCents(summary.priceExclCents) + ' <span class="search-result-vat">excl. BTW</span>';
          var vatLines = resultNode.querySelectorAll('.search-result-vat');
          if (vatLines.length) { vatLines[vatLines.length - 1].classList.remove('mz-price-pending'); vatLines[vatLines.length - 1].removeAttribute('aria-hidden'); vatLines[vatLines.length - 1].textContent = mzFormatCents(summary.priceInclCents) + ' incl. BTW'; }
          var addBtn = resultNode.querySelector('.search-result-add');
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.classList.remove('mz-pending-control');
            addBtn.removeAttribute('aria-hidden');
            addBtn.textContent = '+ Voeg toe';
            addBtn.setAttribute('onclick', 'event.stopPropagation();quickAddFromSearch(' +
              JSON.stringify(pid) + ',' + JSON.stringify(catalogVariant.img || '') + ',' +
              JSON.stringify(catalogVariant.imgV || '') + ',' + (summary.priceExclCents / 100) + ',' +
              (summary.priceInclCents / 100) + ',this,' + JSON.stringify(sizeKey || '') + ')');
          }
          mzSetSaleBadgeElement(el, mzSaleFromShopifyVariant(summary.variant));
          return summary;
        }).catch(function(){ mzSetSaleBadgeElement(el, null); return null; });
      }, wait);
    })(handle, variant.size || variant.label || variant.title || '', badgeEl, index * 20, variant, productId, vsizeRaw, node);
  });
}

function mzApplyInclCentsToCatalogVariant(variant, inclCents) {
  if (!variant || inclCents == null) return false;
  inclCents = Math.max(0, parseInt(inclCents, 10) || 0);
  if (!inclCents) return false;
  var old = mzToCents(variant.priceIncl != null ? variant.priceIncl : ((parseFloat(variant.priceExcl) || 0) * mzVatFactor()));
  if (old === inclCents) return false;
  variant.priceIncl = inclCents / 100;
  variant.priceExcl = mzInclToExclCents(inclCents) / 100;
  return true;
}

function mzSyncCatalogVariantFromShopify(product, variant) {
  var handle = mzBuildShopifyHandle(product, variant) || mzInferShopifyHandle(variant && variant.title, variant && variant.label, variant && variant.img);
  if (!handle || !variant) return Promise.resolve(false);
  var wanted = variant.size || variant.label || variant.title || '';
  return mzFetchShopifyProduct(handle).then(function(shopProduct) {
    var shopVariant = mzFindShopifyVariant(shopProduct, wanted);
    var cents = mzShopifyVariantPriceCents(shopVariant);
    // v87: ook voorraadstatus bijwerken vanuit Shopify
    var stockChanged = false;
    if (shopVariant != null) {
      var nowInStock = (shopVariant.available !== false);
      if (variant.inStock !== nowInStock) { variant.inStock = nowInStock; stockChanged = true; }
      if (shopVariant.id) variant.variantId = String(shopVariant.id);
    }
    var liveSale = mzSaleFromShopifyVariant(shopVariant);
    var saleChanged = JSON.stringify(variant._saleBadge || null) !== JSON.stringify(liveSale || null);
    variant._saleBadge = liveSale;
    variant.compareAtInclCents = shopVariant && shopVariant.compare_at_price ? Math.round(Number(shopVariant.compare_at_price) || 0) : 0;
    var priceChanged = mzApplyInclCentsToCatalogVariant(variant, cents);
    return priceChanged || stockChanged || saleChanged;
  }).catch(function(){ return false; });
}

// Shopify is voor ALLE producten en varianten de enige voorraadbron.
// Hardcoded inStock-waarden in de catalogus zijn uitsluitend een noodfallback en worden
// nooit als definitieve status getoond voordat Shopify heeft geantwoord.
function mzVariantStockState(variant) {
  return variant && variant.stockStatus ? variant.stockStatus : 'unknown';
}

function mzSetActiveStockUi(variant) {
  var pill = document.getElementById('p-stock-pill');
  var btn  = document.getElementById('add-btn');
  if (!variant || !pill || !btn) return;

  var state = mzVariantStockState(variant);

  if (state === 'loaded') {
    pill.style.display = '';
    pill.textContent = variant.inStock ? '✓ Op voorraad' : 'Uitverkocht';
    pill.className   = variant.inStock ? 'stock-pill' : 'oos-pill';
    btn.disabled     = !variant.inStock;
  } else {
    // Shopify controleert live op de achtergrond; bezoekers zien geen tussenstatus.
    pill.textContent = '';
    pill.className   = '';
    pill.style.display = 'none';
    btn.disabled = true;
    btn.classList.add('mz-silent-loading');
  }
}

function mzSyncProductStockStatus(product) {
  if (!product || !Array.isArray(product.variants)) return Promise.resolve(false);

  product.variants.forEach(function(variant) {
    variant.stockStatus = 'loading';
    variant._staffelPriceStatus = mzIsLooseTapeProduct(product) ? 'loading' : 'loaded';
  });

  if (currentProduct === product) {
    mzSetActiveStockUi(cv);
    try { renderVariantGrid(); } catch(e) {}
    try { updateCtaPrice(); } catch(e) {}
  }

  var tasks = product.variants.map(function(variant) {
    var handle = mzBuildShopifyHandle(product, variant) || mzInferShopifyHandle(
      variant && variant.title,
      variant && variant.label,
      variant && variant.img
    );

    if (!handle) {
      variant.stockStatus = 'error';
      return Promise.resolve(false);
    }

    return mzFetchShopifyProduct(handle, { force:true }).then(function(shopProduct) {
      var shopVariant;
      var isMeshProduct = product.variantType === 'mesh-rond' || product.variantType === 'mesh-vierkant';

      if (isMeshProduct && shopProduct && Array.isArray(shopProduct.variants)) {
        shopVariant = shopProduct.variants[0] || null;
      } else {
        var wanted = variant.size || variant.label || variant.title || '';
        shopVariant = mzFindShopifyVariant(shopProduct, wanted);
      }

      if (!shopVariant) {
        variant.stockStatus = 'error';
        return false;
      }

      variant.inStock = (shopVariant.available === true);
      if (shopVariant.id) variant.variantId = String(shopVariant.id);

      var cents = mzShopifyVariantPriceCents(shopVariant);
      if (cents) mzApplyInclCentsToCatalogVariant(variant, cents);
      variant._saleBadge = mzSaleFromShopifyVariant(shopVariant);
      variant.compareAtInclCents = shopVariant && shopVariant.compare_at_price ? Math.round(Number(shopVariant.compare_at_price) || 0) : 0;

      // Voor losse tape worden ook de bijbehorende doosprijzen eerst live uit
      // Shopify opgehaald. Daardoor gebruikt de CTA bij exact 24/36/54/72 rollen
      // nooit een oude doosprijs. Het laden blijft volledig onzichtbaar.
      return mzSyncRelatedBoxPricesForVariant(product, variant).then(function(boxPricesReady) {
        variant.stockStatus = 'loaded';

        // Werk de gekozen variant direct bij zodra alle benodigde actuele prijzen
        // bekend zijn. Staffelbedragen worden dan in één keer correct getoond.
        if (currentProduct === product && cv === variant) {
          try { mzRenderProductPrice(currentProduct, cv); } catch(e) {}
          try { mzSetSaleBadgeElement(document.getElementById('p-sale-badge'), variant._saleBadge); } catch(e) {}
          try { renderStaffelPills(); } catch(e) {}
          try { updateCtaPrice(); } catch(e) {}
          try { mzSetActiveStockUi(cv); } catch(e) {}
        }
        return boxPricesReady || !mzIsLooseTapeProduct(product);
      });
    }).catch(function() {
      variant.stockStatus = 'error';
      return false;
    });
  });

  return Promise.all(tasks).then(function(results) {
    if (currentProduct === product) {
      try { renderVariantGrid(); } catch(e) {}
      mzSetActiveStockUi(cv);
      try { mzRenderProductPrice(currentProduct, cv); } catch(e) {}
      try { renderStaffelPills(); } catch(e) {}
      try { updateCtaPrice(); } catch(e) {}
    }
    return results.some(function(result) { return result === true; });
  });
}

// ── v20: Dynamische vanaf-prijs Dozen Tape ───────────────────────────────
function mzGetDozenVanafPrijs() {
  var p = CATALOG['dozen-tape'];
  if (!p || !Array.isArray(p.variants)) return null;
  var minIncl = null;
  p.variants.forEach(function(v) {
    if (v.inStock && v.priceIncl && v.priceIncl > 0) {
      if (minIncl === null || v.priceIncl < minIncl) minIncl = v.priceIncl;
    }
  });
  if (minIncl === null) return null;
  var excl = Math.round(minIncl / 1.21 * 100) / 100;
  return { incl: Math.round(minIncl * 100) / 100, excl: excl };
}

function mzUpdateDozenVanafPrijs() {
  var prijs = mzGetDozenVanafPrijs();
  if (!prijs) return;
  var fe = '\u20ac ' + prijs.excl.toFixed(2).replace('.', ',');
  var fi = '\u20ac ' + prijs.incl.toFixed(2).replace('.', ',');
  document.querySelectorAll('.dozen-vanaf-excl').forEach(function(el) {
    el.textContent = 'v.a. ' + fe;
  });
  document.querySelectorAll('.dozen-vanaf-incl').forEach(function(el) {
    el.textContent = 'excl. BTW \u00b7 v.a. ' + fi + ' incl. BTW';
  });
}

function mzRefreshDozenVanafPrijsFromShopify() {
  // v22: parallel fetch van alle CATALOG-varianten — onafhankelijk van lokale inStock.
  // Elk Dozen Tape CATALOG-item correspondeert met één uniek Shopify-product
  // (kleur + breedte + inhoud bepalen de handle). Elk zo'n product heeft doorgaans
  // precies één variant; we controleren expliciet alle Shopify-varianten om zeker
  // de goede te kiezen. Changelog: dozen-tape Shopify-producten hebben 1 variant per
  // product — bij meerdere varianten kiezen we de goedkoopste beschikbare.
  var p = CATALOG['dozen-tape'];
  if (!p || !Array.isArray(p.variants)) return;

  // Alle varianten met genoeg data voor een betrouwbare handle-opbouw
  var fetchable = p.variants.filter(function(v) {
    return v.kleur && v.breedte && (v.inhoud > 0) && (v.priceIncl > 0);
  });
  if (!fetchable.length) return;

  var collected = []; // geslaagde, beschikbare resultaten: { priceIncl, priceExcl }
  var remaining  = fetchable.length;

  function onAllDone() {
    if (!collected.length) {
      console.warn('[Moozers v147] Dozen Tape vanaf-prijs: geen beschikbare Shopify-variant gevonden.');
      document.querySelectorAll('.dozen-vanaf-excl').forEach(function(el) {
        el.textContent = 'Bekijk actuele prijs';
        var card = el.closest('.prod-card'); if (card) card.classList.add('mz-price-ready');
      });
      document.querySelectorAll('.dozen-vanaf-incl').forEach(function(el) { el.textContent = ''; });
      return;
    }
    // Goedkoopste beschikbare kiezen
    collected.sort(function(a, b) { return a.priceIncl - b.priceIncl; });
    var best = collected[0];
    // DOM direct bijwerken — geen CATALOG-mutatie, geen BTW-vermenigvuldiging
    var fe = '€ ' + best.priceExcl.toFixed(2).replace('.', ',');
    var fi = '€ ' + best.priceIncl.toFixed(2).replace('.', ',');
    document.querySelectorAll('.dozen-vanaf-excl').forEach(function(el) {
      el.textContent = 'v.a. ' + fe;
    });
    document.querySelectorAll('.dozen-vanaf-incl').forEach(function(el) {
      el.textContent = 'excl. BTW · v.a. ' + fi + ' incl. BTW';
    });
    document.querySelectorAll('.dozen-vanaf-excl').forEach(function(el) {
      var card = el.closest('.prod-card'); if (card) card.classList.add('mz-price-ready');
    });
  }

  function decrementAndCheck() {
    remaining--;
    if (remaining <= 0) onAllDone();
  }

  fetchable.forEach(function(v) {
    var handle = 'doos-moozers-washi-tape-'
      + (v.kleur || '').toLowerCase()
      + '-' + v.breedte + 'mm-' + v.inhoud + 'rollen';
    var logLabel = (v.kleur || '') + ' ' + v.breedte + 'mm × ' + v.inhoud + 'r (handle: ' + handle + ')';

    (typeof mzFetchShopifyProduct === 'function'
      ? mzFetchShopifyProduct(handle)
      : Promise.reject('geen mzFetchShopifyProduct'))
    .then(function(shopProduct) {
      if (!shopProduct || !Array.isArray(shopProduct.variants) || !shopProduct.variants.length) {
        decrementAndCheck(); return;
      }
      // Controleer alle Shopify-varianten; kies de goedkoopste beschikbare
      var available = shopProduct.variants.filter(function(sv) { return !!sv.available; });
      if (!available.length) { decrementAndCheck(); return; }

      var svBest = available.reduce(function(acc, sv) {
        return parseFloat(sv.price) < parseFloat(acc.price) ? sv : acc;
      });
      var cents = mzShopifyVariantPriceCents(svBest); // prijs al in centen (bijv. 6460 = €64,60)
      if (!cents) { decrementAndCheck(); return; }

      // Shopify storefront-prijs is al INCL. BTW — nooit opnieuw vermenigvuldigen met 1,21
      var newIncl = cents / 100;
      var newExcl = Math.round((newIncl / 1.21) * 100) / 100;
      collected.push({ priceIncl: newIncl, priceExcl: newExcl });
      decrementAndCheck();
    })
    .catch(function(e) {
      console.warn('[Moozers v22] Dozen Tape vanaf-prijs: fetch mislukt voor ' + logLabel, e);
      decrementAndCheck(); // Fout in één variant stopt de overige niet
    });
  });
}
// ── einde v20 Dozen Tape functies ────────────────────────────────────────

function mzCartLivePriceKey() {
  if (!Array.isArray(cart)) return '';
  var parts = [];
  cart.forEach(function(item) {
    try { mzEnsureCartPricingMeta(item); } catch(e) {}
    parts.push([item.shopifyHandle || '', item.variantSize || '', item.label || '', item.qty || 0].join(':'));
  });
  return parts.join('|');
}

function mzSyncLivePricesForCart(options) {
  options = options || {};
  if (!Array.isArray(cart) || !cart.length) return Promise.resolve(false);
  if (mzLivePriceSyncState.running && !options.force) return Promise.resolve(false);

  var key = mzCartLivePriceKey();
  if (!options.force && mzLivePriceSyncState.lastKey === key) return Promise.resolve(false);
  mzLivePriceSyncState.running = true;

  var tasks = [];
  var changed = false;

  cart.forEach(function(item) {
    mzEnsureCartPricingMeta(item);
    var found = mzFindCatalogVariantForItem(item);
    if (found && found.product && found.variant) {
      tasks.push(mzSyncCatalogVariantFromShopify(found.product, found.variant).then(function(didChange) {
        if (didChange) {
          changed = true;
          item.basePriceIncl = found.variant.priceIncl;
          item.basePriceExcl = found.variant.priceExcl;
        }
      }));
    }
  });

  // Ook de doosvarianten live ophalen als de huidige cart in een dooshoeveelheid valt.
  var groups = {};
  cart.forEach(function(item, i) {
    mzEnsureCartPricingMeta(item);
    var groupKey = item.tierGroupKey || item.shopifyHandle || ('line-' + i);
    if (!groups[groupKey]) groups[groupKey] = { qty:0, indexes:[] };
    groups[groupKey].qty += Math.max(0, parseInt(item.qty, 10) || 0);
    groups[groupKey].indexes.push(i);
  });
  Object.keys(groups).forEach(function(groupKey) {
    var group = groups[groupKey];
    for (var i = 0; i < group.indexes.length; i++) {
      var deal = mzGetBoxDealForCartGroup(cart[group.indexes[i]], group.qty);
      if (deal && deal.boxProduct && deal.boxVariant) {
        tasks.push(mzSyncCatalogVariantFromShopify(deal.boxProduct, deal.boxVariant).then(function(didChange){ if (didChange) changed = true; }));
        break;
      }
    }
  });

  return Promise.all(tasks).then(function() {
    mzLivePriceSyncState.lastKey = key;
    if (changed && typeof mzRepriceCartItems === 'function') mzRepriceCartItems();
    return changed;
  }).catch(function() {
    return changed;
  }).then(function(result) {
    mzLivePriceSyncState.running = false;
    return result;
  });
}

function mzScheduleLivePriceSync(delay) {
  if (!Array.isArray(cart) || !cart.length) return;
  if (mzLivePriceSyncState.timer) clearTimeout(mzLivePriceSyncState.timer);
  mzLivePriceSyncState.timer = setTimeout(function(){
    mzLivePriceSyncState.timer = null;
    mzSyncLivePricesForCart({ force:false }).then(function(changed) {
      if (changed && typeof renderCart === 'function') renderCart(true);
      if (changed && currentProduct && cv && typeof updateCtaPrice === 'function') {
        try { renderVariantGrid(); renderStaffelPills(); updateCtaPrice(); } catch(e) {}
      }
    });
  }, delay == null ? 150 : delay);
}

function mzRealCartProductInclCents(realCart) {
  if (!realCart || !Array.isArray(realCart.items)) return null;
  return realCart.items.reduce(function(sum, line) {
    var cents = line.final_line_price != null ? line.final_line_price : (line.line_price != null ? line.line_price : 0);
    return sum + Math.max(0, parseInt(cents, 10) || 0);
  }, 0);
}

function mzCompressLineItems(items) {
  var byId = {};
  items.forEach(function(item) {
    if (!byId[item.id]) {
      byId[item.id] = {
        id: item.id,
        quantity: 0,
        properties: item.properties || {},
        _mzDisplayName: item._mzDisplayName || 'Dit product',
        _mzCartItem: item._mzCartItem || null,
        _mzCartItems: []
      };
    }
    byId[item.id].quantity += item.quantity;
    if (item._mzCartItem) {
      byId[item.id]._mzCartItems.push({
        item: item._mzCartItem,
        quantity: Math.max(0, parseInt(item.quantity, 10) || 0)
      });
    }
  });
  return Object.keys(byId).map(function(id) { return byId[id]; });
}

function mzApplyShopifyCartPricesToDisplay(realCart, requestedLines, displaySyncKey) {
  if (!realCart || !Array.isArray(realCart.items) || !Array.isArray(requestedLines)) return false;
  var syncKey = displaySyncKey || ((typeof mzCartLivePriceKey === 'function') ? mzCartLivePriceKey() : '');
  var updated = false;

  requestedLines.forEach(function(line) {
    if (!line || !line.id) return;
    var realInclCents = 0;
    var realOriginalInclCents = 0;
    var realQty = 0;

    realCart.items.forEach(function(realLine) {
      if (String(realLine.variant_id) !== String(line.id)) return;
      realInclCents += Math.max(0, parseInt(realLine.final_line_price != null ? realLine.final_line_price : realLine.line_price, 10) || 0);
      realOriginalInclCents += Math.max(0, parseInt(realLine.original_line_price != null ? realLine.original_line_price : realLine.line_price, 10) || 0);
      realQty += Math.max(0, parseInt(realLine.quantity, 10) || 0);
    });

    if (realQty <= 0 && realInclCents <= 0) return;

    var sources = (Array.isArray(line._mzCartItems) && line._mzCartItems.length)
      ? line._mzCartItems
      : [{ item: line._mzCartItem, quantity: line.quantity }];
    var totalSourceQty = sources.reduce(function(sum, src) {
      return sum + Math.max(0, parseInt(src && src.quantity, 10) || 0);
    }, 0) || Math.max(1, parseInt(line.quantity, 10) || 1);
    var remainingInclCents = realInclCents;

    sources.forEach(function(src, pos) {
      var item = src && src.item;
      if (!item) return;

      var sourceQty = Math.max(0, parseInt(src.quantity, 10) || 0);
      var lineInclCents = (pos === sources.length - 1)
        ? Math.max(0, remainingInclCents)
        : Math.round(realInclCents * (sourceQty / Math.max(1, totalSourceQty)));
      remainingInclCents -= lineInclCents;

      var lineExclCents = mzInclToExclCents(lineInclCents);
      if (item._lineInclCents !== lineInclCents || item._lineExclCents !== lineExclCents || item._shopifyDisplaySynced !== true) {
        updated = true;
      }

      item._lineInclCents = lineInclCents;
      item._lineExclCents = lineExclCents;
      item._lineTaxCents = lineInclCents - lineExclCents;
      item._shopifyDisplaySynced = true;
      item._shopifyDisplaySyncKey = syncKey;
      item._shopifyDisplayVariantId = line.id;
      var actualDiscount = realOriginalInclCents > realInclCents && realOriginalInclCents > 0
        ? Math.max(0, Math.min(1, (realOriginalInclCents - realInclCents) / realOriginalInclCents))
        : 0;
      item._shopifyActualDiscount = actualDiscount;
      item._staffelDiscount = actualDiscount;
      delete item._boxPriceMatch;
      delete item._boxVariantLabel;
      delete item._boxDealQty;

      var displayQty = Math.max(0, parseInt(item.qty, 10) || 0);
      item.priceIncl = displayQty ? (lineInclCents / 100) / displayQty : 0;
      item.priceExcl = displayQty ? (lineExclCents / 100) / displayQty : 0;
    });
  });

  return updated;
}

function mzSetCheckoutLoading(isLoading) {
  document.querySelectorAll('.btn-checkout').forEach(function(btn) {
    if (!btn.getAttribute('data-original-html')) btn.setAttribute('data-original-html', btn.innerHTML);
    btn.disabled = !!isLoading;
    btn.innerHTML = btn.getAttribute('data-original-html');
    btn.classList.toggle('mz-silent-loading', !!isLoading);
    if (isLoading) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  });
}

function mzCheckoutItemName(item) {
  if (!item) return 'Dit product';
  var name = String(item.title || item.name || '').replace(/\s+/g, ' ').trim();
  var variant = String(item.variantSize || item.label || '').replace(/\s+/g, ' ').trim();
  if (variant && name.toLowerCase().indexOf(variant.toLowerCase()) < 0) name += ' ' + variant;
  name = name.replace(/\s+×\s+/g, ' × ').replace(/\s+x\s+/ig, ' × ').trim();
  return name || 'Dit product';
}


function mzMostLikelyStockItemName(limitQty) {
  if (!Array.isArray(cart) || !cart.length) return 'Dit product';
  var limit = limitQty == null ? null : Math.max(0, parseInt(limitQty, 10) || 0);
  var best = cart[0];
  if (limit != null) {
    for (var i = 0; i < cart.length; i++) {
      var qty = Math.max(0, parseInt(cart[i] && cart[i].qty, 10) || 0);
      if (qty > limit) { best = cart[i]; break; }
    }
  } else {
    for (var j = 0; j < cart.length; j++) {
      var q = Math.max(0, parseInt(cart[j] && cart[j].qty, 10) || 0);
      var bq = Math.max(0, parseInt(best && best.qty, 10) || 0);
      if (q > bq) best = cart[j];
    }
  }
  return mzCheckoutItemName(best);
}

function mzCheckoutExtractStockLimitFromText(text) {
  var s = String(text || '');
  var m = s.match(/slechts\s+(\d+)/i) || s.match(/only\s+(\d+)/i) || s.match(/maximum(?:\s+of)?\s+(\d+)/i) || s.match(/maximaal\s+(\d+)/i);
  if (m && m[1] != null) return Math.max(0, parseInt(m[1], 10) || 0);
  return null;
}

function mzBuildNamedStockError(itemName, wantedQty, limitQty, rawText) {
  var name = itemName || 'Dit product';
  var wanted = Math.max(0, parseInt(wantedQty, 10) || 0);
  var limit = limitQty == null ? null : Math.max(0, parseInt(limitQty, 10) || 0);
  var raw = String(rawText || '').toLowerCase();
  if (limit != null) {
    if (limit <= 0 || raw.indexOf('sold out') >= 0 || raw.indexOf('uitverkocht') >= 0) {
      return name + ' is niet meer op voorraad. Verwijder dit product of kies een alternatief.';
    }
    return name + ' heeft onvoldoende voorraad. Er zijn maximaal ' + limit + ' stuks beschikbaar; je hebt ' + wanted + ' in de winkelwagen.';
  }
  return name + ' heeft onvoldoende voorraad. Verlaag het aantal of kies een alternatief.';
}

function mzThrowNamedStockError(line, rawText, actualQty) {
  var payload = {
    name: line && line._mzDisplayName ? line._mzDisplayName : 'Dit product',
    wanted: line && line.quantity ? line.quantity : null,
    limit: actualQty == null ? null : actualQty,
    raw: String(rawText || '')
  };
  throw new Error('MZ_STOCK_PRODUCT::' + JSON.stringify(payload));
}

function mzFriendlyCheckoutMessage(err) {
  var raw = err && err.message ? String(err.message) : '';

  if (raw.indexOf('MZ_PRICE_MISMATCH::') === 0) {
    return 'De winkelwagenprijs is net opnieuw met Shopify gecontroleerd. Controleer de bijgewerkte winkelwagen en klik daarna opnieuw op checkout.';
  }

  if (raw.indexOf('MZ_STOCK_PRODUCT::') === 0) {
    try {
      var payload = JSON.parse(raw.slice('MZ_STOCK_PRODUCT::'.length));
      return mzBuildNamedStockError(payload.name, payload.wanted, payload.limit, payload.raw);
    } catch(e) {
      return mzBuildNamedStockError(mzMostLikelyStockItemName(null), (Array.isArray(cart) && cart.length ? cart[0].qty : null), null, raw);
    }
  }

  var parsedMessage = '';
  if (raw) {
    try {
      var parsed = JSON.parse(raw);
      parsedMessage = parsed.description || parsed.message || '';
    } catch(e) {
      parsedMessage = raw;
    }
  }
  var full = (parsedMessage || raw || '').replace(/\s+/g, ' ').trim();
  var lower = full.toLowerCase();
  var onlyMatch = full.match(/slechts\s+(\d+)/i) || full.match(/only\s+(\d+)/i) || full.match(/maximaal\s+(\d+)/i);
  if (lower.indexOf('beschikbaarheid') >= 0 || lower.indexOf('voorraad') >= 0 || lower.indexOf('sold out') >= 0 || lower.indexOf('not enough') >= 0 || lower.indexOf('422') >= 0 || lower.indexOf('available') >= 0 || lower.indexOf('slechts') >= 0) {
    if (onlyMatch && onlyMatch[1] && Array.isArray(cart)) {
      var limit = Math.max(0, parseInt(onlyMatch[1], 10) || 0);
      for (var i = 0; i < cart.length; i++) {
        var qty = Math.max(0, parseInt(cart[i] && cart[i].qty, 10) || 0);
        if (qty > limit) return mzBuildNamedStockError(mzCheckoutItemName(cart[i]), qty, limit, full);
      }
    }
    if (Array.isArray(cart) && cart.length === 1) {
      return mzBuildNamedStockError(mzCheckoutItemName(cart[0]), cart[0].qty, null, full);
    }
    return mzBuildNamedStockError(mzMostLikelyStockItemName(null), (Array.isArray(cart) && cart.length ? cart[0].qty : null), null, raw);
  }
  if (lower.indexOf('product niet gevonden') >= 0 || lower.indexOf('geen variant') >= 0) {
    return 'Dit product is nog niet goed gekoppeld aan Shopify. Kies een ander product of neem contact met ons op.';
  }
  if (lower.indexOf('leeg') >= 0) {
    return 'Je winkelwagen is leeg. Voeg eerst een product toe.';
  }
  return 'Checkout kan nog niet worden geopend. Controleer je winkelwagen en probeer opnieuw.';
}

function mzShowCartNotice(message, type) {
  type = type || 'error';
  var html = '<strong>Let op:</strong> ' + message;

  // Toon maximaal ÉÉN algemene cart-melding. In v33 werd dezelfde rode melding
  // bovenin én bij de checkoutknop getoond. Dat oogde dubbel en verwarrend.
  var topNotice = document.getElementById('mz-cart-notice');
  if (topNotice && topNotice.parentNode) topNotice.parentNode.removeChild(topNotice);

  var sticky = document.querySelector('#s-cart .cart-sticky') || document.querySelector('.cart-sticky');
  var targetId = sticky ? 'mz-cart-notice-sticky' : 'mz-cart-notice';
  var notice = document.getElementById(targetId);

  if (!notice) {
    notice = document.createElement('div');
    notice.id = targetId;
    if (sticky) {
      sticky.insertBefore(notice, sticky.firstChild);
    } else {
      var anchor = document.getElementById('cart-items');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(notice, anchor);
    }
  }

  if (notice) {
    notice.className = 'mz-cart-notice mz-cart-notice--' + type;
    notice.innerHTML = html;
    try { notice.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch(e) {}
  }
}

function mzClearCartNotice() {
  ['mz-cart-notice','mz-cart-notice-sticky'].forEach(function(id) {
    var notice = document.getElementById(id);
    if (notice && notice.parentNode) notice.parentNode.removeChild(notice);
  });
}

// ── Serialisatie van échte Shopify-cart mutaties ────────────────────────────
// Achtergrond-sync en checkout kunnen dezelfde echte Shopify-cart bijwerken.
// Deze lokale queue voert die mutaties strikt na elkaar uit, zodat een oudere
// achtergrond-sync nooit door een definitieve checkout-sync heen kan lopen.
var mzShopifyCartMutationQueue = Promise.resolve();
function mzWithShopifyCartLock(task) {
  var run = mzShopifyCartMutationQueue
    .catch(function(){})
    .then(function(){ return mzBrowserCartSessionReady; })
    .then(function(){ return task(); });
  // De keten mag nooit definitief breken op een rejectie, anders blijft alles hangen.
  mzShopifyCartMutationQueue = run.catch(function(){});
  return run;
}
// Zodra de klant afrekent mogen geen NIEUWE achtergrond-cart-mutaties meer starten.
// Dit blokkeert uitsluitend de Moozers-cart-syncs — nooit knoppen, links of navigatie.
var mzCheckoutInProgress = false;

function mzSyncDisplayCartToShopify(options) {
  options = options || {};
  if (!cart || cart.length === 0) {
    return (options.silent || options.background) ? Promise.resolve(false) : Promise.reject(new Error('Je winkelwagen is leeg.'));
  }
  // Voer de volledige muterende reeks (varianten oplossen → clear → add → teruglezen
  // → attributes) atomair uit via de gedeelde cart-lock.
  return mzWithShopifyCartLock(function(){ return mzSyncDisplayCartToShopifyLocked(options); });
}
function mzRealCartMatchesRequested(realCart, requestedLines) {
  if (!realCart || !Array.isArray(realCart.items) || !Array.isArray(requestedLines)) return false;
  var wanted = {};
  var actual = {};
  requestedLines.forEach(function(line) {
    if (!line || !line.id) return;
    var id = String(line.id);
    wanted[id] = (wanted[id] || 0) + Math.max(0, parseInt(line.quantity, 10) || 0);
  });
  realCart.items.forEach(function(line) {
    if (!line || !line.variant_id) return;
    var id = String(line.variant_id);
    actual[id] = (actual[id] || 0) + Math.max(0, parseInt(line.quantity, 10) || 0);
  });
  var wantedKeys = Object.keys(wanted).sort();
  var actualKeys = Object.keys(actual).filter(function(id){ return actual[id] > 0; }).sort();
  if (wantedKeys.length !== actualKeys.length) return false;
  for (var i = 0; i < wantedKeys.length; i++) {
    if (wantedKeys[i] !== actualKeys[i] || wanted[wantedKeys[i]] !== actual[actualKeys[i]]) return false;
  }
  return true;
}

function mzFetchRealShopifyCart() {
  return fetch('/cart.js', {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'Accept': 'application/json' }
  }).then(function(res) {
    if (!res.ok) throw new Error('Shopify cart kon niet worden gelezen.');
    return res.json();
  });
}

function mzAddRequestedLinesBatch(requestedLines) {
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      items: requestedLines.map(function(line) {
        return { id: line.id, quantity: line.quantity, properties: line.properties || {} };
      })
    })
  }).then(function(res) {
    if (res.ok) return res.json();
    return res.text().then(function(text) {
      var limit = mzCheckoutExtractStockLimitFromText(text);
      var errorLine = requestedLines[0] || null;
      if (limit != null) {
        for (var i = 0; i < requestedLines.length; i++) {
          if ((parseInt(requestedLines[i].quantity, 10) || 0) > limit) {
            errorLine = requestedLines[i];
            break;
          }
        }
      }
      mzThrowNamedStockError(errorLine, text || 'Shopify cart kon niet gevuld worden.', limit);
    });
  });
}

function mzSyncDisplayCartToShopifyLocked(options) {
  var requestedLines = [];
  var syncStartKey = '';
  if (typeof mzRepriceCartItems === 'function') mzRepriceCartItems();
  syncStartKey = (typeof mzCartLivePriceKey === 'function') ? mzCartLivePriceKey() : '';

  return Promise.all(cart.map(mzResolveShopifyVariant)).then(function(items) {
    items = (items || []).filter(function(item){ return !!item; });
    if (!items.length) throw new Error('Je winkelwagen is leeg.');
    requestedLines = mzCompressLineItems(items);

    // Fast path: de achtergrond-sync houdt de echte Shopify-cart normaal al gelijk.
    // Als varianten en aantallen exact kloppen, is clear/add overbodig en kan checkout
    // direct verder. Dit voorkomt ook een tijdelijk lege cart tijdens navigatie.
    return mzFetchRealShopifyCart();
  }).then(function(existingCart) {
    if (mzRealCartMatchesRequested(existingCart, requestedLines)) return existingCart;

    // Alleen bij een echte afwijking opnieuw opbouwen. Alle regels gaan in één
    // Shopify-request in plaats van één request per product.
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function(res) {
      if (!res.ok) throw new Error('Shopify cart kon niet worden bijgewerkt.');
      return mzAddRequestedLinesBatch(requestedLines);
    }).then(function() {
      return mzFetchRealShopifyCart();
    });
  }).then(function(realCart) {
    if (realCart && realCart.items && requestedLines.length) {
      var syncCurrentKey = (typeof mzCartLivePriceKey === 'function') ? mzCartLivePriceKey() : '';
      if (options.background && syncStartKey && syncCurrentKey !== syncStartKey) {
        return realCart || {};
      }
      for (var i = 0; i < requestedLines.length; i++) {
        var line = requestedLines[i];
        var actual = 0;
        realCart.items.forEach(function(realLine) {
          if (String(realLine.variant_id) === String(line.id)) {
            actual += Math.max(0, parseInt(realLine.quantity, 10) || 0);
          }
        });
        if (actual < line.quantity) {
          mzThrowNamedStockError(line, 'Shopify voegde minder toe dan gevraagd.', actual);
        }
      }
      var mzCartPriceUpdated = mzApplyShopifyCartPricesToDisplay(realCart, requestedLines, syncStartKey || syncCurrentKey);
      if (mzCartPriceUpdated && typeof renderCart === 'function') {
        try { renderCart(true); } catch(e) {}
      }
    }

    var attrs = (typeof mzCartAttributesForVat === 'function') ? mzCartAttributesForVat() : {};
    if (!attrs || !Object.keys(attrs).length) return realCart || {};
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: attrs,
        note: 'Belgisch BTW-nummer: ' + attrs['Belgisch BTW-nummer'] + ' — klant moet in Shopify Checkout het officiële BTW-veld invullen voor reverse charge.'
      })
    }).then(function(){ return realCart || {}; }).catch(function(){ return realCart || {}; });
  });
}

function goToLiveCheckout() {
  if (mzCheckoutInProgress) return;
  mzCheckoutInProgress = true;
  mzClearCartNotice();
  if (!cart || cart.length === 0) {
    mzCheckoutInProgress = false;
    showScreen('s-cart');
    mzShowCartNotice('Je winkelwagen is leeg. Voeg eerst een product toe.', 'warning');
    return;
  }

  // Sla de visuele cart vóór de externe checkoutnavigatie op. Bij teruggaan kan
  // dezelfde winkelwagen daardoor direct worden hersteld, ook na een full reload.
  mzPersistCartState();
  mzSetCheckoutLoading(true);

  // De geforceerde tweede product-prijssync was dubbel werk. De definitieve sync
  // hieronder leest de echte Shopify-cart en prijzen al, en gebruikt de fast path
  // wanneer varianten en aantallen al kloppen.
  mzSyncDisplayCartToShopify({ checkout:true })
    .then(function() {
      try { sessionStorage.setItem(MZ_CHECKOUT_RETURN_KEY, String(Date.now())); } catch(e) {}
      window.location.assign('/checkout');
    })
    .catch(function(err) {
      console.error('Moozers checkout sync failed:', err);
      mzCheckoutInProgress = false;
      mzSetCheckoutLoading(false);
      mzShowCartNotice(mzFriendlyCheckoutMessage(err), 'error');
      // Nooit de volledige echte cart wissen na een checkoutfout. De klant moet
      // aantallen kunnen corrigeren zonder dat terugnavigatie een lege cart toont.
    });
}



// ════════════════════════════════════════════════════════
//  CART DISPLAY PRICE SYNC
//  Haalt de echte Shopify-cartprijs al op bij openen/wijzigen van de winkelwagen,
//  zodat de prijs niet pas verandert wanneer de klant op afrekenen klikt.
// ════════════════════════════════════════════════════════
var mzDisplayCartShopifySyncState = { running:false, pending:false, timer:null, promise:null };

function mzCartDisplayNeedsShopifySync() {
  if (!Array.isArray(cart) || !cart.length) return false;
  var key = (typeof mzCartLivePriceKey === 'function') ? mzCartLivePriceKey() : '';
  for (var i = 0; i < cart.length; i++) {
    var item = cart[i];
    if (!item) continue;
    if (item._shopifyDisplaySynced !== true || item._shopifyDisplaySyncKey !== key || item._lineInclCents == null) return true;
  }
  return false;
}

function mzCartDisplayStockCheckInProgress() {
  return Array.isArray(cart) && cart.some(function(item){ return item && item._stockChecking; });
}

function mzSyncDisplayCartPricesNow(force) {
  if (mzCheckoutInProgress) return Promise.resolve(false);
  if (!Array.isArray(cart) || !cart.length) return Promise.resolve(false);
  if (!force && !mzCartDisplayNeedsShopifySync()) return Promise.resolve(false);
  if (mzCartDisplayStockCheckInProgress()) {
    mzScheduleDisplayCartShopifySync(350, !!force);
    return Promise.resolve(false);
  }
  if (mzDisplayCartShopifySyncState.running) {
    mzDisplayCartShopifySyncState.pending = true;
    return mzDisplayCartShopifySyncState.promise || Promise.resolve(false);
  }

  mzDisplayCartShopifySyncState.running = true;
  mzDisplayCartShopifySyncState.pending = false;

  var syncPromise = Promise.resolve()
    .then(function(){
      return (typeof mzSyncLivePricesForCart === 'function')
        ? mzSyncLivePricesForCart({ force:false }).catch(function(){ return false; })
        : false;
    })
    .then(function(){
      return (typeof mzSyncDisplayCartToShopify === 'function')
        ? mzSyncDisplayCartToShopify({ background:true, silent:true })
        : false;
    })
    .catch(function(err){
      // Geen popup tijdens achtergrondsync; checkout/voorraadcontrole tonen fouten indien nodig.
      // Verwijder ook geen geldige voorraadmelding; dit voorkomt alleen dat een oude
      // algemene koppelingsmelding blijft staan terwijl de cart opnieuw wordt berekend.
      try {
        var msg = err && err.message ? String(err.message).toLowerCase() : '';
        if ((msg.indexOf('product niet gevonden') >= 0 || msg.indexOf('geen variant') >= 0 || msg.indexOf('gekoppeld') >= 0) && typeof mzClearCartNotice === 'function') mzClearCartNotice();
      } catch(e) {}
      try { console.warn('Moozers cart display price sync skipped:', err); } catch(e) {}
      return false;
    })
    .then(function(result){
      mzDisplayCartShopifySyncState.running = false;
      mzDisplayCartShopifySyncState.promise = null;
      if (mzDisplayCartShopifySyncState.pending || mzCartDisplayNeedsShopifySync()) {
        mzDisplayCartShopifySyncState.pending = false;
        mzScheduleDisplayCartShopifySync(80, true);
      }
      return result;
    });
  mzDisplayCartShopifySyncState.promise = syncPromise;
  return syncPromise;
}

function mzScheduleDisplayCartShopifySync(delay, force) {
  if (mzCheckoutInProgress) return;
  if (!Array.isArray(cart) || !cart.length) return;
  if (mzDisplayCartShopifySyncState.timer) clearTimeout(mzDisplayCartShopifySyncState.timer);
  mzDisplayCartShopifySyncState.timer = setTimeout(function(){
    mzDisplayCartShopifySyncState.timer = null;
    mzSyncDisplayCartPricesNow(!!force);
  }, delay == null ? 120 : delay);
}

function mzSetImg(el, src, alt) {
  if (!el) return;
  if (el.parentElement) el.parentElement.classList.remove('mz-img-missing');
  el.style.visibility = '';
  el.style.opacity = '1';
  el.removeAttribute('data-mz-retried');
  el.src = src || '';
  if (alt !== undefined) el.alt = alt || '';
}


// Active staffel tiers: variant-specific (50mm) or product default
function getActiveTiers() {
  if (currentProduct && currentProduct.noStaffel) return [];
  return (cv && cv.staffelTiers) ? cv.staffelTiers : (currentProduct && currentProduct.staffelTiers ? currentProduct.staffelTiers : []);
}

function getTierDiscount(q) {
  var tiers = getActiveTiers();
  for (var i = tiers.length - 1; i >= 0; i--) {
    if (q >= tiers[i].min) return tiers[i].discount;
  }
  return 0;
}


// Staffelprijzen worden altijd berekend vanaf de actuele Shopify-verkoopprijs
// van de geselecteerde variant. Vergelijkingsprijzen worden nooit als basis gebruikt.
function mzIsLooseTapeProduct(product) {
  return !!product && (product.id === 'washi-tape' || product.id === 'washi-tape-paars');
}

function mzStaffelQuoteForQty(variant, quantity, discount) {
  quantity = Math.max(1, parseInt(quantity, 10) || 1);
  discount = Math.max(0, Math.min(1, parseFloat(discount) || 0));
  var baseInclCents = mzToCents(mzInclFloatFromVariant(variant, variant && variant.priceExcl));
  var lineInclCents = Math.round(baseInclCents * quantity * (1 - discount));
  var lineExclCents = mzInclToExclCents(lineInclCents);
  return {
    quantity: quantity,
    discount: discount,
    baseInclCents: baseInclCents,
    lineInclCents: lineInclCents,
    lineExclCents: lineExclCents,
    unitInclCents: Math.round(lineInclCents / quantity),
    unitExclCents: Math.round(lineExclCents / quantity)
  };
}

function mzRelatedBoxVariants(product, variant) {
  if (!mzIsLooseTapeProduct(product) || !variant) return [];
  var meta = mzLooseTapeMeta(product, variant);
  var boxesProduct = CATALOG['dozen-tape'];
  if (!meta || !boxesProduct || !Array.isArray(boxesProduct.variants)) return [];
  return boxesProduct.variants.filter(function(box) {
    return mzNormaliseKleur(box.kleur) === mzNormaliseKleur(meta.kleur)
      && String(box.breedte) === String(meta.breedte);
  });
}

function mzHasRelatedBoxQuantity(product, variant, quantity) {
  quantity = Math.max(1, parseInt(quantity, 10) || 1);
  return mzRelatedBoxVariants(product, variant).some(function(box) {
    return Math.max(0, parseInt(box.inhoud, 10) || 0) === quantity;
  });
}

var mzRelatedBoxPricePromises = {};
function mzSyncRelatedBoxPricesForVariant(product, variant) {
  if (!variant || !mzIsLooseTapeProduct(product)) {
    if (variant) variant._staffelPriceStatus = 'loaded';
    return Promise.resolve(true);
  }

  var related = mzRelatedBoxVariants(product, variant);
  if (!related.length) {
    variant._staffelPriceStatus = 'loaded';
    return Promise.resolve(true);
  }

  var key = String(product.id || '') + '|' + String(variant.size || variant.label || '');
  if (mzRelatedBoxPricePromises[key]) return mzRelatedBoxPricePromises[key];
  variant._staffelPriceStatus = 'loading';

  var tasks = related.map(function(boxVariant) {
    var boxesProduct = CATALOG['dozen-tape'];
    var handle = mzBuildShopifyHandle(boxesProduct, boxVariant);
    if (!handle) return Promise.resolve(false);
    return mzFetchShopifyProduct(handle).then(function(shopProduct) {
      var shopVariant = mzFindShopifyVariant(shopProduct, boxVariant.size || boxVariant.label || boxVariant.title || '');
      if (!shopVariant && shopProduct && Array.isArray(shopProduct.variants)) shopVariant = shopProduct.variants[0] || null;
      var cents = mzShopifyVariantPriceCents(shopVariant);
      if (!shopVariant || !cents) return false;
      mzApplyInclCentsToCatalogVariant(boxVariant, cents);
      boxVariant.inStock = shopVariant.available !== false;
      boxVariant.stockStatus = 'loaded';
      if (shopVariant.id) boxVariant.variantId = String(shopVariant.id);
      boxVariant._saleBadge = mzSaleFromShopifyVariant(shopVariant);
      boxVariant.compareAtInclCents = shopVariant.compare_at_price ? Math.round(Number(shopVariant.compare_at_price) || 0) : 0;
      return true;
    }).catch(function() {
      boxVariant.stockStatus = 'error';
      return false;
    });
  });

  var promise = Promise.all(tasks).then(function(results) {
    var allReady = results.every(function(result){ return result === true; });
    variant._staffelPriceStatus = allReady ? 'loaded' : 'error';
    delete mzRelatedBoxPricePromises[key];
    return allReady;
  }).catch(function() {
    variant._staffelPriceStatus = 'error';
    delete mzRelatedBoxPricePromises[key];
    return false;
  });
  mzRelatedBoxPricePromises[key] = promise;
  return promise;
}

// ════════════════════════════════════════════════════════
//  DOZEN PICKER — 3-step kleur × breedte × inhoud
// ════════════════════════════════════════════════════════
function dozenUniqueBreedtes(kleur) {
  var seen = {}, result = [];
  currentProduct.variants.forEach(function(v) {
    if (v.kleur === kleur && !seen[v.breedte]) { seen[v.breedte] = true; result.push(v.breedte); }
  });
  return result;
}
function dozenUniqueInhouds(kleur, breedte) {
  var seen = {}, result = [];
  currentProduct.variants.forEach(function(v) {
    if (v.kleur === kleur && v.breedte === breedte && !seen[v.inhoud]) { seen[v.inhoud] = true; result.push(v.inhoud); }
  });
  return result;
}
// Centrale doosvariant-resolver: kleur + breedte + inhoud = exacte variant.
// Type-veilig (breedte als string, inhoud als getal) zodat een geldige combinatie
// nooit mist door een type-verschil. Zolang de exacte combinatie bestaat wordt
// nooit op een andere variant teruggevallen; alleen wanneer een combinatie echt
// niet bestaat wordt de dichtstbijzijnde geldige optie gekozen.
function findDozenVariant(kleur, breedte, inhoud) {
  var p = currentProduct;
  if (!p || !Array.isArray(p.variants)) return null;
  var dozen = p.variants.filter(function(v){ return v && v.kleur != null; });
  if (!dozen.length) return null;
  var K = String(kleur), B = String(breedte), I = parseInt(inhoud, 10);

  // 1) Exacte match.
  for (var i = 0; i < dozen.length; i++) {
    var v = dozen[i];
    if (String(v.kleur) === K && String(v.breedte) === B && parseInt(v.inhoud, 10) === I) return v;
  }
  // 2) Combinatie bestaat niet → dichtstbijzijnde inhoud binnen kleur+breedte.
  var sameKB = dozen.filter(function(v){ return String(v.kleur) === K && String(v.breedte) === B; });
  if (sameKB.length) {
    sameKB.sort(function(a, b){ return Math.abs(parseInt(a.inhoud,10) - I) - Math.abs(parseInt(b.inhoud,10) - I); });
    return sameKB[0];
  }
  // 3) Anders eerste geldige variant binnen de kleur.
  var sameK = dozen.filter(function(v){ return String(v.kleur) === K; });
  if (sameK.length) return sameK[0];
  // 4) Laatste redmiddel: standaardvariant.
  return p.variants[p.defaultVariantIndex] || dozen[0];
}

function setDozenCV() {
  var found = findDozenVariant(dozenKleur, dozenBreedte, dozenInhoud);
  if (!found) return;
  cv = found;
  // Globals synchroon zetten met de daadwerkelijk geselecteerde variant (enige bron
  // van waarheid), zodat pillen, titel, prijs, afbeelding, voorraad en Add to Cart
  // nooit uiteenlopen.
  dozenKleur   = found.kleur;
  dozenBreedte = found.breedte;
  dozenInhoud  = found.inhoud;
  document.getElementById('p-name').textContent       = cv.title;
  mzRenderProductPrice(currentProduct, cv);
  mzSetImg(document.getElementById('main-img'), imgUrl(cv), cv.title);
  // Ook dozenvarianten gebruiken uitsluitend de actuele Shopify-voorraad.
  cv.stockStatus = 'loading';
  mzSetActiveStockUi(cv);
  mzSyncProductStockStatus(currentProduct);
  document.getElementById('v-label-prefix').textContent = 'Samenstelling';
  document.getElementById('v-label').textContent = cv.label;
  // Actieve kleur-, breedte- en inhoud-pil altijd afstemmen op de gekozen variant.
  renderDozenColorRow();
  renderDozenBreedteRow();
  renderDozenInhoudRow();
  qty = 1;
  mzSetProductQtyDisplay(1);
  updateCtaPrice();
}
function renderDozenColorRow() {
  var html = '';
  ['Geel', 'Paars'].forEach(function(k) {
    var dot = '';
    html += '<button class="dozen-color-btn' + (k === dozenKleur ? ' active' : '') + '" onclick="selectDozenKleur(\'' + k + '\',this)">' + dot + ' ' + k + '</button>';
  });
  document.getElementById('dozen-color-row').innerHTML = html;
}
function renderDozenBreedteRow() {
  var allBreedtes = ['19', '24', '36', '50'];
  var valid = dozenUniqueBreedtes(dozenKleur);
  var html = '';
  allBreedtes.forEach(function(b) {
    var ok  = valid.indexOf(b) !== -1;
    var cls = 'dozen-breedte-pill' + (ok && b === dozenBreedte ? ' active' : '') + (!ok ? ' oos' : '');
    var oc  = ok ? ' onclick="selectDozenBreedte(\'' + b + '\',this)"' : '';
    html += '<div class="' + cls + '"' + oc + '>' + b + 'mm</div>';
  });
  document.getElementById('dozen-breedte-row').innerHTML = html;
}
function renderDozenInhoudRow() {
  var inhouds = dozenUniqueInhouds(dozenKleur, dozenBreedte);
  var html = '';
  inhouds.forEach(function(inh) {
    html += '<div class="dozen-inhoud-pill' + (inh === dozenInhoud ? ' active' : '') + '" onclick="selectDozenInhoud(' + inh + ',this)">' + inh + ' rollen</div>';
  });
  document.getElementById('dozen-inhoud-row').innerHTML = html;
}
function renderDozenPicker() {
  var p  = currentProduct;
  // Klantselectie is leidend: leid de huidige samenstelling af uit cv (enige bron
  // van waarheid). Zo zet een her-render — bijvoorbeeld door een asynchrone
  // voorraad- of prijsupdate die renderVariantGrid opnieuw aanroept — de keuze
  // nooit terug naar de standaardvariant. Alleen wanneer cv (nog) geen doosvariant
  // van dit product is, initialiseren we één keer vanaf de standaardvariant.
  var sel = (cv && p.variants.indexOf(cv) !== -1 && cv.kleur != null) ? cv : p.variants[p.defaultVariantIndex];
  dozenKleur   = sel.kleur;
  dozenBreedte = sel.breedte;
  dozenInhoud  = sel.inhoud;
  document.getElementById('variant-section').style.display = 'block';
  document.getElementById('v-label-prefix').textContent = 'Samenstelling';
  document.getElementById('v-label').textContent = sel.label;
  document.getElementById('variant-grid').innerHTML =
    '<div class="dozen-step"><div class="dozen-step-label">Kleur</div><div class="dozen-color-row" id="dozen-color-row"></div></div>' +
    '<div class="dozen-step"><div class="dozen-step-label">Breedte</div><div class="dozen-breedte-row" id="dozen-breedte-row"></div></div>' +
    '<div class="dozen-step"><div class="dozen-step-label">Inhoud</div><div class="dozen-inhoud-row" id="dozen-inhoud-row"></div></div>';
  document.getElementById('variant-grid').style.gridTemplateColumns = '1fr';
  renderDozenColorRow();
  renderDozenBreedteRow();
  renderDozenInhoudRow();
}
function selectDozenKleur(kleur, el) {
  dozenKleur = kleur;
  document.querySelectorAll('.dozen-color-btn').forEach(function(b) { b.classList.remove('active'); });
  el.classList.add('active');
  var vb = dozenUniqueBreedtes(kleur);
  if (vb.indexOf(dozenBreedte) === -1) dozenBreedte = vb[0];
  var vi = dozenUniqueInhouds(kleur, dozenBreedte);
  if (vi.indexOf(dozenInhoud) === -1) dozenInhoud = vi[0];
  renderDozenBreedteRow();
  renderDozenInhoudRow();
  setDozenCV();
}
function selectDozenBreedte(breedte, el) {
  dozenBreedte = breedte;
  document.querySelectorAll('.dozen-breedte-pill').forEach(function(b) { b.classList.remove('active'); });
  el.classList.add('active');
  var vi = dozenUniqueInhouds(dozenKleur, breedte);
  if (vi.indexOf(dozenInhoud) === -1) dozenInhoud = vi[0];
  renderDozenInhoudRow();
  setDozenCV();
}
function selectDozenInhoud(inhoud, el) {
  dozenInhoud = inhoud;
  document.querySelectorAll('.dozen-inhoud-pill').forEach(function(b) { b.classList.remove('active'); });
  el.classList.add('active');
  setDozenCV();
}

// ════════════════════════════════════════════════════════
//  LOAD PRODUCT — switches the entire product screen
// ════════════════════════════════════════════════════════
function loadProductVariant(id, size) {
  loadProduct(id);
  // v82: selecteer de gewenste variant direct en exact.
  // Voorheen werd eerst de standaardvariant geladen (bij Washi geel = 24mm),
  // waardoor klikken op 19/36/50mm vanuit de collectie soms toch op 24mm uitkwam.
  var wanted = String(size == null ? '' : size).toLowerCase().replace(/\s+/g, '').replace('mm','');
  if (!currentProduct || !currentProduct.variants || !wanted) return;

  var idx = -1;
  for (var i = 0; i < currentProduct.variants.length; i++) {
    var v = currentProduct.variants[i] || {};
    var candidates = [v.size, v.label, v.title].map(function(x){
      return String(x == null ? '' : x).toLowerCase().replace(/\s+/g, '').replace('mm','');
    });
    if (candidates.indexOf(wanted) !== -1) {
      idx = i;
      break;
    }
  }

  if (idx >= 0) {
    var pills = document.querySelectorAll('#variant-grid .vpill');
    if (pills[idx] && typeof selectV === 'function') selectV(pills[idx], idx);
  }
}

function loadProduct(id) {
  var p = CATALOG[id];
  if (!p) return;
  currentProduct = p;
  qty = 1;
  cv  = p.variants[p.defaultVariantIndex];

  // Ann bar
  document.getElementById('ann-bar').innerHTML =
    '★★★★★ ' + p.reviewScore + ' &nbsp;·&nbsp; ' + p.reviewCount + ' beoordelingen &nbsp;·&nbsp; Getest door vaklieden';

  // Main product info
  document.getElementById('p-name').textContent       = cv.title;
  // Prijs en voorraad worden altijd eerst live uit Shopify opgehaald. Zet alle
  // varianten vóór de eerste render op loading, zodat geen oude fallbackprijs flitst.
  p.variants.forEach(function(variant) {
    variant.stockStatus = 'loading';
    variant._staffelPriceStatus = mzIsLooseTapeProduct(p) ? 'loading' : 'loaded';
  });
  mzRenderProductPrice(currentProduct, cv);
  mzSetImg(document.getElementById('main-img'), imgUrl(cv), cv.title);
  mzSetActiveStockUi(cv);
  document.getElementById('r-score').textContent      = p.reviewScore;
  document.getElementById('r-count').textContent      = p.reviewCount + ' beoordelingen ↓';
  document.getElementById('rev-num-big').textContent  = p.reviewScore;
  mzSetProductQtyDisplay(1);

  // Cart trust score in cart header
  var tpEl = document.getElementById('cart-tp-score');
  if (tpEl) tpEl.textContent = '★ ' + p.reviewScore + ' · ' + p.reviewCount + ' reviews';

  renderVariantGrid();
  mzSyncProductStockStatus(currentProduct); // v87: voorraadstatus live bijwerken
  renderStaffelPills();
  renderUSPs();
  renderSpecs();
  renderReviews();
  renderCrossSells();
  renderImgDots();
  updateCtaPrice();
  closeNav();
  showScreen('s-product');
}

// ── Variant grid ───────────────────────────────────────
function renderVariantGrid() {
  var p    = currentProduct;
  var grid = document.getElementById('variant-grid');
  var sect = document.getElementById('variant-section');

  // Dozen products use a custom 3-step picker
  if (p.variantType === 'dozen') { renderDozenPicker(); return; }

  // Apex Mesh Rond (150mm + 125mm): 2D-picker maat × korrel in bestaande variant-section
  if (p.variantType === 'mesh-rond') {
    sect.style.display = 'block';
    grid.style.gridTemplateColumns = '1fr';
    var vLblPfx = document.getElementById('v-label-prefix');
    var vLbl    = document.getElementById('v-label');
    if (vLblPfx) vLblPfx.textContent = 'Maat & korrel';
    if (vLbl)    vLbl.textContent    = _meshMaat + ' · ' + _meshKorrel;

    var maats = []; // unieke maats in volgorde
    p.variants.forEach(function(v){ if (maats.indexOf(v.maat) < 0) maats.push(v.maat); });
    var geldigeKorrels = _meshKorrelForMaat(p, _meshMaat);

    var h = '<div style="margin-bottom:12px;">'
          + '<div style="font-size:12px;font-weight:600;margin-bottom:6px;">'
          + 'Maat: <strong>' + _meshMaat + '</strong></div>'
          + '<div style="display:grid;grid-template-columns:repeat(' + maats.length + ',1fr);gap:6px;">';
    maats.forEach(function(m) {
      h += '<div class="vpill' + (m === _meshMaat ? ' active' : '') + '" onclick="selectMeshMaat(\'' + m + '\')">' + m + '</div>';
    });
    h += '</div></div>'
       + '<div><div style="font-size:12px;font-weight:600;margin-bottom:6px;">'
       + 'Korrel: <strong>' + _meshKorrel + '</strong></div>'
       + '<div style="display:grid;grid-template-columns:repeat(' + geldigeKorrels.length + ',1fr);gap:6px;">';
    geldigeKorrels.forEach(function(k) {
      var vv = _meshFindVariant(p, _meshMaat, k);
      var oos = vv && vv.stockStatus === 'loaded' && !vv.inStock; // v13: oos alleen na bevestigd laden
      h += '<div class="vpill' + (k === _meshKorrel ? ' active' : '') + (oos ? ' oos' : '')
         + '" onclick="selectMeshKorrel(\'' + k + '\')">' + k + '</div>';
    });
    h += '</div></div>';
    grid.innerHTML = h;
    return;
  }

  // Apex Mesh 80×133mm: 1D korrel-picker in bestaande variant-section
  if (p.variantType === 'mesh-vierkant') {
    sect.style.display = 'block';
    grid.style.gridTemplateColumns = '1fr';
    var vLblPfx2 = document.getElementById('v-label-prefix');
    var vLbl2    = document.getElementById('v-label');
    if (vLblPfx2) vLblPfx2.textContent = 'Korrel';
    if (vLbl2)    vLbl2.textContent    = _meshKorrel;

    var korrels80 = [];
    p.variants.forEach(function(v){ if (korrels80.indexOf(v.korrel) < 0) korrels80.push(v.korrel); });

    var h2 = '<div style="display:grid;grid-template-columns:repeat(' + korrels80.length + ',1fr);gap:6px;">';
    korrels80.forEach(function(k) {
      var vv = _meshFindVariant(p, '80×133mm', k);
      var oos = vv && vv.stockStatus === 'loaded' && !vv.inStock; // v13: oos alleen na bevestigd laden
      h2 += '<div class="vpill' + (k === _meshKorrel ? ' active' : '') + (oos ? ' oos' : '')
          + '" onclick="selectMeshKorrel(\'' + k + '\')">' + k + '</div>';
    });
    h2 += '</div>';
    grid.innerHTML = h2;
    return;
  }

  // Hide if only one variant
  if (p.variants.length <= 1) {
    sect.style.display = 'none';
    return;
  }
  sect.style.display = 'block';

  // Responsive column count
  var cols = Math.min(4, p.variants.length);
  grid.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';

  // Update label
  document.getElementById('v-label-prefix').textContent = p.variantLabel;
  document.getElementById('v-label').textContent = cv.label;

  var html = '';
  p.variants.forEach(function(v, idx) {
    var isActive = (v === cv);
    var state    = mzVariantStockState(v);
    var isOos    = state === 'loaded' && !v.inStock;
    var cls      = 'vpill' + (isActive ? ' active' : '') + (isOos ? ' oos' : '');
    var onclick  = isOos ? '' : ' onclick="selectV(this,' + idx + ')"';
    var pillText = p.variantUnit ? (v.size + p.variantUnit) : v.size;
    html += '<div class="' + cls + '"' + onclick + '>';
    html += '<div class="vpill-mm">' + pillText + '</div>';
    if (isOos) {
      html += '<div class="vpill-oos-label">Uitverkocht</div>';
    } else if (state !== 'loaded') {
      html += '<div class="vpill-price mz-price-pending" aria-hidden="true">&nbsp;</div>';
    } else {
      html += '<div class="vpill-price">' + fmt(v.priceExcl) + '</div>';
    }
    html += '</div>';
  });
  grid.innerHTML = html;
}

// ── Image dots ─────────────────────────────────────────
function mzProductMediaUrl(variant, mediaIndex) {
  if (!variant) return '';
  var media = (Array.isArray(variant.imgs) && variant.imgs.length)
    ? variant.imgs[mediaIndex || 0]
    : variant.img;
  if (!media) return '';
  return imgUrl({ img:media, imgV:variant.imgV });
}

function renderImgDots() {
  var p    = currentProduct;
  var dots = document.getElementById('img-dots');
  if (!dots) return;

  var media = (cv && Array.isArray(cv.imgs))
    ? cv.imgs.filter(function(x){ return x; })
    : [];

  // Eén productvariant kan meerdere eigen foto's hebben, zoals de nieuwe
  // Joint Mesh Gaasband. Toon dan fotopaginatie zonder een nep-variantwissel.
  if (media.length > 1) {
    dots.style.display = 'flex';
    dots.innerHTML = media.map(function(_, idx) {
      return '<div class="img-dot' + (idx === 0 ? ' active' : '') + '" onclick="setProductMedia(' + idx + ',this)"></div>';
    }).join('');
    return;
  }

  if (!p || p.variants.length <= 1 || p.variantType === 'dozen') {
    dots.style.display = 'none';
    dots.innerHTML = '';
    return;
  }
  dots.style.display = 'flex';
  var html = '';
  p.variants.forEach(function(v, idx) {
    var isActive = (v === cv);
    html += '<div class="img-dot' + (isActive ? ' active' : '') + '" onclick="setImg(' + idx + ',this)"></div>';
  });
  dots.innerHTML = html;
}

function setProductMedia(idx, dot) {
  document.querySelectorAll('#img-dots .img-dot').forEach(function(d){ d.classList.remove('active'); });
  if (dot) dot.classList.add('active');
  var url = mzProductMediaUrl(cv, idx);
  if (url) mzSetImg(document.getElementById('main-img'), url, cv.title || currentProduct.name || '');
}

function setImg(idx, dot) {
  document.querySelectorAll('#img-dots .img-dot').forEach(function(d){ d.classList.remove('active'); });
  if (dot) dot.classList.add('active');
  var v = currentProduct.variants[idx];
  if (v) mzSetImg(document.getElementById('main-img'), imgUrl(v), v.title || currentProduct.name || '');
}

// ── Staffelkorting pills ──────────────────────────────────────────────────
function renderStaffelPills() {
  var staffelBlock = document.querySelector('.staffel-block');
  var container = document.getElementById('staffel-pills');
  var tiers = getActiveTiers();
  var hasVisibleStaffel = tiers && tiers.some(function(tier){ return tier && tier.discount > 0; });

  // Staffelprijzen mogen pas worden berekend nadat de actuele Shopify-basisprijs
  // van de gekozen variant geladen is. Tot die tijd tonen we geen oude bedragen.
  if (!cv || mzVariantStockState(cv) !== 'loaded' || (mzIsLooseTapeProduct(currentProduct) && cv._staffelPriceStatus !== 'loaded')) {
    if (staffelBlock) staffelBlock.style.display = 'none';
    if (container) container.innerHTML = '';
    return;
  }

  // Verberg het volledige staffelkortingblok bij producten zonder echte korting,
  // zoals ronde schuurschijven en losse schuurpapier-dozen.
  if (currentProduct && (currentProduct.variantType === 'dozen' || currentProduct.noStaffel || !hasVisibleStaffel)) {
    if (staffelBlock) staffelBlock.style.display = 'none';
    if (container) container.innerHTML = '';
    return;
  }

  if (staffelBlock) staffelBlock.style.display = '';
  var p         = cv.priceExcl;
  var unit      = currentProduct.unit || 'stuks';
  if (!container) return;

  var html = '';
  // De actieve pil wordt afgeleid van de huidige hoeveelheid (qty = enige bron
  // van waarheid). Zo zet een her-render door een asynchrone voorraad- of
  // prijsupdate nooit de verkeerde staffel terug en blijft de selectie synchroon
  // met hoeveelheid, prijs en Add to Cart.
  var qNow = Math.max(1, parseInt(qty, 10) || 1);
  var activeIdx = 0;
  for (var ai = tiers.length - 1; ai >= 0; ai--) {
    if (qNow >= tiers[ai].min) { activeIdx = ai; break; }
  }
  tiers.forEach(function(tier, idx) {
    // De staffelkaart toont de prijs die voor het volledige aangegeven bereik
    // geldt. Een losse doosprijs wordt hier bewust niet over een heel bereik
    // uitgesmeerd; die wordt alleen bij het exacte doosaantal in de CTA gebruikt.
    var quote = mzStaffelQuoteForQty(cv, tier.min, tier.discount);
    var rangeLabel = (tier.max >= 900)
      ? '≥ ' + tier.min + ' ' + unit
      : tier.min + ' – ' + tier.max + ' ' + unit;
    var discBadge  = tier.discount > 0
      ? '<span class="stp-disc">−' + Math.round(tier.discount * 100) + '%</span>'
      : '';
    var isActive   = (idx === activeIdx);
    html += '<div class="staffel-pill' + (isActive ? ' active' : '') + '"';
    html += ' id="staffel-pill-' + (idx + 1) + '"';
    html += ' onclick="setTierFromPill(' + tier.min + ')">';
    html += '<span class="stp-range">' + rangeLabel + '</span>';
    html += '<span class="stp-price">' + mzFormatCents(quote.unitExclCents) + ' excl.</span>';
    if (discBadge) html += discBadge;
    html += '</div>';
  });
  container.innerHTML = html;
}

function syncStaffelPills(q) {
  var tiers     = getActiveTiers();
  var activeIdx = 0;
  for (var i = tiers.length - 1; i >= 0; i--) {
    if (q >= tiers[i].min) { activeIdx = i; break; }
  }
  tiers.forEach(function(tier, i) {
    var pill = document.getElementById('staffel-pill-' + (i + 1));
    if (pill) pill.className = 'staffel-pill' + (i === activeIdx ? ' active' : '');
  });
}

function setTierFromPill(val) {
  qty = val;
  mzSetProductQtyDisplay(qty);
  syncStaffelPills(qty);
  updateCtaPrice();
}

// ── Staffel compat shim (highlightStaffelRow → syncStaffelPills) ─────────────
function highlightStaffelRow(q) { syncStaffelPills(q); }

// One-tap tier selector
function setTier(minQty) {
  qty = minQty;
  mzSetProductQtyDisplay(qty);
  syncStaffelPills(qty);
  updateCtaPrice();
}

// ── USPs ───────────────────────────────────────────────
function renderUSPs() {
  var html = '';
  currentProduct.usps.forEach(function(usp) {
    html += '<div class="inline-usp"><span class="inline-usp-check">✅</span> ' + usp + '</div>';
  });
  document.getElementById('usps-container').innerHTML = html;
}

// ── Specs ──────────────────────────────────────────────
function renderSpecs() {
  var p = currentProduct || {};
  var descEl = document.getElementById('product-desc');
  if (descEl) {
    var desc = p.description || '';
    if (!desc) {
      if (p.id === 'washi-tape' || p.id === 'washi-tape-paars') desc = 'Professionele Washi Tape voor strakke verfranden bij schilderwerk. Geschikt voor vakmensen die snel en netjes willen afplakken.';
      else if (p.id === 'dozen-tape') desc = 'Grootverpakking Washi Tape voor schildersbedrijven en teams die vaste voorraad willen aanhouden.';
      else if (p.id === 'maskeerfolie') desc = 'Maskeerfolie voor snel en schoon afdekken bij schilder- en spuitwerk.';
      else if (p.id === 'maskeerpapier') desc = 'Maskeerpapier helpt oppervlakken tijdens schilderwerk te beschermen tegen verfspetters, lakspetters en lichte vervuiling. Geschikt voor het afdekken van kozijnen, ramen, deuren, plinten en andere delen rondom het werkgebied. Eenvoudig op maat te snijden en in combinatie met Washi Tape snel vast te zetten.';
      else if (p.id === 'schuurpapier' || p.id === 'schuurpad') desc = 'Schuurmateriaal voor professioneel voorbereiden, egaliseren en afwerken van ondergronden.';
      else desc = 'Professioneel product voor vakmensen en serieuze klussers.';
    }
    if (p.descriptionHtml) descEl.innerHTML = p.descriptionHtml;
    else descEl.textContent = desc;
    descEl.style.display = 'block';
  }
  var listEl = document.getElementById('specs-list');
  if (listEl) {
    listEl.innerHTML = (p.specs || []).map(function(s){ return '<li>' + s + '</li>'; }).join('');
  }
  var noteEl = document.getElementById('specs-note');
  if (noteEl) {
    if (p.specsNote) {
      noteEl.textContent = p.specsNote;
      noteEl.style.display = 'block';
    } else {
      noteEl.textContent = '';
      noteEl.style.display = 'none';
    }
  }
}

// ── Reviews ────────────────────────────────────────────
function renderReviews() {
  var html = '';
  var reviewsSection = document.getElementById('reviews-section');
  var reviews = (currentProduct && Array.isArray(currentProduct.reviews)) ? currentProduct.reviews : [];
  if (!reviews.length) {
    if (reviewsSection) reviewsSection.style.display = 'none';
    document.getElementById('reviews-list').innerHTML = '';
    return;
  }
  if (reviewsSection) reviewsSection.style.display = '';
  reviews.forEach(function(rev) {
    html += '<div class="rev-card">';
    html += '<div class="rev-card-top">';
    html += '<span style="color:var(--orange);font-size:12px;">' + stars(rev.stars) + '</span>';
    html += '<span class="rev-card-name">' + rev.name + '</span>';
    html += '<span class="rev-card-verified">✅ Geverifieerd</span>';
    html += '</div>';
    html += '<div class="rev-card-text">' + rev.text + '</div>';
    html += '<div class="rev-date">' + rev.date + ' · Geverifieerde aankoop</div>';
    html += '</div>';
  });
  document.getElementById('reviews-list').innerHTML = html;
}

// ── Cross-sells ────────────────────────────────────────
function renderCrossSells() {
  var html = '';
  currentProduct.crossSells.forEach(function(cs, csIndex) {
    var addCall = "event.preventDefault();event.stopPropagation();"
      + "quickAdd('" + cs.fullTitle.replace(/'/g, "\\'") + "','"
      + cs.label.replace(/'/g, "\\'") + "','"
      + cs.img + "','"
      + cs.imgV + "',"
      + cs.priceExcl + ","
      + cs.priceIncl + ",'"
      + cs.label.replace(/'/g, "\\'") + "')";
    html += '<a class="cross-card" data-mz-cross-index="' + csIndex + '" href="' + cs.link + '">';
    html += '<div class="cross-img-wrap">';
    html += '<img class="cross-img" src="' + IMG_BASE + cs.img + '?v=' + cs.imgV + '" alt="' + cs.name + '" onerror="this.parentElement.innerHTML=\'<div class=cross-img-placeholder>📦</div>\'">';
    html += '</div>';
    html += '<div class="cross-stars">★★★★★</div>';
    html += '<div class="cross-name">' + cs.name + '</div>';
    html += '<div class="cross-price mz-price-pending" aria-hidden="true">&nbsp;</div><div class="cross-price-incl mz-price-pending" aria-hidden="true" style="font-size:10px;color:var(--muted);margin-top:1px;">&nbsp;</div>';
    html += '<button class="cross-add mz-pending-control" disabled aria-hidden="true">+ Toevoegen</button>';
    html += '</a>';
  });
  document.getElementById('cross-container').innerHTML = html;
  setTimeout(function(){ try { mzSyncCrossSellPrices(); } catch(e) {} }, 0);
}

function mzSyncCrossSellPrices() {
  if (!currentProduct || !Array.isArray(currentProduct.crossSells)) return;
  var nodes = document.querySelectorAll('#cross-container .cross-card[data-mz-cross-index]');
  Array.prototype.forEach.call(nodes, function(node, index){
    var csIndex = parseInt(node.getAttribute('data-mz-cross-index'), 10);
    var cs = currentProduct.crossSells[csIndex];
    if (!cs) return;
    var handle = mzProductHandleFromHref(cs.link || '') || mzInferShopifyHandle(cs.fullTitle || cs.name, cs.label || cs.name, cs.img);
    if (!handle) return;
    var priceEl = node.querySelector('.cross-price');
    var inclEl = node.querySelector('.cross-price-incl');
    var badgeEl = mzEnsureSaleBadgeBefore(priceEl, 'mz-sale-badge-card');
    mzRunSaleBadgeLater(function(){
      return mzFetchShopifyProduct(handle).then(function(shopProduct){
        var summary = mzShopifyProductPriceSummary(shopProduct, cs.label || cs.name || '');
        if (!summary) return null;
        cs.priceIncl = summary.priceInclCents / 100;
        cs.priceExcl = summary.priceExclCents / 100;
        if (priceEl) { priceEl.classList.remove('mz-price-pending'); priceEl.removeAttribute('aria-hidden'); priceEl.innerHTML = mzFormatCents(summary.priceExclCents) + ' <span class="cross-vat">excl. BTW</span>'; }
        if (inclEl) { inclEl.classList.remove('mz-price-pending'); inclEl.removeAttribute('aria-hidden'); inclEl.textContent = mzFormatCents(summary.priceInclCents) + ' incl. BTW'; }
        mzSetSaleBadgeElement(badgeEl, mzSaleFromShopifyVariant(summary.variant));
        var btn = node.querySelector('.cross-add');
        if (btn) {
          var addCall = 'event.preventDefault();event.stopPropagation();quickAdd(' +
            JSON.stringify(cs.fullTitle) + ',' + JSON.stringify(cs.label) + ',' +
            JSON.stringify(cs.img) + ',' + JSON.stringify(cs.imgV || '') + ',' +
            cs.priceExcl + ',' + cs.priceIncl + ',' + JSON.stringify(cs.label) + ')';
          btn.disabled = false;
          btn.classList.remove('mz-pending-control');
          btn.removeAttribute('aria-hidden');
          btn.textContent = '+ Toevoegen';
          btn.setAttribute('onclick', addCall);
        }
        return summary;
      }).catch(function(){ return null; });
    }, index * 20);
  });
}

// ── Variant pills ──────────────────────────────────────
function selectV(el, idx) {
  var v = currentProduct.variants[idx];
  if (!v) return;
  if (mzVariantStockState(v) === 'loaded' && !v.inStock) return;

  document.querySelectorAll('.vpill').forEach(function(p){ p.classList.remove('active'); });
  if (el) el.classList.add('active');
  cv  = v;
  qty = 1;
  mzSetProductQtyDisplay(qty);

  var vLabel = document.getElementById('v-label');
  if (vLabel) vLabel.textContent = v.label;
  document.getElementById('p-name').textContent = v.title;
  mzRenderProductPrice(currentProduct, v);
  document.getElementById('main-img').src = imgUrl(v);
  mzSetActiveStockUi(v);

  renderStaffelPills();
  syncStaffelPills(1);
  updateCtaPrice();

  document.querySelectorAll('.img-dot').forEach(function(d, i){
    d.classList.toggle('active', i === idx);
  });

  // Een variantwissel vraagt opnieuw een verse Shopify-voorraadstatus op.
  mzSyncProductStockStatus(currentProduct);
}

// ── Quantity ───────────────────────────────────────────
function mzSetProductQtyDisplay(value) {
  var el = document.getElementById('qty-num');
  if (el) { if ('value' in el) el.value = String(value); else el.textContent = String(value); }
}
function setProductQty(value) {
  var raw = String(value == null ? '' : value).replace(/[^0-9]/g, '');
  if (raw === '') return;
  var next = parseInt(raw, 10);
  if (!isFinite(next)) next = 1;
  qty = Math.max(1, Math.min(999, next));
  mzSetProductQtyDisplay(qty);
  highlightStaffelRow(qty);
  updateCtaPrice();
}
function normalizeProductQty() {
  qty = Math.max(1, Math.min(999, parseInt(qty, 10) || 1));
  mzSetProductQtyDisplay(qty);
  highlightStaffelRow(qty);
  updateCtaPrice();
}
function changeQty(delta) {
  qty = Math.max(1, Math.min(999, (parseInt(qty, 10) || 1) + delta));
  mzSetProductQtyDisplay(qty);
  highlightStaffelRow(qty);
  updateCtaPrice();
}

// ── CTA price + hint ───────────────────────────────────
function mzGetFixedPriceHint(product, variant) {
  if (!product) return 'Vaste prijs';

  // Gebruik eerst de product- of variantnaam. Zo wordt bijvoorbeeld
  // "50 stuks" of "100 stuks" automatisch correct weergegeven.
  var nameParts = [
    variant && variant.title,
    variant && variant.label,
    variant && variant.name,
    product.title,
    product.category,
    product.desc
  ].filter(Boolean);
  var productName = nameParts.join(' ');
  var amountMatch = productName.match(/(?:^|[\s·\-–—(])(\d+)\s*stuks?(?:\b|$)/i);
  if (amountMatch) return 'Vaste prijs per ' + amountMatch[1] + ' stuks';

  var unit = String(product.unit || '').toLowerCase();
  if (unit === 'rollen' || unit === 'rol') return 'Vaste prijs per rol';
  if (unit === 'stuks' || unit === 'stuk') return 'Vaste prijs per stuk';
  if (unit === 'dozen' || unit === 'doos') return 'Vaste prijs per doos';

  return 'Vaste prijs';
}

function updateCtaPrice() {
  var btn = document.getElementById('add-btn');
  if (!btn || !cv) return;

  var stockState = mzVariantStockState(cv);
  if (stockState !== 'loaded') {
    btn.disabled = true;
    if (stockState === 'error') {
      btn.classList.remove('mz-silent-loading');
      btn.removeAttribute('aria-busy');
      btn.innerHTML = 'Prijs tijdelijk niet beschikbaar';
    } else {
      btn.classList.add('mz-silent-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = '<span>' + CONFIG.ctaLabel + '</span>';
    }
    var pendingHint = document.getElementById('qty-hint');
    if (pendingHint) pendingHint.textContent = '';
    return;
  }
  btn.classList.remove('mz-silent-loading');
  btn.removeAttribute('aria-busy');
  if (!cv.inStock) {
    btn.innerHTML = CONFIG.outOfStockLabel;
    btn.disabled = true;
    return;
  }
  var exactBoxQuantity = mzHasRelatedBoxQuantity(currentProduct, cv, qty);
  if (exactBoxQuantity && cv._staffelPriceStatus !== 'loaded') {
    btn.disabled = true;
    btn.classList.add('mz-silent-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = '<span>' + CONFIG.ctaLabel + '</span>';
    var waitingHint = document.getElementById('qty-hint');
    if (waitingHint) waitingHint.textContent = '';
    return;
  }

  btn.disabled = false;
  var boxDeal = (exactBoxQuantity && cv._staffelPriceStatus === 'loaded' && typeof mzGetBoxDealForProductQty === 'function')
    ? mzGetBoxDealForProductQty(currentProduct, cv, qty)
    : null;
  var disc = getTierDiscount(qty);
  var quote = mzStaffelQuoteForQty(cv, qty, disc);
  var lineInclCents = boxDeal ? boxDeal.totalInclCents : quote.lineInclCents;
  var lineExclCents = boxDeal ? boxDeal.totalExclCents : quote.lineExclCents;
  var unitPrice = qty ? (lineExclCents / 100) / qty : 0;
  document.getElementById('add-btn').innerHTML =
    '<span>' + CONFIG.ctaLabel + '</span><div style="text-align:right;"><div style="font-size:17px;font-weight:900;line-height:1;">' + mzFormatCents(lineExclCents) + '</div><div style="font-size:9.5px;font-weight:600;opacity:0.85;">excl. BTW &nbsp;&middot;&nbsp; <span style="font-weight:500;opacity:0.8;">' + mzFormatCents(lineInclCents) + '&nbsp;incl.</span></div></div>';

  // Dynamic hint: next tier threshold
  var tiers    = getActiveTiers();
  var unit     = currentProduct.unit || 'stuks';
  var hint     = '';
  var nextTier = null;
  for (var i = 0; i < tiers.length; i++) {
    if (qty < tiers[i].min) { nextTier = tiers[i]; break; }
  }
  if (boxDeal) {
    hint = 'Doosprijs toegepast — gelijk aan ' + (boxDeal.boxVariant && boxDeal.boxVariant.label ? boxDeal.boxVariant.label : (boxDeal.boxInhoud + ' stuks'));
  } else if (nextTier) {
    var nextQuote = mzStaffelQuoteForQty(cv, nextTier.min, nextTier.discount);
    var baseUnitExclCents = mzInclToExclCents(nextQuote.baseInclCents);
    var savePerUnitCents = Math.max(0, baseUnitExclCents - nextQuote.unitExclCents);
    hint = nextTier.min + '+ ' + unit + '? Bespaar ' +
           Math.round(nextTier.discount * 100) + '% — ' +
           mzFormatCents(savePerUnitCents) + '/stuk';
  } else if (currentProduct && currentProduct.variantType === 'dozen') {
    hint = 'Doosprijzen — al geprijsd als bulk';
  } else if (currentProduct && currentProduct.noStaffel) {
    hint = mzGetFixedPriceHint(currentProduct, cv);
  } else {
    hint = 'Maximale staffelkorting actief';
  }
  document.getElementById('qty-hint').textContent = hint;
}

// ── Navigation ─────────────────────────────────────────
function showScreen(id) {
  var el = document.getElementById(id);
  if (!el) { console.warn('showScreen: screen not found:', id); return; }
  document.querySelectorAll('.screen').forEach(function(s){ s.classList.remove('active'); });
  el.classList.add('active');
  el.scrollTop = 0;
}
function goBack() {
  var active = document.querySelector('.screen.active');
  var target = active && active.dataset.back ? active.dataset.back : 's-home';
  showScreen(target);
}
function mzSetMobileNavPosition() {
  if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) {
    document.documentElement.style.removeProperty('--mz-mobile-nav-top');
    return;
  }

  var activeHeader = document.querySelector('.screen.active .header') || document.querySelector('.header');
  if (!activeHeader || !activeHeader.getBoundingClientRect) return;

  var headerBottom = Math.max(0, Math.round(activeHeader.getBoundingClientRect().bottom));
  document.documentElement.style.setProperty('--mz-mobile-nav-top', headerBottom + 'px');
}

function openNav() {
  mzSetMobileNavPosition();
  document.getElementById('nav-drawer').classList.add('open');
  document.getElementById('nav-overlay').classList.add('open');
}
function closeNav() {
  document.getElementById('nav-drawer').classList.remove('open');
  document.getElementById('nav-overlay').classList.remove('open');
}
function toggleNavItem(h) {
  var sub  = h.nextElementSibling;
  var chev = h.querySelector('.nav-chevron');
  var open = sub.classList.contains('open');
  document.querySelectorAll('.nav-sub').forEach(function(s){ s.classList.remove('open'); });
  document.querySelectorAll('.nav-chevron').forEach(function(c){ c.classList.remove('open'); });
  if (!open) { sub.classList.add('open'); chev.classList.add('open'); }
}
var GOOGLE_REVIEWS_URL = 'https://www.google.com/search?sca_esv=2b2ec1583e7d2558&rlz=1C5CHFA_enNL1142NL1146&sxsrf=ANbL-n6qe0VcbrSGOeqI2ESDZXr7g1eq1A:1781342028260&q=MOOZERS+Reviews&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNLYwM7AwNTcyMjQ2NjI2tgRyNjAyvmLk9_X3j3INClYISi3LTC0vXsSKLgIAfpOfQT8AAAA&rldimm=13860857221332339085&tbm=lcl&hl=nl-NL&sa=X&ved=2ahUKEwiphMWW8IOVAxXZ-AIHHVNmFFMQ9fQKegQITBAG&biw=1470&bih=797&dpr=2#lkt=LocalPoiReviews';
function openGoogleReviews() {
  window.open(GOOGLE_REVIEWS_URL, '_blank', 'noopener,noreferrer');
}
function scrollToReviews() { openGoogleReviews(); }

// ── Add to cart ────────────────────────────────────────
function addToCart() {
  if (!currentProduct || !cv) {
    try {
      var path = (window.location.pathname || '').toLowerCase();
      var handle = path.indexOf('/products/') === 0 ? path.split('/products/')[1].split('/')[0] : '';
      if (handle && typeof mzLoadProductFromHandle === 'function' && mzLoadProductFromHandle(handle)) {
        setTimeout(addToCart, 120);
        return;
      }
    } catch (e) {}
    showScreen('s-cart');
    mzShowCartNotice('Dit product kon nog niet worden toegevoegd. Open het product opnieuw en probeer het nog een keer.', 'error');
    return;
  }
  if (!cv.inStock) return;
  var item = mzCartItemFromVariant(currentProduct, cv, qty, cv.priceExcl);
  var addedItem = (typeof mzAddCartItem === 'function') ? mzAddCartItem(item) : (cart.push(item), item);
  if (typeof mzRepriceCartItems === 'function') mzRepriceCartItems();
  renderCart();
  openPopupProduct(cv, (addedItem && addedItem.priceExcl) || item.priceExcl || cv.priceExcl);
}


// V22: sticky add-to-cart moet overal betrouwbaar klikken, ook als Shopify/editor inline onclick tegenwerkt.
document.addEventListener('click', function(e) {
  var btn = e.target.closest && e.target.closest('#add-btn, [data-mz-add-to-cart]');
  if (!btn) return;
  if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
  if (e.preventDefault) e.preventDefault();
  if (e.stopPropagation) e.stopPropagation();
  if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  addToCart();
}, true);


// v32: winkelwagen-aantallen zijn ook typend aanpasbaar.
document.addEventListener('change', function(e) {
  var inp = e.target && e.target.closest && e.target.closest('.ci-qty-input');
  if (!inp) return;
  cartSetQty(parseInt(inp.getAttribute('data-cart-index'), 10), inp.value);
}, true);

function quickAdd(title, size, img, imgV, priceExcl, priceIncl, label) {
  var handle = mzInferShopifyHandle(title, size || label, img);
  var added = (typeof mzAddCartItem === 'function') ? mzAddCartItem({
    title: title + ' ' + size, label: label,
    img: img, imgV: imgV,
    basePriceExcl: priceExcl, basePriceIncl: priceIncl,
    priceExcl: priceExcl, priceIncl: priceIncl,
    qty: 1, emoji: null,
    shopifyHandle: handle,
    variantSize: size || label || ''
  }) : null;
  if (!added) {
    added = {
      title: title + ' ' + size, label: label, img: img, imgV: imgV,
      priceExcl: priceExcl, priceIncl: priceIncl, qty: 1, emoji: null,
      shopifyHandle: handle, variantSize: size || label || ''
    };
    cart.push(added);
  }
  renderCart();
  openPopupItem(added);
}

// ── Staffelprijs herberekenen per Shopify-variant ───────
function mzFindCatalogVariantForItem(item) {
  if (!item || typeof CATALOG !== 'object') return null;
  var handle = item.shopifyHandle || mzInferShopifyHandle(item.title, item.label || item.variantSize, item.img);
  var wanted = mzText([item.variantSize, item.label, item.title].join(' '));
  var ids = item.productId && CATALOG[item.productId] ? [item.productId] : Object.keys(CATALOG);
  for (var p = 0; p < ids.length; p++) {
    var product = CATALOG[ids[p]];
    if (!product || !Array.isArray(product.variants)) continue;
    for (var v = 0; v < product.variants.length; v++) {
      var variant = product.variants[v];
      var vHandle = mzBuildShopifyHandle(product, variant) || mzInferShopifyHandle(variant.title, variant.label, variant.img);
      var vText = mzText([variant.size, variant.label, variant.title, variant.img].join(' '));
      if ((handle && vHandle === handle) || (item.img && variant.img === item.img) || (wanted && (vText.indexOf(wanted) >= 0 || wanted.indexOf(vText) >= 0))) {
        return { product: product, variant: variant, handle: vHandle };
      }
    }
  }
  return null;
}


function mzNormaliseKleur(v) {
  v = mzText(v || '');
  if (v.indexOf('paars') >= 0) return 'Paars';
  if (v.indexOf('geel') >= 0) return 'Geel';
  return '';
}

function mzLooseTapeMeta(product, variant) {
  if (!product || !variant) return null;
  if (product.id !== 'washi-tape' && product.id !== 'washi-tape-paars') return null;
  var kleur = product.id === 'washi-tape-paars' ? 'Paars' : 'Geel';
  var txt = [variant.breedte, variant.size, variant.label, variant.title].join(' ');
  var breedte = (String(txt || '').match(/(19|24|36|50)\b/) || [null,null])[1];
  if (!breedte) return null;
  return { kleur: kleur, breedte: String(breedte) };
}


function mzLooseTapeMetaFromCartItemStrict(item) {
  if (!item) return null;

  // 1) De Shopify-handle is de veiligste bron. Hiermee mag 19mm nooit 24mm worden.
  var handle = mzText(item.shopifyHandle || '').replace(/^\/products\//, '').replace(/^\/+|\/+$/g, '');
  var m = handle.match(/^moozers-washi-tape-(geel|paars)-(19|24|36|50)mm$/);
  if (m) return { kleur: m[1] === 'paars' ? 'Paars' : 'Geel', breedte: String(m[2]) };

  // Doosproducten zelf niet opnieuw als losse rollen naar een andere doos omzetten.
  if (handle.match(/^doos-moozers-washi-tape-/)) return null;

  // 2) Fallback alleen als productId duidelijk een los tapeproduct is.
  if (item.productId === 'washi-tape' || item.productId === 'washi-tape-paars') {
    var kleur = item.productId === 'washi-tape-paars' ? 'Paars' : 'Geel';
    var txt = [item.variantSize, item.label, item.title].join(' ');
    var breedte = (String(txt || '').match(/(?:^|[^0-9])(19|24|36|50)\s*(?:mm)?(?:[^0-9]|$)/) || [null,null])[1];
    if (breedte) return { kleur: kleur, breedte: String(breedte) };
  }

  // 3) Geen gok doen op basis van alleen afbeelding of algemene tekst.
  // Liever geen doosprijs dan een verkeerde doosvariant in checkout.
  return null;
}

function mzFindBoxDeal(kleur, breedte, quantity) {
  quantity = Math.max(0, parseInt(quantity, 10) || 0);
  if (!quantity || !kleur || !breedte || !CATALOG || !CATALOG['dozen-tape']) return null;
  var dozenProduct = CATALOG['dozen-tape'];
  var variants = dozenProduct.variants || [];
  var matches = [];
  for (var i = 0; i < variants.length; i++) {
    var box = variants[i];
    if (mzNormaliseKleur(box.kleur) !== mzNormaliseKleur(kleur)) continue;
    if (String(box.breedte) !== String(breedte)) continue;
    var inhoud = Math.max(0, parseInt(box.inhoud, 10) || 0);
    if (!inhoud || quantity < inhoud) continue;
    if (quantity === inhoud) { // v86: alleen exact doosaantal, geen veelvoud
      var boxQty = Math.max(1, quantity / inhoud);
      var totalInclCents = mzToCents(box.priceIncl != null ? box.priceIncl : ((parseFloat(box.priceExcl) || 0) * mzVatFactor())) * boxQty;
      var totalExclCents = mzInclToExclCents(totalInclCents);
      var totalExcl = totalExclCents / 100;
      var unitPriceExcl = totalExcl / quantity;
      var unitPriceIncl = (totalInclCents / 100) / quantity;
      matches.push({
        boxVariant: box,
        boxProduct: dozenProduct,
        boxHandle: mzBuildShopifyHandle(dozenProduct, box),
        boxInhoud: inhoud,
        boxQty: boxQty,
        totalInclCents: totalInclCents,
        totalExclCents: totalExclCents,
        totalExcl: totalExcl,
        unitPriceExcl: unitPriceExcl,
        unitPriceIncl: unitPriceIncl
      });
    }
  }
  if (!matches.length) return null;
  matches.sort(function(a, b) {
    if (a.boxInhoud === quantity && b.boxInhoud !== quantity) return -1;
    if (b.boxInhoud === quantity && a.boxInhoud !== quantity) return 1;
    if (Math.abs(a.unitPriceExcl - b.unitPriceExcl) > 0.000001) return a.unitPriceExcl - b.unitPriceExcl;
    return b.boxInhoud - a.boxInhoud;
  });
  return matches[0];
}

function mzGetBoxDealForProductQty(product, variant, quantity) {
  var meta = mzLooseTapeMeta(product, variant);
  if (!meta) return null;
  return mzFindBoxDeal(meta.kleur, meta.breedte, quantity);
}

function mzGetBoxDealForCartGroup(item, quantity) {
  // Veiligheidsfix v80: voor tape-doosprijzen alleen omzetten op basis van een strikte
  // kleur + breedte match. Daardoor kan 19mm nooit naar een 24mm-doos veranderen.
  var strictMeta = mzLooseTapeMetaFromCartItemStrict(item);
  if (strictMeta) return mzFindBoxDeal(strictMeta.kleur, strictMeta.breedte, quantity);

  // Bestaande v78-fallback behouden voor niet-tape producten/regels.
  var found = mzFindCatalogVariantForItem(item);
  if (!found || !found.product || !found.variant) return null;
  return mzGetBoxDealForProductQty(found.product, found.variant, quantity);
}

function mzCartItemKey(item) {
  if (!item) return '';
  mzEnsureCartPricingMeta(item);
  return item.tierGroupKey || item.shopifyHandle || mzInferShopifyHandle(item.title, item.label || item.variantSize, item.img) || mzText([item.productId, item.variantSize, item.label, item.title].join('|'));
}

function mzAddCartItem(item) {
  if (!item) return null;
  mzEnsureCartPricingMeta(item);
  var key = mzCartItemKey(item);
  for (var i = 0; i < cart.length; i++) {
    if (mzCartItemKey(cart[i]) === key) {
      cart[i].qty = Math.max(1, parseInt(cart[i].qty, 10) || 1) + Math.max(1, parseInt(item.qty, 10) || 1);
      return cart[i];
    }
  }
  cart.push(item);
  return item;
}

function mzEnsureCartPricingMeta(item) {
  if (!item) return;
  var found = mzFindCatalogVariantForItem(item);
  if (found && found.variant) {
    if (item.basePriceIncl == null) item.basePriceIncl = mzInclFloatFromVariant(found.variant, item.priceExcl);
    if (item.basePriceExcl == null) item.basePriceExcl = mzExclFloatFromInclFloat(item.basePriceIncl);
    if (!item.productId && found.product) item.productId = found.product.id;
    if (!item.variantSize) item.variantSize = found.variant.size || found.variant.label || '';
    if (!item.shopifyHandle && found.handle) item.shopifyHandle = found.handle;
    if (!item.staffelTiers) item.staffelTiers = (found.variant.staffelTiers || found.product.staffelTiers || null);
    if (!item.tierGroupKey) item.tierGroupKey = item.shopifyHandle || ((found.product ? found.product.id : '') + '|' + (found.variant.size || found.variant.label || found.variant.title || ''));
  }
  if (item.basePriceIncl == null) item.basePriceIncl = item.priceIncl != null ? (parseFloat(item.priceIncl) || 0) : ((parseFloat(item.priceExcl) || 0) * mzVatFactor());
  if (item.basePriceExcl == null) item.basePriceExcl = mzExclFloatFromInclFloat(item.basePriceIncl);
  if (!item.tierGroupKey) item.tierGroupKey = item.shopifyHandle || mzInferShopifyHandle(item.title, item.label || item.variantSize, item.img) || mzText([item.productId, item.variantSize, item.label, item.title].join('|'));
}

function mzTierDiscountFromTiers(tiers, q) {
  if (!Array.isArray(tiers) || !tiers.length) return 0;
  q = Math.max(0, parseInt(q, 10) || 0);
  var discount = 0;
  for (var i = 0; i < tiers.length; i++) {
    var min = Math.max(0, parseInt(tiers[i].min, 10) || 0);
    var max = tiers[i].max == null ? 999999 : Math.max(0, parseInt(tiers[i].max, 10) || 999999);
    if (q >= min && q <= max) discount = parseFloat(tiers[i].discount) || 0;
  }
  return discount;
}

function mzRepriceCartItems() {
  if (!Array.isArray(cart)) return;
  var mzCurrentDisplaySyncKey = (typeof mzCartLivePriceKey === 'function') ? mzCartLivePriceKey() : '';
  var groups = {};
  cart.forEach(function(item, i) {
    mzEnsureCartPricingMeta(item);
    var key = item.tierGroupKey || ('line-' + i);
    if (!groups[key]) groups[key] = { qty: 0, indexes: [], tiers: item.staffelTiers || null };
    groups[key].qty += Math.max(0, parseInt(item.qty, 10) || 0);
    groups[key].indexes.push(i);
    if (!groups[key].tiers && item.staffelTiers) groups[key].tiers = item.staffelTiers;
  });

  Object.keys(groups).forEach(function(key) {
    var group = groups[key];
    var boxDeal = null;
    for (var b = 0; b < group.indexes.length; b++) {
      boxDeal = mzGetBoxDealForCartGroup(cart[group.indexes[b]], group.qty);
      if (boxDeal) break;
    }
    var remainingInclCents = boxDeal ? (boxDeal.totalInclCents || mzToCents(boxDeal.totalExcl * mzVatFactor())) : null;

    group.indexes.forEach(function(i, pos) {
      var item = cart[i];
      if (!item) return;
      if (item._shopifyDisplaySynced) {
        if (item._shopifyDisplaySyncKey === mzCurrentDisplaySyncKey && item._lineInclCents != null) {
          var lockedInclCents = Math.max(0, parseInt(item._lineInclCents, 10) || 0);
          var lockedExclCents = mzInclToExclCents(lockedInclCents);
          item._lineInclCents = lockedInclCents;
          item._lineExclCents = lockedExclCents;
          item._lineTaxCents = lockedInclCents - lockedExclCents;
          item._staffelGroupQty = group.qty;

          // Zodra de echte Shopify-cart is gelezen, is alleen de daar berekende
          // final_line_price leidend. Ook het getoonde kortingspercentage komt dan
          // uit Shopify en niet uit een lokale staffelberekening.
          item._staffelDiscount = Math.max(0, parseFloat(item._shopifyActualDiscount) || 0);
          delete item._boxPriceMatch;
          delete item._boxVariantLabel;
          delete item._boxDealQty;
          delete item._shopifyCheckoutHandle;
          delete item._shopifyCheckoutQty;
          delete item._shopifyCheckoutVariantSize;
          delete item._shopifyCheckoutSkip;
          return;
        }
        delete item._shopifyDisplaySynced;
        delete item._shopifyDisplaySyncKey;
        delete item._shopifyDisplayVariantId;
      }
      delete item._shopifyCheckoutHandle;
      delete item._shopifyCheckoutQty;
      delete item._shopifyCheckoutVariantSize;
      delete item._shopifyCheckoutSkip;
      delete item._boxPriceMatch;
      delete item._boxVariantLabel;
      delete item._boxDealQty;
      delete item._lineInclCents;
      delete item._lineExclCents;
      delete item._lineTaxCents;

      var qty = Math.max(0, parseInt(item.qty, 10) || 0);
      var baseInclCents = mzToCents(item.basePriceIncl != null ? item.basePriceIncl : ((parseFloat(item.basePriceExcl) || parseFloat(item.priceExcl) || 0) * mzVatFactor()));
      var lineInclCents;

      if (boxDeal) {
        // Verdeel de exacte incl.-btw doosprijs over eventuele samengevoegde regels.
        // De laatste regel krijgt de rest, zodat het subtotaal exact gelijk blijft aan Shopify.
        if (pos === group.indexes.length - 1) {
          lineInclCents = Math.max(0, remainingInclCents || 0);
        } else {
          lineInclCents = Math.round((boxDeal.totalInclCents || 0) * (qty / Math.max(1, group.qty)));
          remainingInclCents -= lineInclCents;
        }
        item._staffelDiscount = 0;
        item._staffelGroupQty = group.qty;
        item._boxPriceMatch = true;
        item._boxVariantLabel = boxDeal.boxVariant && boxDeal.boxVariant.label ? boxDeal.boxVariant.label : (boxDeal.boxInhoud + ' rollen');
        item._boxDealQty = boxDeal.boxQty;
        // v93: behoud in checkout exact dezelfde losse variant en hetzelfde
        // aantal als in de winkelwagen. Alleen de zichtbare staffel-/doosprijs blijft
        // voor de prijsberekening actief; er wordt geen 72 -> 1 omzetting meer gedaan.
        delete item._shopifyCheckoutHandle;
        delete item._shopifyCheckoutQty;
        delete item._shopifyCheckoutVariantSize;
        delete item._shopifyCheckoutSkip;
      } else {
        // v88: Staffelkorting actief in Shopify Checkout — ook in cart tonen.
        var discount = mzTierDiscountFromTiers(group.tiers, group.qty);
        lineInclCents = Math.round(baseInclCents * qty * (1 - discount));
        item._staffelDiscount = discount;
        item._staffelGroupQty = group.qty;
      }

      var lineExclCents = mzInclToExclCents(lineInclCents);
      item._lineInclCents = lineInclCents;
      item._lineExclCents = lineExclCents;
      item._lineTaxCents = lineInclCents - lineExclCents;
      item.priceIncl = qty ? (lineInclCents / 100) / qty : 0;
      item.priceExcl = qty ? (lineExclCents / 100) / qty : 0;
    });
  });
}

// ── Render cart ────────────────────────────────────────
function mzCartStockLabel(item) {
  if (!item) return '';
  // Voorraadcontrole draait volledig stil op de achtergrond.
  // Toon alleen een concrete rode melding bij het product als er écht een probleem is.
  if (item._stockChecking) return '';
  if (item._stockIssue) return '';
  if (item._stockLimit === 0) return '';
  return '';
}
function renderCart(skipLiveSync) {
  if (typeof mzRepriceCartItems === 'function') mzRepriceCartItems();
  var mzCartRenderKey = (typeof mzCartLivePriceKey === 'function') ? mzCartLivePriceKey() : '';
  var cartPricingPending = Array.isArray(cart) && cart.length > 0 && cart.some(function(item){
    return !item || item._shopifyDisplaySynced !== true || item._shopifyDisplaySyncKey !== mzCartRenderKey || item._lineInclCents == null;
  });
  var subExclCents = cart.reduce(function(s, i){ return s + mzItemLineExclCents(i); }, 0);
  var productInclCents = cart.reduce(function(s, i){ return s + mzItemLineInclCents(i); }, 0);
  var totalItems = cart.reduce(function(s, i){ return s + i.qty; }, 0);
  // De Shopify-prijs is incl. btw. Daarom is productInclCents leidend.
  // Excl. BTW en BTW worden op regelniveau terugberekend om centverschillen met checkout te voorkomen.
  var btwCents = productInclCents - subExclCents;
  var thresholdCents = mzToCents(CONFIG.freeShippingThreshold);
  var shippingCents = subExclCents >= thresholdCents ? 0 : mzToCents(CONFIG.shippingCost);
  var totalCents = productInclCents + shippingCents;
  var subExcl = subExclCents / 100;

  // Badge — update ALL .cart-badge elements across all screens
  document.querySelectorAll('.cart-badge').forEach(function(b) {
    b.textContent = totalItems;
    b.style.display = totalItems > 0 ? 'flex' : 'none';
  });

  // Shipping bar on product page: pas tonen nadat de actuele Shopify-cartprijs bekend is.
  var shipBarEl = document.getElementById('ship-bar-wrap');
  if (shipBarEl) shipBarEl.style.display = (totalItems > 0 && !cartPricingPending) ? 'block' : 'none';

  // Progress
  var remCents = Math.max(0, thresholdCents - subExclCents);
  var pct     = Math.min(100, (subExclCents / Math.max(1, thresholdCents)) * 100);
  var shipHtml = remCents <= 0
    ? '<strong>Gratis verzending!</strong>'
    : '🚚 Nog <strong>' + mzFormatCents(remCents) + '</strong>&nbsp;excl.&nbsp;btw voor gratis verzending';
  document.getElementById('ship-fill').style.width       = pct + '%';
  document.getElementById('ship-text').innerHTML         = shipHtml;
  document.getElementById('cart-count-h').textContent    = totalItems;
  document.getElementById('cart-ship-fill').style.width  = pct + '%';
  document.getElementById('cart-ship-text').innerHTML    = shipHtml;

  // Cart items
  var html = '';
  if (cart.length === 0) {
    html = '<div style="text-align:center;padding:28px 14px;color:var(--muted);">Je winkelwagen is leeg.<br><a href="#" onclick="showScreen(\'s-home\');return false" style="color:var(--primary);font-weight:700;text-decoration:none;">← Verder winkelen</a></div>';
  } else {
    cart.forEach(function(item, i) {
      var cartImageUrl = mzCartItemImageUrl(item);
      var safeCartImageUrl = String(cartImageUrl || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
      var thumb = item.emoji
        ? '<div style="width:60px;height:60px;display:flex;align-items:center;justify-content:center;font-size:32px;flex-shrink:0;">' + item.emoji + '</div>'
        : (safeCartImageUrl
          ? '<img class="ci-img" src="' + safeCartImageUrl + '" onerror="this.onerror=null;this.style.opacity=\'1\';this.style.visibility=\'hidden\';if(this.parentElement){this.parentElement.classList.add(\'mz-img-missing\');}" alt="">'
          : '<div class="ci-img mz-img-missing" aria-hidden="true"></div>');
      var itemPriceReady = item._shopifyDisplaySynced === true && item._shopifyDisplaySyncKey === mzCartRenderKey && item._lineInclCents != null;
      var staffelLine = itemPriceReady && item._staffelDiscount > 0
        ? '<div class="ci-variant">Korting in Shopify: ' + Math.round(item._staffelDiscount * 100) + '%</div>'
        : '';
      html += '<div class="cart-item" data-mz-idx="' + i + '">' + thumb +
        '<div class="ci-info">' +
          '<div class="ci-name">' + item.title + '</div>' +
          (item.label ? '<div class="ci-variant">' + item.label + '</div>' : '') +
          staffelLine +
          '<div class="ci-stock">' + mzCartStockLabel(item) + '</div>' +
          '<div class="ci-bottom">' +
            '<div class="ci-qty-ctrl">' +
              '<button class="ci-qty-btn" type="button" aria-label="Aantal verlagen" onclick="cartQty(' + i + ',-1)">−</button>' +
              '<input class="ci-qty-input" type="number" inputmode="numeric" pattern="[0-9]*" min="0" max="999" value="' + item.qty + '" data-cart-index="' + i + '" aria-label="Aantal aanpassen" onkeydown="if(event.key===\'Enter\'){this.blur();}" onchange="cartSetQty(' + i + ', this.value)" onblur="cartSetQty(' + i + ', this.value)">' +
              '<button class="ci-qty-btn" type="button" aria-label="Aantal verhogen" onclick="cartQty(' + i + ',1)">+</button>' +
            '</div>' +
            '<div><div class="ci-price' + (itemPriceReady ? '' : ' mz-price-pending') + '">' + (itemPriceReady ? mzFormatCents(mzItemLineExclCents(item)) : '&nbsp;') + '</div><div class="ci-vat-note' + (itemPriceReady ? '' : ' mz-price-pending') + '">' + (itemPriceReady ? 'excl. BTW' : '&nbsp;') + '</div></div>' +
            '<span class="ci-del" onclick="removeItem(' + i + ')">🗑</span>' +
          '</div>' +
        '</div></div>';
    });
  }
  document.getElementById('cart-items').innerHTML = html;
  setTimeout(function(){ try { if (typeof mzApplyCartSaleBadges === 'function') mzApplyCartSaleBadges(); } catch(e) {} }, 0);
  var sumSubEl = document.getElementById('sum-sub');
  var sumBtwEl = document.getElementById('sum-btw');
  if (sumSubEl) { sumSubEl.textContent = cartPricingPending ? '' : mzFormatCents(subExclCents); sumSubEl.classList.toggle('mz-price-pending', cartPricingPending); }
  if (sumBtwEl) { sumBtwEl.textContent = cartPricingPending ? '' : mzFormatCents(btwCents); sumBtwEl.className = cartPricingPending ? 'mz-price-pending' : ''; }
  var lblEl = document.getElementById('sum-btw-label');
  if (lblEl) lblEl.textContent = b2bState.active ? 'BTW (controle in checkout)' : 'BTW (21%)';
  if (lblEl) lblEl.style.color = b2bState.active ? '#2e7d32' : '';
  // Verzendkosten kunnen pas exact in Shopify Checkout worden bepaald op basis
  // van land, postcode en eventuele zakelijke voorwaarden. Toon daarom in de cart
  // geen schijn-eindtotaal dat later kan afwijken.
  var sumShipEl = document.getElementById('sum-ship');
  var sumTotalEl = document.getElementById('sum-total');
  if (sumShipEl) { sumShipEl.textContent = cartPricingPending ? '' : 'Berekend in checkout'; sumShipEl.classList.toggle('mz-price-pending', cartPricingPending); }
  if (sumTotalEl) { sumTotalEl.textContent = cartPricingPending ? '' : mzFormatCents(productInclCents); sumTotalEl.classList.toggle('mz-price-pending', cartPricingPending); }

  var cartShipBar = document.querySelector('#s-cart .cart-ship-bar');
  if (cartShipBar) cartShipBar.style.visibility = cartPricingPending ? 'hidden' : '';

  document.querySelectorAll('.btn-checkout').forEach(function(btn) {
    if (!btn.getAttribute('data-mz-price-original-html')) btn.setAttribute('data-mz-price-original-html', btn.innerHTML);
    btn.innerHTML = btn.getAttribute('data-mz-price-original-html');
    if (cartPricingPending && cart.length) {
      btn.disabled = true;
      btn.classList.add('mz-silent-loading');
      btn.setAttribute('aria-busy', 'true');
    } else if (!cart.length) {
      btn.disabled = true;
      btn.classList.remove('mz-silent-loading');
      btn.removeAttribute('aria-busy');
    } else if (!mzCheckoutInProgress) {
      btn.disabled = false;
      btn.classList.remove('mz-silent-loading');
      btn.removeAttribute('aria-busy');
    }
  });

  if (cartPricingPending && typeof mzScheduleDisplayCartShopifySync === 'function') {
    var cartScreen = document.getElementById('s-cart');
    if (cartScreen && cartScreen.classList.contains('active')) mzScheduleDisplayCartShopifySync(0, true);
  }
  // v25: verzend-info direct boven afrekenknop (cart-sticky)
  var cssEl = document.getElementById('cart-sticky-ship');
  if (cssEl) {
    if (cart.length === 0 || cartPricingPending) {
      cssEl.style.display = 'none';
    } else if (shippingCents === 0) {
      cssEl.className = 'cart-sticky-ship css-free';
      cssEl.innerHTML = '\u2713 Je bestelling wordt gratis verzonden';
      cssEl.style.display = '';
    } else {
      cssEl.className = 'cart-sticky-ship';
      cssEl.innerHTML = 'Verzendkosten NL &amp; BE: ' + mzFormatCents(mzToCents(CONFIG.shippingCost))
        + '<span class="css-sep"> &middot; </span>'
        + 'Nog <strong>' + mzFormatCents(remCents) + '</strong>&nbsp;excl.&nbsp;btw voor gratis verzending';
      cssEl.style.display = '';
    }
  }
  mzPersistCartState();
  if (!skipLiveSync && typeof mzScheduleLivePriceSync === 'function') mzScheduleLivePriceSync(0);
  renderCartUpsell();
}

function cartSetQty(i, value) {
  if (!cart[i]) return;
  var raw = String(value == null ? '' : value).replace(/[^0-9]/g, '');
  if (raw === '') {
    cart[i].qty = 1;
  } else {
    var next = parseInt(raw, 10);
    if (!isFinite(next)) next = 1;
    next = Math.max(0, Math.min(999, next));
    if (next === 0) {
      cart.splice(i, 1);
      renderCart();
      return;
    }
    cart[i].qty = next;
  }
  mzClearCartNotice();
  renderCart();
}
function cartQty(i, d) {
  if (!cart[i]) return;
  cart[i].qty = Math.max(0, Math.min(999, (parseInt(cart[i].qty, 10) || 1) + d));
  if (cart[i].qty === 0) cart.splice(i, 1);
  mzClearCartNotice();
  renderCart();
}
function removeItem(i) { cart.splice(i, 1); mzClearCartNotice(); renderCart(); }

// ── Cart popup ─────────────────────────────────────────

function mzHandlePopupImageError(imgEl) {
  var em = document.getElementById('pop-emoji');
  if (imgEl) {
    imgEl.style.display = 'none';
    imgEl.style.visibility = 'hidden';
  }
  if (em) {
    em.textContent = '📦';
    em.style.display = 'flex';
    em.style.alignItems = 'center';
    em.style.justifyContent = 'center';
  }
}
window.mzHandlePopupImageError = mzHandlePopupImageError;
function mzSetPopupImageFromVariant(v) {
  var imgEl = document.getElementById('pop-img');
  var em = document.getElementById('pop-emoji');
  if (!imgEl || !v || !v.img) { mzHandlePopupImageError(imgEl); return; }
  if (em) em.style.display = 'none';
  imgEl.style.visibility = 'visible';
  imgEl.style.display = 'block';
  imgEl.onerror = function(){ mzHandlePopupImageError(imgEl); };
  imgEl.src = imgUrl(v);
}
function mzSetPopupImageFromItem(item) {
  var imgEl = document.getElementById('pop-img');
  var em = document.getElementById('pop-emoji');
  if (item && item.emoji) {
    if (imgEl) imgEl.style.display = 'none';
    if (em) { em.textContent = item.emoji; em.style.display = 'flex'; em.style.alignItems = 'center'; em.style.justifyContent = 'center'; }
    return;
  }
  if (!imgEl || !item || !item.img) { mzHandlePopupImageError(imgEl); return; }
  if (em) em.style.display = 'none';
  imgEl.style.visibility = 'visible';
  imgEl.style.display = 'block';
  imgEl.onerror = function(){ mzHandlePopupImageError(imgEl); };
  imgEl.src = IMG_BASE + item.img + '?v=' + item.imgV + '&width=220';
}

function openPopupProduct(v, price) {
  mzSetPopupImageFromVariant(v);
  var nameEl = document.getElementById('pop-name');
  var variantEl = document.getElementById('pop-variant');
  if (nameEl) nameEl.textContent = v.title || '';
  if (variantEl) {
    var label = currentProduct && currentProduct.variantLabel ? currentProduct.variantLabel : 'Variant';
    var value = v.label || v.size || '';
    variantEl.textContent = value ? (label + ': ' + value) : '';
  }
  var popupInclCents = mzToCents(mzInclFloatFromVariant(v, price));
  var popupExclCents = mzInclToExclCents(popupInclCents);
  document.getElementById('pop-price').textContent = mzFormatCents(popupExclCents);
  document.getElementById('pop-vat').textContent   = 'excl. BTW (' + mzFormatCents(popupInclCents) + ' incl. BTW)';
  setPopupShip();
  document.getElementById('popup-overlay').classList.add('open');
}
function openPopupItem(item) {
  mzSetPopupImageFromItem(item);
  document.getElementById('pop-name').textContent    = item.title || '';
  document.getElementById('pop-variant').textContent = item.label || '';
  document.getElementById('pop-price').textContent   = mzFormatCents(mzInclToExclCents(mzToCents(item.priceIncl)));
  document.getElementById('pop-vat').textContent     = 'excl. BTW (' + mzFormatCents(mzToCents(item.priceIncl)) + ' incl. BTW)';
  setPopupShip();
  document.getElementById('popup-overlay').classList.add('open');
}
function setPopupShip() {
  var subCents = cart.reduce(function(s, i){ return s + mzItemLineExclCents(i); }, 0);
  var remCents = Math.max(0, mzToCents(CONFIG.freeShippingThreshold) - subCents);
  var rem = remCents / 100;
  var el  = document.getElementById('pop-ship');
  if (rem <= 0) {
    el.innerHTML = '🎉 <strong>Gratis verzending!</strong>';
    el.style.cssText = 'background:#d4edda;border:1px solid #28a745;border-radius:8px;padding:9px 12px;font-size:12px;font-weight:600;color:#155724;margin-bottom:12px;';
  } else {
    el.innerHTML = '🚚 Nog <strong>' + mzFormatCents(remCents) + '</strong> excl. btw voor gratis verzending';
    el.style.cssText = 'background:#ecf9f0;border:1px solid #a7e6c3;border-radius:8px;padding:9px 12px;font-size:12px;font-weight:600;color:#1a6e3a;margin-bottom:12px;';
  }
}
function closePopup()      { document.getElementById('popup-overlay').classList.remove('open'); }
function outsideClose(e)   { if (e.target === document.getElementById('popup-overlay')) closePopup(); }
function goToCart()        { closePopup(); showScreen('s-cart'); }

// ── Account ──────────────────────────────────────────────
var mzAccount = window.__MOOZERS_ACCOUNT || { loggedIn:false, urls:{} };
var accountLoggedIn = !!mzAccount.loggedIn;

function mzCustomerUrl(kind) {
  // Gebruik bewust interne Shopify-theme routes.
  // Sommige Shopify-instellingen geven routes.account_login_url als /authentication/oauth/... terug;
  // dat opent de standaard Shopify customer-login. Voor deze theme willen we binnen de Moozers-interface blijven.
  var account = window.__MOOZERS_ACCOUNT || {};
  kind = kind || (account.loggedIn ? 'account' : 'login');
  if (kind === 'register') return '/account/register';
  if (kind === 'logout')   return '/account/logout';
  if (kind === 'addresses')return '/account/addresses';
  if (kind === 'recover')  return '/account/login#recover';
  if (kind === 'login')    return '/account/login';
  return '/account';
}
function mzPathOnly(url) {
  url = url || '/';
  try {
    var parsed = new URL(url, window.location.href);
    return parsed.pathname + parsed.search + parsed.hash;
  } catch (e) {
    return url;
  }
}
function mzAbsoluteUrl(url) {
  url = url || '/account/login';
  try {
    return new URL(url, window.location.origin).href;
  } catch (e) {
    return url;
  }
}
function mzIsInShopifyEditor() {
  var ref = '';
  try { ref = document.referrer || ''; } catch (e) {}
  var href = '';
  try { href = String(window.location.href || ''); } catch (e) {}
  var designMode = false;
  try { designMode = !!(window.Shopify && window.Shopify.designMode); } catch (e) {}
  var framed = false;
  try { framed = window.top !== window; } catch (e) { framed = true; }
  return designMode || framed || ref.indexOf('admin.shopify.com') !== -1 || href.indexOf('previewMode=') !== -1 || href.indexOf('previewPath=') !== -1;
}
function mzNavigate(url) {
  var absolute = mzAbsoluteUrl(url);
  closeAccount();

  // In de Shopify theme editor wordt top-navigation vaak geblokkeerd of onderschept.
  // Daarom openen account/login/register links daar bewust in een nieuw tabblad.
  if (mzIsInShopifyEditor()) {
    var opened = null;
    try { opened = window.open(absolute, '_blank', 'noopener,noreferrer'); } catch (e) {}
    if (!opened) {
      try { window.location.assign(absolute); return; } catch (e) {}
      window.location.href = absolute;
    }
    return;
  }

  try { window.location.assign(absolute); return; } catch (e) {}
  window.location.href = absolute;
}
function goAccount(kind) {
  mzNavigate(mzCustomerUrl(kind));
}

function setCustomerPanelMode(mode) {
  mode = mode === 'addresses' ? 'addresses' : 'orders';
  var ordersPanel = document.getElementById('mz-account-orders-panel');
  var addressesPanel = document.getElementById('mz-account-addresses-panel');
  var ordersTab = document.querySelector('[data-mz-account-tab="orders"]');
  var addressesTab = document.querySelector('[data-mz-account-tab="addresses"]');
  if (ordersPanel) ordersPanel.classList.toggle('active', mode === 'orders');
  if (addressesPanel) addressesPanel.classList.toggle('active', mode === 'addresses');
  if (ordersTab) ordersTab.classList.toggle('active', mode === 'orders');
  if (addressesTab) addressesTab.classList.toggle('active', mode === 'addresses');
}
function openCustomerPanel(mode) {
  closeAccount();
  try { showScreen('s-account'); } catch (e) {}
  setTimeout(function(){ setCustomerPanelMode(mode || 'orders'); }, 0);
  return false;
}
function mzAccountMenuAction(action, ev) {
  if (ev) {
    if (ev.preventDefault) ev.preventDefault();
    if (ev.stopPropagation) ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
  }

  // Houd deze knoppen binnen de huidige draft/theme-preview, zoals in het prototype.
  // Ze linken dus niet naar de live website.
  if (action === 'orders') return openCustomerPanel('orders');
  if (action === 'addresses') return openCustomerPanel('addresses');

  if (action === 'business') {
    closeAccount();
    try { showScreen('s-zakelijk'); } catch (e) { window.location.hash = '#zakelijk'; }
    return false;
  }

  if (action === 'logout') {
    closeAccount();
    // Uitloggen moet wel via Shopify, maar alleen via een relatieve route zodat de knop niet hard naar moozers.nl linkt.
    var logoutUrl = mzPathOnly(mzCustomerUrl('logout') || '/account/logout');
    try { window.location.assign(logoutUrl); return false; } catch (e) {}
    window.location.href = logoutUrl;
    return false;
  }

  return openCustomerPanel('orders');
}
window.openCustomerPanel = openCustomerPanel;
window.setCustomerPanelMode = setCustomerPanelMode;
window.mzAccountMenuAction = mzAccountMenuAction;
function mzNavigateAccountLink(el, ev) {
  if (ev && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button)) return true;
  if (ev) {
    if (ev.preventDefault) ev.preventDefault();
    if (ev.stopPropagation) ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
  }
  var kind = el && el.getAttribute ? el.getAttribute('data-account-kind') : null;
  return mzOpenAccountRoute(kind || 'login', ev);
}
function mzOpenAccountRoute(kind, ev) {
  if (ev) {
    if (ev.preventDefault) ev.preventDefault();
    if (ev.stopPropagation) ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
  }
  if (kind === 'logout') {
    mzNavigate(mzCustomerUrl('logout'));
    return false;
  }
  if (kind === 'register') return openLiveAccountScreen('register');
  if (kind === 'recover')  return openLiveAccountScreen('login');
  if ((window.__MOOZERS_ACCOUNT || {}).loggedIn) {
    openAccount();
    return false;
  }
  return openLiveAccountScreen('login');
}
window.goAccount = goAccount;
window.mzNavigateAccountLink = mzNavigateAccountLink;
window.mzOpenAccountRoute = mzOpenAccountRoute;

function setAccountScreenMode(mode) {
  mode = mode === 'register' ? 'register' : 'login';
  var login = document.getElementById('mz-login-mode');
  var register = document.getElementById('mz-register-mode');
  if (login) login.classList.toggle('active', mode === 'login');
  if (register) register.classList.toggle('active', mode === 'register');
  try {
    var focusTarget = mode === 'register'
      ? document.getElementById('RegisterEmailInline') || document.getElementById('RegisterFirstNameInline')
      : document.getElementById('CustomerEmailInline');
    setTimeout(function(){ if (focusTarget) focusTarget.focus(); }, 80);
  } catch(e) {}
}
function openLiveAccountScreen(mode) {
  closeAccount();
  setAccountScreenMode(mode || 'login');
  showScreen('s-account');
  return false;
}
window.setAccountScreenMode = setAccountScreenMode;
window.openLiveAccountScreen = openLiveAccountScreen;

// v16: account-icoon opent weer de account-popup; echte links blijven als fallback staan.
document.addEventListener('click', function(e) {
  var trigger = e.target.closest && e.target.closest('.mz-account-icon-trigger');
  if (!trigger) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
  e.preventDefault();
  openAccount();
}, true);

function mzInitials(name, email) {
  var base = String(name || email || 'Moozers').trim();
  var parts = base.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return base.slice(0,2).toUpperCase();
}
function openAccount() {
  renderAccountPanel();
  var overlay = document.getElementById('acc-overlay');
  if (overlay) overlay.classList.add('open');
}
function closeAccount() {
  var overlay = document.getElementById('acc-overlay');
  if (overlay) overlay.classList.remove('open');
}
function outsideCloseAcc(e) {
  if (e.target === document.getElementById('acc-overlay')) closeAccount();
}
function renderAccountPanel() {
  var guest    = document.getElementById('acc-guest');
  var loggedIn = document.getElementById('acc-loggedin');
  if (!guest || !loggedIn) return;
  var account = window.__MOOZERS_ACCOUNT || {};
  accountLoggedIn = !!account.loggedIn;
  if (accountLoggedIn) {
    guest.style.display = 'none';
    loggedIn.style.display = 'block';
    var initials = mzInitials(account.name, account.email);
    var ini = document.getElementById('acc-initials'); if (ini) ini.textContent = initials;
    var un  = document.getElementById('acc-uname'); if (un) un.textContent = account.name || account.email || 'Mijn account';
    var ue  = document.getElementById('acc-uemail'); if (ue) ue.textContent = account.email || '';
  } else {
    guest.style.display = 'block';
    loggedIn.style.display = 'none';
  }
  document.querySelectorAll('.acc-dot').forEach(function(d) { d.classList.toggle('show', accountLoggedIn); });
}


// v24: voorkom dat account-links in de mobiele/desktop preview naar de standaard Shopify klantlogin springen.
document.addEventListener('click', function(e) {
  var a = e.target.closest && e.target.closest('a[href]');
  if (!a) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
  var href = a.getAttribute('href') || '';
  if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
  var path = '';
  try { path = new URL(href, window.location.origin).pathname.toLowerCase(); } catch (err) { path = href.toLowerCase(); }
  var isAccountPath = path.indexOf('/account') === 0 || path.indexOf('/authentication') === 0 || path.indexOf('/challenge') === 0;
  if (!isAccountPath) return;
  if (path.indexOf('/account/logout') === 0) return;
  e.preventDefault();
  e.stopPropagation();
  if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  if (path.indexOf('/account/register') === 0) return openLiveAccountScreen('register');
  if ((window.__MOOZERS_ACCOUNT || {}).loggedIn) return openAccount();
  return openLiveAccountScreen('login');
}, true);

// v20: fallback-delegatie voor ingelogde account-menu knoppen.
document.addEventListener('click', function(e) {
  var el = e.target.closest && e.target.closest('[data-account-menu-action]');
  if (!el) return;
  mzAccountMenuAction(el.getAttribute('data-account-menu-action'), e);
}, true);



// ── Zakelijke BTW-informatie ─────────────────────────────
// De invoer en validatie van een Belgisch btw-nummer vinden uitsluitend
// plaats in Shopify Checkout. Het theme bewaart of valideert geen btw-nummer.
var b2bState = { active:false, vatNr:'', company:'', country:'' };

function syncB2BState() {
  b2bState = { active:false, vatNr:'', company:'', country:'' };
  try { localStorage.removeItem('moozers_b2b_vat'); } catch(e) {}
  return false;
}

function mzCartAttributesForVat() {
  return {};
}

// ── Accordions ─────────────────────────────────────────
function toggleAcc(header) {
  if (!header) return false;
  var body  = header.nextElementSibling;
  var arrow = header.querySelector('.acc-arrow');
  if (!body) return false;
  var open  = body.classList.contains('open');
  body.classList.toggle('open', !open);
  if (arrow) arrow.classList.toggle('open', !open);
  return false;
}

// ── Blog artikelen ──────────────────────────────────────
var articles = [
  {
    cat: 'Schilderstape', date: '12 mei 2025', time: '4 min lezen',
    img: 'https://www.moozers.nl/cdn/shop/files/MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png?v=1781333549',
    title: 'Hoe kies je de juiste schilderstape voor jouw klus?',
    body: '<p>Schilderstape is er in veel soorten en maten. Maar welke kies je nu voor welke klus? We leggen het uit.</p><h3>Breedte: 19, 24, 36 of 50mm?</h3><p>Een <strong>smallere tape (19–24mm)</strong> is ideaal voor kozijnen, plint en raamkozijnen. Een <strong>bredere tape (36–50mm)</strong> gebruik je voor grote vlakken, langs daklijsten of waar je meer overlap wilt.</p><h3>UV-bestendigheid</h3><p>Buiten schilderen? Kies altijd tape die minimaal 14 dagen UV-bestendig is, zoals onze MOOZERS® washi tape. Bij langdurige blootstelling aan zon bestaat het risico dat de lijm harder wordt en lijmresten achterlaat.</p><h3>Oppervlak</h3><p>Op gevoelige ondergronden (behang, matte verf, kalkverf) is washi tape ideaal — de lage kleefkracht voorkomt beschadiging bij verwijderen. Op hout, metaal of kunststof kun je een steviger tape gebruiken.</p><h3>Tip van de vakman</h3><p>"Ik test altijd eerst een klein stukje op een onzichtbare plek. Zo weet je zeker dat de verf er niet af gaat." — Kees V., schilder ZZP</p>'
  },
  {
    cat: 'Techniek', date: '3 april 2025', time: '6 min lezen',
    img: 'https://www.moozers.nl/cdn/shop/files/MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png?v=1781333455',
    title: '5 fouten bij afplakken die je als schilder wil vermijden',
    body: '<p>Afplakken lijkt simpel, maar er gaat regelmatig iets mis. Hier zijn de vijf meest gemaakte fouten — en hoe je ze voorkomt.</p><h3>1. Te vroeg afplakken</h3><p>Plak nooit af terwijl de verf nog nat is. Wacht tot de ondergrond volledig droog is (minimaal 24 uur voor meeste verven).</p><h3>2. Tape te hard aandrukken</h3><p>Druk de tape aan met een putty knife of nagel langs de rand. Zo voorkom je dat verf onderkruipt.</p><h3>3. Te laat verwijderen</h3><p>Verwijder de tape altijd terwijl de verf nog licht kleverig aanvoelt (tacky). Is de verf droog? Dan verhoog je het risico op het meescheuren van verf.</p><h3>4. Verkeerde tapehoek bij verwijderen</h3><p>Trek de tape altijd onder een hoek van 45° terug over zichzelf. Nooit loodrecht omhoog trekken — dat geeft de mooiste, scherpste lijn.</p><h3>5. Te goedkope tape gebruiken</h3><p>Goedkope tape hecht ongelijkmatig en laat vaker lijmresten achter. Investeer in kwaliteitstape — dat betaalt zich terug in schone afwerking.</p>'
  },
  {
    cat: 'Zakelijk', date: '18 maart 2025', time: '3 min lezen',
    img: '',
    title: 'Staffelkorting uitgelegd: hoeveel bespaar je als zzp-schilder?',
    body: '<p>Als zzp-schilder koop je regelmatig tape in. Maar hoe werkt staffelkorting nou precies, en hoeveel bespaar je?</p><h3>Hoe werkt het?</h3><p>Staffelkorting werkt op basis van het aantal rollen dat je per artikel bestelt. De korting wordt automatisch berekend in je winkelwagen — je hoeft er niks voor te doen.</p><h3>De staffels</h3><ul><li>1–23 rollen: normale prijs</li><li>24–71 rollen: −3% korting</li><li>72+ rollen: −10% korting</li></ul><h3>Actuele prijs</h3><p>De prijs per rol en de totale besparing worden live berekend vanuit Shopify. Bekijk de productpagina of winkelwagen voor het actuele bedrag bij jouw gekozen aantal.</p><h3>Tip</h3><p>Bestelt u regelmatig? Bewaar uw favoriete producten in uw account en herbestel in één klik. Combineer meerdere klussen in één bestelling voor extra korting.</p>'
  },
  {
    cat: 'Schuurmateriaal', date: '5 februari 2025', time: '5 min lezen',
    img: 'https://www.moozers.nl/cdn/shop/files/MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg?v=1781377934',
    title: 'Schuurpapier of schuurpad – wanneer gebruik je wat?',
    body: '<p>Schuurpapier en schuurpads: beide zijn onmisbaar, maar voor verschillende situaties. Hieronder leggen we het verschil uit.</p><h3>Schuurpapier</h3><p>Schuurpapier (vellen) is ideaal voor het schuren van grote, vlakke oppervlakken met een vlakschuiver of hand. De MOOZERS® APEX schuurpapier in 50-stuks pakken is zeer populair bij schilders die snel grote oppervlakten moeten schuren.</p><p><strong>Gebruik voor:</strong> muren, plafonds, plamuurlagen, hout.</p><h3>Schuurpad</h3><p>Een schuurpad is dubbelzijdig en eigenlijk altijd bruikbaar met de hand — zonder houder. Perfect voor hoeken, profileringen, kozijnen en kleine oppervlakten. De MOOZERS® schuurpads zijn dubbelzijdig: fijn aan de ene kant, grover aan de andere.</p><p><strong>Gebruik voor:</strong> kozijnen, hoeken, detailwerk, metaal voorbereiden.</p><h3>Korreligheid</h3><p>P80–P100 = grof (voor het verwijderen van materiaal), P120–P180 = middel (voor natwerk en gladmaken), P220+ = fijn (finishing voor de laatste laag).</p>'
  }
];
function showArticle(idx) {
  var a = articles[idx];
  if (!a) return;
  document.getElementById('article-cat').textContent   = a.cat;
  document.getElementById('article-title').textContent  = a.title;
  document.getElementById('article-meta').textContent   = a.date + ' · ' + a.time;
  document.getElementById('article-body').innerHTML     = a.body;
  var img = document.getElementById('article-img');
  if (a.img) {
    img.src = a.img;
    img.style.display = '';
    document.getElementById('article-banner').style.display = '';
  } else {
    img.style.display = 'none';
    document.getElementById('article-banner').style.display = 'none';
  }
  showScreen('s-article');
}

// ══════════════════════════════════════════════════════
//  ZOEKFUNCTIE — live search overlay
// ══════════════════════════════════════════════════════
var searchableProducts = [
  {id:'washi-tape', variantSize:'24', name:'Washi Tape Geel 24mm × 50m', tags:['washi','tape','24mm','geel','schilderstape'], img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781333549', priceExcl:2.008, priceIncl:2.43},
  {id:'washi-tape', variantSize:'19', name:'Washi Tape Geel 19mm × 50m', tags:['washi','tape','19mm','geel'], img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_19mm_x_50m.png', imgV:'1781333745', priceExcl:1.529, priceIncl:1.85},
  {id:'washi-tape', variantSize:'50', name:'Washi Tape Geel 50mm × 50m', tags:['washi','tape','50mm','geel'], img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_50mm_x_50m.png', imgV:'1781333478', priceExcl:4.570, priceIncl:5.53},
  {id:'washi-tape-paars', variantSize:'24', name:'Washi Tape Paars 24mm × 50m', tags:['washi','tape','24mm','paars'], img:'MOOZERS_-_Washi_-_Schilderstape_Paars_-_24mm_x_50m.png', imgV:'1781377963', priceExcl:2.198, priceIncl:2.66},
  {id:'washi-tape-paars', variantSize:'36', name:'Washi Tape Paars 36mm × 50m', tags:['washi','tape','36mm','paars','gevoelige ondergrond'], img:'MOOZERS_-_Washi_-_Schilderstape_Paars_-_36mm_x_50m.png', imgV:'1781332518', priceExcl:2.61, priceIncl:3.16},
  {id:'maskeerfolie', variantSize:'1500mm × 30m', name:'Maskeerfolie 1500mm × 30m', tags:['maskeerfolie','folie','1500mm'], img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png', imgV:'1781333455', priceExcl:4.12, priceIncl:4.99},
  {id:'maskeerpapier', variantSize:'300mm × 20m', name:'Maskeerpapier 300mm × 20m', tags:['maskeerpapier','papier','300mm'], img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png', imgV:'1781331618', priceExcl:3.71, priceIncl:4.49},
  {id:'joint-mesh-gaasband', variantSize:'50mm × 90m', name:'MOOZERS® Joint Mesh Gaasband 50mm × 90m', tags:['gaasband','joint mesh','glasvezel','gipsplaat','stucwerk','50mm','90m'], img:MZ_JOINT_MESH_STANDING, imgV:'', priceExcl:(MZ_JOINT_MESH_LIVE.priceExclCents ? MZ_JOINT_MESH_LIVE.priceExclCents / 100 : 6.45), priceIncl:(MZ_JOINT_MESH_LIVE.priceInclCents ? MZ_JOINT_MESH_LIVE.priceInclCents / 100 : 7.80)},
  {id:'schuurpapier', variantSize:'P100', name:'Schuurpapier 50 st. P100', tags:['schuurpapier','p100','schuur','apex'], img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', priceExcl:11.98, priceIncl:14.49},
  {id:'schuurschijf', variantSize:'P600', name:'Ronde schuurschijf 150mm P600 · 100 stuks', tags:['schuurschijf','ronde schuurschijf','schuur','p600','150mm','apex'], img:'schuurschijf_a086baaa-626f-4143-a9d9-eeb4c1c26d45.png', imgV:'1756201546', priceExcl:24.79, priceIncl:29.99},
  {id:'schuurschijf', variantSize:'P800', name:'Ronde schuurschijf 150mm P800 · 100 stuks', tags:['schuurschijf','ronde schuurschijf','schuur','p800','150mm','apex'], img:'schuurschijf_a086baaa-626f-4143-a9d9-eeb4c1c26d45.png', imgV:'1756201546', priceExcl:24.79, priceIncl:29.99},
  {id:'schuurschijf', variantSize:'P3000', name:'Ronde schuurschijf 150mm P3000 · 100 stuks', tags:['schuurschijf','ronde schuurschijf','schuur','p3000','150mm','apex'], img:'schuurschijf_a086baaa-626f-4143-a9d9-eeb4c1c26d45.png', imgV:'1756201546', priceExcl:24.79, priceIncl:29.99},
  {id:'schuurpad', variantSize:'P120', name:'Schuurpad Dubbelzijdig P120', tags:['schuurpad','p120','schuur'], img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg', imgV:'1781377934', priceExcl:0.93, priceIncl:1.13}
];
function openSearch() {
  document.getElementById('search-input').value = '';
  document.getElementById('search-tags').style.display = '';
  renderSearchResults('');
  document.getElementById('search-overlay').classList.add('open');
  setTimeout(function(){ document.getElementById('search-input').focus(); }, 120);
}
function closeSearch() { document.getElementById('search-overlay').classList.remove('open'); }
function outsideCloseSearch(e) { if (e.target === document.getElementById('search-overlay')) closeSearch(); }
function doSearch(q) {
  document.getElementById('search-tags').style.display = q.length > 0 ? 'none' : '';
  if (q.length > 0) document.getElementById('search-input').value = q;
  renderSearchResults(q);
}
function mzSearchProductImageUrl(product) {
  var raw = String(product && product.img || '').trim();
  if (!raw) return '';
  if (raw.indexOf('//') === 0) raw = 'https:' + raw;
  if (/^https?:\/\//i.test(raw) || raw.charAt(0) === '/') return raw;
  var url = IMG_BASE + raw;
  if (product.imgV) url += (url.indexOf('?') > -1 ? '&' : '?') + 'v=' + product.imgV;
  return url;
}
function renderSearchResults(q) {
  var el = document.getElementById('search-results');
  q = (q || '').toLowerCase().trim();
  var results = q.length === 0 ? searchableProducts.slice(0, 6) :
    searchableProducts.filter(function(p) {
      return p.name.toLowerCase().indexOf(q) >= 0 || p.tags.some(function(t) { return t.indexOf(q) >= 0; });
    });
  var label = q.length === 0 ? 'Populaire producten' : (results.length + ' resultaten voor "' + q + '"');
  var out = '<div class="search-results-label">' + label + '</div>';
  if (results.length === 0) {
    out += '<div class="search-empty">Geen producten gevonden.<br>Probeer "washi", "24mm" of "schuurpapier".</div>';
  } else {
    results.forEach(function(p) {
      out += '<div class="search-result" data-mz-pid="' + p.id + '" data-mz-vsize="' + (p.variantSize || '') + '" onclick="closeSearch();openProductFromSearch(\'' + p.id + '\',\'' + (p.variantSize || '') + '\')">' +
        '<img class="search-result-img" src="' + mzSearchProductImageUrl(p) + '" onerror="this.onerror=null;if(!this.getAttribute(\'src\'))return;this.style.opacity=\'1\';this.style.visibility=\'hidden\';if(this.parentElement){this.parentElement.classList.add(\'mz-img-missing\');}" alt="">' +
        '<div class="search-result-body">' +
          '<div class="search-result-name">' + p.name + '</div>' +
          '<div class="search-result-price mz-price-pending" aria-hidden="true">&nbsp;</div>' +
          '<div class="search-result-vat mz-price-pending" aria-hidden="true">&nbsp;</div>' +
        '</div>' +
        '<button class="search-result-add mz-pending-control" disabled aria-hidden="true">+ Voeg toe</button>' +
      '</div>';
    });
  }
  el.innerHTML = out;
  setTimeout(function(){ try { if (typeof mzApplySearchSaleBadges === 'function') mzApplySearchSaleBadges(); } catch(e) {} }, 0);
}
function openProductFromSearch(productId, variantSize) {
  if (variantSize && typeof loadProductVariant === 'function') return loadProductVariant(productId, variantSize);
  return loadProduct(productId);
}
function quickAddFromSearch(productId, img, imgV, priceExcl, priceIncl, btn, variantSize) {
  var prod = CATALOG[productId];
  var variant = mzFindVariantByImage(productId, img, variantSize);
  if (!prod || !variant || variant.inStock === false) {
    if (typeof mzShowCartNotice === 'function') mzShowCartNotice('Dit product is momenteel niet op voorraad.', 'error');
    return;
  }
  var name = variant ? variant.title : (prod && prod.variants && prod.variants[0] ? prod.variants[0].title : productId);
  if (variant) {
    priceIncl = variant.priceIncl != null ? parseFloat(variant.priceIncl) : priceIncl;
    priceExcl = variant.priceExcl != null ? parseFloat(variant.priceExcl) : priceExcl;
  }
  cart.push({
    title: name,
    label: variant ? variant.label : '',
    img: img,
    imgV: imgV,
    priceExcl: priceExcl,
    priceIncl: priceIncl,
    qty: 1,
    emoji: null,
    productId: productId,
    variantSize: variant ? (variant.size || variant.label || '') : '',
    shopifyHandle: variant ? mzBuildShopifyHandle(prod, variant) : mzInferShopifyHandle(name, '', img)
  });
  renderCart(); renderCartUpsell();
  if (btn) { var orig = btn.textContent; btn.textContent = '✓'; btn.style.background = '#1e7e34'; setTimeout(function() { btn.textContent = orig; btn.style.background = ''; }, 1200); }
}

// ══════════════════════════════════════════════════════
//  SLIMME WINKELWAGEN — upsell
// ══════════════════════════════════════════════════════
function getCartSuggestions() {
  var cartTitles = cart.map(function(i) { return i.title.toLowerCase(); });
  var all = [
    {name:'Maskeerpapier 300mm', priceIncl:4.49, img:'MOOZERS_-_Maskeerpapier_-_300MM_x_20M.png', imgV:'1781331618', keyword:'maskeerpapier', tag:'Past bij elk afplakwerk'},
    {name:'Maskeerfolie 1500mm', priceIncl:4.99, img:'MOOZERS_-_Maskeerfolie_-_1500MM_x_30M.png', imgV:'1781333455', keyword:'maskeerfolie', tag:'Dekt grote vlakken snel af'},
    {name:'Schuurpad P120', priceIncl:1.13, img:'MOOZERS_-_Schuurpad_Dubbelzijdig_-_P120.jpg', imgV:'1781377934', keyword:'schuurpad', tag:'Ideaal voor kozijnen en hoeken'},
    {name:'Schuurpapier 50st P100', priceIncl:14.49, img:'MOOZERS_-_Apex_Abrasives_-_100x150MM_-_Schuurpapier_-_50_stuks.png', imgV:'1781333914', keyword:'schuurpapier', tag:'Voor strak schuurwerk vóór het schilderen'},
    {name:'Washi Tape Geel 24mm', priceIncl:2.43, img:'MOOZERS_-_Washi_-_Schilderstape_geel_-_24mm_x_50m.png', imgV:'1781333549', keyword:'washi', tag:'Veelgebruikte breedte voor strak afplakken'}
  ];
  var s = [];
  all.forEach(function(x) { if (!cartTitles.some(function(t){ return t.indexOf(x.keyword) >= 0; }) && s.length < 3) s.push(x); });
  return s;
}
function renderCartUpsell() {
  var el = document.getElementById('cart-upsell');
  if (!el) return;
  if (cart.length === 0) { el.style.display = 'none'; return; }
  var sg = getCartSuggestions();
  window.__MZ_LAST_UPSELL_SUGGESTIONS = sg;
  if (sg.length === 0) { el.style.display = 'none'; return; }
  el.style.display = '';
  var out = '<div class="cart-upsell-title">🛒 Je vergat misschien:</div>';
  sg.forEach(function(s, sIndex) {
    var pe = (s.priceIncl / 1.21).toFixed(3);
    out += '<div class="upsell-item" data-mz-upsell-index="' + sIndex + '">' +
      '<img class="upsell-img" src="https://www.moozers.nl/cdn/shop/files/' + s.img + '?v=' + s.imgV + '" onerror="this.onerror=null;if(!this.getAttribute(\'src\'))return;this.style.opacity=\'1\';this.style.visibility=\'hidden\';if(this.parentElement){this.parentElement.classList.add(\'mz-img-missing\');}" alt="">' +
      '<div class="upsell-info"><div class="upsell-name">' + s.name + '</div>' +
      (s.tag ? '<div style="font-size:10px;color:var(--muted);margin-top:2px;line-height:1.3;">' + s.tag + '</div>' : '') +
      '<div class="upsell-price mz-price-pending" aria-hidden="true">&nbsp;</div>' +
      '<div class="upsell-price-incl mz-price-pending" aria-hidden="true" style="font-size:10px;color:var(--muted);margin-top:1px">&nbsp;</div></div>' +
      '<button class="upsell-add mz-pending-control" disabled aria-hidden="true">+ Voeg toe</button>' +
    '</div>';
  });
  el.innerHTML = out;
  setTimeout(function(){ try { mzSyncUpsellPrices(); } catch(e) {} }, 0);
}

function mzSyncUpsellPrices() {
  var sg = window.__MZ_LAST_UPSELL_SUGGESTIONS || [];
  var nodes = document.querySelectorAll('#cart-upsell .upsell-item[data-mz-upsell-index]');
  Array.prototype.forEach.call(nodes, function(node, index){
    var sIndex = parseInt(node.getAttribute('data-mz-upsell-index'), 10);
    var suggestion = sg[sIndex];
    if (!suggestion) return;
    var handle = mzInferShopifyHandle(suggestion.name, suggestion.name, suggestion.img);
    if (!handle) return;
    var priceEl = node.querySelector('.upsell-price');
    var inclEl = node.querySelector('.upsell-price-incl');
    var badgeEl = mzEnsureSaleBadgeBefore(priceEl, 'mz-sale-badge-card');
    mzRunSaleBadgeLater(function(){
      return mzFetchShopifyProduct(handle).then(function(shopProduct){
        var summary = mzShopifyProductPriceSummary(shopProduct, suggestion.name || '');
        if (!summary) return null;
        suggestion.priceIncl = summary.priceInclCents / 100;
        suggestion.priceExcl = summary.priceExclCents / 100;
        if (priceEl) { priceEl.classList.remove('mz-price-pending'); priceEl.removeAttribute('aria-hidden'); priceEl.innerHTML = mzFormatCents(summary.priceExclCents) + ' <span style="font-size:10px;font-weight:600;color:var(--muted)">excl. BTW</span>'; }
        if (inclEl) { inclEl.classList.remove('mz-price-pending'); inclEl.removeAttribute('aria-hidden'); inclEl.textContent = mzFormatCents(summary.priceInclCents) + ' incl. BTW'; }
        mzSetSaleBadgeElement(badgeEl, mzSaleFromShopifyVariant(summary.variant));
        var btn = node.querySelector('.upsell-add');
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('mz-pending-control');
          btn.removeAttribute('aria-hidden');
          btn.textContent = '+ Voeg toe';
          btn.setAttribute('onclick', 'quickAddUpsell(' + JSON.stringify(suggestion.name) + ',' + JSON.stringify(suggestion.img) + ',' + JSON.stringify(suggestion.imgV || '') + ',' + suggestion.priceExcl + ',' + suggestion.priceIncl + ')');
        }
        return summary;
      }).catch(function(){ return null; });
    }, index * 20);
  });
}

function quickAddUpsell(name, img, imgV, pe, pi) {
  cart.push({title: name, label: '', img: img, imgV: imgV, priceExcl: parseFloat(pe), priceIncl: parseFloat(pi), qty: 1, emoji: null,
    shopifyHandle: mzInferShopifyHandle(name, '', img), variantSize: name});
  renderCart(); renderCartUpsell();
}

// ══════════════════════════════════════════════════════
//  COLLECTIE FILTERS
// ══════════════════════════════════════════════════════
var collFilters = {breedte: 'alle', kleur: 'alle'};
function setCollFilter(type, value) {
  collFilters[type] = value;
  document.querySelectorAll('.coll-filter-btn[data-filter-type="' + type + '"]').forEach(function(b) {
    b.classList.toggle('active', b.dataset.filterValue === value);
  });
  applyCollFilters();
}
function applyCollFilters() {
  var cards = document.querySelectorAll('#coll-grid .prod-card');
  var n = 0;
  cards.forEach(function(c) {
    var show = (collFilters.breedte === 'alle' || c.dataset.breedte === collFilters.breedte) &&
               (collFilters.kleur   === 'alle' || c.dataset.kleur   === collFilters.kleur);
    c.style.display = show ? '' : 'none';
    if (show) n++;
  });
  var el = document.getElementById('coll-prod-count');
  if (el) el.textContent = n + ' product' + (n !== 1 ? 'en' : '');
}

// v134: Categoriekaarten blijven zichtbaar, ook wanneer Shopify aangeeft dat
// het product uitverkocht is. Uitverkochte kaarten krijgen alleen een badge.
function mzSetCollectionCardStockState(card, state) {
  if (!card) return;
  var isOos = state === 'false';
  card.setAttribute('data-stock-available', state || 'loading');
  card.classList.toggle('mz-card-oos', isOos);

  var pci = card.querySelector ? card.querySelector('.pci') : null;
  if (!pci) return;

  var badge = pci.querySelector('.mz-oos-sticker');
  if (isOos) {
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'pci-sticker mz-oos-sticker';
      badge.textContent = 'Uitverkocht';
      pci.appendChild(badge);
    }
  } else if (badge) {
    badge.parentNode.removeChild(badge);
  }
}

function mzProductHandleFromHref(href) {
  try {
    if (!href) return '';
    var url = new URL(String(href), window.location.origin);
    var m = url.pathname.match(/\/products\/([^\/?#]+)/);
    return m && m[1] ? decodeURIComponent(m[1]) : '';
  } catch(e) {
    var raw = String(href || '');
    var mm = raw.match(/\/products\/([^\/?#]+)/);
    return mm && mm[1] ? decodeURIComponent(mm[1]) : '';
  }
}

// v135: alle productkaarten op categoriepagina's krijgen automatisch een
// live Shopify-voorraadhandle. Daardoor blijven ook oudere/statische kaarten
// zichtbaar en kan dezelfde bestaande code overal het label 'Uitverkocht' tonen.
function mzPrepareCollectionLiveStockCards() {
  var cards;
  try {
    cards = document.querySelectorAll(
      '#s-collection .prod-card[href*="/products/"], .screen[id^="s-coll"] .prod-card[href*="/products/"]'
    );
  } catch(e) { return; }

  Array.prototype.forEach.call(cards || [], function(card) {
    if (!card || card.getAttribute('data-mz-live-stock-handle')) return;
    var handle = mzProductHandleFromHref(card.getAttribute('href') || '');
    if (!handle) return;
    card.setAttribute('data-mz-live-stock-handle', handle);
    if (!card.getAttribute('data-stock-available')) {
      card.setAttribute('data-stock-available', 'loading');
    }
  });
}

// v136: snelle voorraadcontrole voor categoriekaarten.
// - alle kaarten blijven zichtbaar; alleen de badge verandert;
// - per producthandle maximaal één request tegelijk;
// - korte cache voorkomt dubbele requests bij filteren/navigeren;
// - requests worden beperkt parallel uitgevoerd zodat de pagina snel klikbaar blijft.
var mzCollectionStockCache = {};
var mzCollectionStockRunning = false;
var mzCollectionStockQueued = false;
var mzCollectionStockTtlMs = 120000;
var mzCollectionStockConcurrency = 4;

function mzGetCollectionStockState(handle) {
  handle = String(handle || '').replace(/^\/products\//, '').replace(/^\/+|\/+$/g, '');
  if (!handle) return Promise.resolve('loading');

  var now = Date.now ? Date.now() : new Date().getTime();
  var cached = mzCollectionStockCache[handle];
  if (cached && cached.expires > now && cached.promise) return cached.promise;

  var promise;
  try {
    promise = mzFetchShopifyProduct(handle, { force:true }).then(function(shopProduct) {
      var available = false;
      if (shopProduct && Array.isArray(shopProduct.variants)) {
        available = shopProduct.variants.some(function(v) { return v && v.available === true; });
      }
      return available ? 'true' : 'false';
    }).catch(function() {
      // Netwerkfout: niet als uitverkocht markeren en niets verbergen.
      return 'loading';
    });
  } catch(e) {
    promise = Promise.resolve('loading');
  }

  mzCollectionStockCache[handle] = { promise: promise, expires: now + mzCollectionStockTtlMs };
  return promise;
}

function mzApplyCollectionFiltersOnce() {
  try { if (typeof applyCollFilters === 'function') applyCollFilters(); } catch(e) {}
}

function mzSyncCollectionLiveStockCards() {
  if (mzCollectionStockRunning) { mzCollectionStockQueued = true; return; }
  mzCollectionStockRunning = true;

  try { mzPrepareCollectionLiveStockCards(); } catch(e0) {}

  var cards;
  try { cards = document.querySelectorAll('.prod-card[data-mz-live-stock-handle]'); } catch(e) { mzCollectionStockRunning = false; return; }
  if (!cards || !cards.length) { mzCollectionStockRunning = false; mzApplyCollectionFiltersOnce(); return; }

  var byHandle = {};
  Array.prototype.forEach.call(cards, function(card) {
    if (!card) return;
    var handle = card.getAttribute('data-mz-live-stock-handle') || '';
    handle = String(handle).replace(/^\/products\//, '').replace(/^\/+|\/+$/g, '');
    if (!handle) return;
    if (!byHandle[handle]) byHandle[handle] = [];
    byHandle[handle].push(card);
    if (!card.getAttribute('data-stock-available')) card.setAttribute('data-stock-available', 'loading');
    card.style.display = '';
  });

  var handles = Object.keys(byHandle);
  if (!handles.length) { mzCollectionStockRunning = false; mzApplyCollectionFiltersOnce(); return; }

  var index = 0;
  var active = 0;

  function finish() {
    mzCollectionStockRunning = false;
    mzApplyCollectionFiltersOnce();
    if (mzCollectionStockQueued) {
      mzCollectionStockQueued = false;
      setTimeout(mzSyncCollectionLiveStockCards, 120);
    }
  }

  function runNext() {
    if (index >= handles.length && active === 0) { finish(); return; }
    while (active < mzCollectionStockConcurrency && index < handles.length) {
      (function(handle) {
        active++;
        mzGetCollectionStockState(handle).then(function(state) {
          (byHandle[handle] || []).forEach(function(card) {
            mzSetCollectionCardStockState(card, state);
            card.style.display = '';
          });
        }).catch(function() {
          (byHandle[handle] || []).forEach(function(card) {
            mzSetCollectionCardStockState(card, 'loading');
            card.style.display = '';
          });
        }).then(function() {
          active--;
          runNext();
        });
      })(handles[index++]);
    }
  }

  runNext();
}
function sortCollection(val) {
  var grid = document.getElementById('coll-grid');
  if (!grid) return;
  var cards = Array.from(grid.querySelectorAll('.prod-card'));
  var price = function(c) {
    var t = (c.querySelector('.pcb-price') || {textContent:''}).textContent;
    return parseFloat(t.replace(/[^\d,]/g,'').replace(',','.')) || 0;
  };
  if (val === 'laag-hoog') cards.sort(function(a,b){ return price(a)-price(b); });
  if (val === 'hoog-laag') cards.sort(function(a,b){ return price(b)-price(a); });
  cards.forEach(function(c){ grid.appendChild(c); });
}


// Herstel na terugnavigatie vanuit Shopify Checkout zonder een geforceerde reload.
// Bij BFCache blijft de in-memory cart bestaan; bij een volledige reload komt hij
// uit sessionStorage. Alleen wanneer Shopify na checkout echt een lege cart meldt
// (bijvoorbeeld na een afgeronde bestelling) wordt de opgeslagen cart gewist.
function mzRestoreCartAfterPageShow() {
  mzCheckoutInProgress = false;
  if (typeof mzSetCheckoutLoading === 'function') mzSetCheckoutLoading(false);
  if (!Array.isArray(cart) || !cart.length) mzRestoreCartState();
  if (typeof renderCart === 'function') renderCart(true);

  // Bij de eerste pagina van een nieuwe browsersessie mag een oude Shopify-cart
  // nooit terug in de zichtbare cart worden gehydrateerd. Wacht eerst op de reset.
  if (mzFreshBrowserCartSession) {
    return mzBrowserCartSessionReady.then(function() {
      try { sessionStorage.removeItem(MZ_CHECKOUT_RETURN_KEY); } catch(e) {}
      if (typeof renderCart === 'function') renderCart(true);
      if (cart.length && typeof mzScheduleDisplayCartShopifySync === 'function') {
        mzScheduleDisplayCartShopifySync(0, false);
      }
    });
  }

  var departed = false;
  try { departed = !!sessionStorage.getItem(MZ_CHECKOUT_RETURN_KEY); } catch(e) {}

  return mzFetchRealShopifyCart().then(function(realCart) {
    if (realCart && Array.isArray(realCart.items) && realCart.items.length) {
      if (!cart.length) mzHydrateCartFromShopify(realCart);
      try { sessionStorage.removeItem(MZ_CHECKOUT_RETURN_KEY); } catch(e) {}
      if (typeof renderCart === 'function') renderCart(true);
      if (typeof mzScheduleDisplayCartShopifySync === 'function') mzScheduleDisplayCartShopifySync(0, false);
      return;
    }
    if (departed) {
      cart = [];
      mzPersistCartState();
      try { sessionStorage.removeItem(MZ_CHECKOUT_RETURN_KEY); } catch(e) {}
      if (typeof renderCart === 'function') renderCart(true);
    }
  }).catch(function() {
    // Netwerkfout: behoud de lokaal opgeslagen cart; nooit leegmaken op onzekerheid.
  });
}

window.addEventListener('pageshow', function() {
  mzRestoreCartAfterPageShow();
});
window.addEventListener('pagehide', function() {
  mzPersistCartState();
});

// ══════════════════════════════════════════════════════
//  INIT — preload product data, start on homepage
// ══════════════════════════════════════════════════════
loadProduct('washi-tape'); // preloads product data (showScreen call inside is suppressed by homepage active state)
showScreen('s-home');      // ensure homepage is active
renderCart();
renderAccountPanel();


  /* ═══════ Desktop mega menu — v16 hover-first ══════════════════ */
  function initDesktopMenu() {
    var hdr = document.getElementById('desk-hdr');
    if (!hdr) return;
    var nav = hdr.querySelector('.desk-nav');

    /* Remove all JS-added open states. */
    function closeAllDesktopDropdowns() {
      hdr.querySelectorAll('.desk-nav-item.drop-open').forEach(function(el) {
        el.classList.remove('drop-open');
      });
    }
    window.closeAllDrops = closeAllDesktopDropdowns;

    /* True pointer device (desktop)? If yes, CSS :hover is sufficient. */
    function hasHover() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    hdr.querySelectorAll('.desk-nav-item').forEach(function(item) {
      var link = item.querySelector('.desk-nav-link');
      var hasDrop = item.querySelector('.desk-drop') || item.querySelector('.desk-mega');
      if (!link || !hasDrop) return;

      /* mouseenter: clear any pinned drop-open class so CSS :hover takes
         over cleanly. Without this, a previously clicked item stays open
         while another is hovered — the classic "overlap" bug. */
      item.addEventListener('mouseenter', function() {
        closeAllDesktopDropdowns();
      });

      /* click: desktop → do nothing (CSS :hover handles open/close).
                touch  → toggle drop-open for this item. */
      link.addEventListener('click', function(e) {
        if (hasHover()) return;   // desktop: no click-pinning
        e.preventDefault();
        e.stopPropagation();
        var wasOpen = item.classList.contains('drop-open');
        closeAllDesktopDropdowns();
        if (!wasOpen) item.classList.add('drop-open');
      });
    });

    /* Dropdown links: clear pinned state; inline onclick then navigates. */
    hdr.querySelectorAll('.desk-drop-link, .desk-mega-link').forEach(function(a) {
      a.addEventListener('click', function() { closeAllDesktopDropdowns(); });
    });

    /* Mouse leaves the entire nav bar: remove any pinned state. */
    if (nav) {
      nav.addEventListener('mouseleave', function() {
        closeAllDesktopDropdowns();
      });
    }

    /* Outside click: close (handles touch + keyboard navigation). */
    document.addEventListener('click', function(e) {
      if (!hdr.contains(e.target)) closeAllDesktopDropdowns();
    });
  }

  /* Script is at bottom of <body> — DOM is fully parsed. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopMenu);
  } else {
    initDesktopMenu();
  }

  /* ═══════ Desktop nav active state + cart badge sync ═══════ */
  (function() {
    var _orig = showScreen;
    showScreen = function(id) {
      if (typeof window.closeAllDrops === 'function') {
        window.closeAllDrops();
      }
      _orig.call(this, id);
      window.scrollTo(0, 0);
      document.querySelectorAll('.desk-nav-link').forEach(function(a) {
        a.classList.remove('active');
        var oc = a.getAttribute('onclick') || '';
        if (oc.indexOf("'" + id + "'") !== -1) a.classList.add('active');
      });
    };
    document.addEventListener('DOMContentLoaded', function() {
      var s = document.querySelector('.screen.active');
      if (s) {
        document.querySelectorAll('.desk-nav-link').forEach(function(a) {
          a.classList.remove('active');
          var oc = a.getAttribute('onclick') || '';
          if (oc.indexOf("'" + s.id + "'") !== -1) a.classList.add('active');
        });
      }
      /* Sync desk-cart-badge with mobile cart badge */
      document.querySelectorAll('.cart-badge').forEach(function(b) {
        if (b.id === 'desk-cart-badge') return;
        var obs = new MutationObserver(function() {
          var n = parseInt(b.textContent) || 0;
          var db = document.getElementById('desk-cart-badge');
          if (db) {
            db.style.display = n > 0 ? 'flex' : 'none';
            db.textContent = b.textContent;
          }
        });
        obs.observe(b, { childList: true, subtree: true, characterData: true });
      });
    });
  })();


  /* ── Compatibele route naar de schilderstape-collectie ─────── */
  function goToBestsellers() {
    window.location.assign('/collections/washi-tape');
  }

  /* Navigate to a screen then scroll to a named section within it. */
  function navToSection(screenId, sectionId) {
    showScreen(screenId);
    setTimeout(function() {
      var el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
  }

  /* ── Washi Tape kleur picker ─────────────────────────────────── */
  function renderColorPicker() {
    var p    = currentProduct;
    var sect = document.getElementById('color-section');
    if (!sect) return;
    if (!p || !p.colorVariants || p.colorVariants.length < 2) {
      sect.style.display = 'none';
      return;
    }
    sect.style.display = 'block';
    var activeIdx = (typeof p.activeColorIndex !== 'undefined') ? p.activeColorIndex : 0;
    var lbl = document.getElementById('c-label');
    if (lbl) lbl.textContent = p.colorVariants[activeIdx].label;
    var html = '';
    p.colorVariants.forEach(function(colVar, idx) {
      var isActive = (idx === activeIdx);
      html += '<div class="cpill' + (isActive ? ' active' : '') + '" onclick="selectColor(\'' + colVar.productId + '\')">';
      html += '<div class="cpill-dot" style="background:' + colVar.color + ';"></div>';
      html += colVar.label + '</div>';
    });
    var grid = document.getElementById('color-grid');
    if (grid) grid.innerHTML = html;
  }

  function selectColor(productId) {
    if (currentProduct && currentProduct.id === productId) return;
    var prevSize = cv ? cv.size : null;
    loadProduct(productId);
    // Probeer zelfde breedte te herstellen
    if (prevSize && currentProduct && currentProduct.variants) {
      var vars = currentProduct.variants;
      for (var i = 0; i < vars.length; i++) {
        if (vars[i].size === prevSize && vars[i].inStock) {
          var pills = document.querySelectorAll('#variant-grid .vpill');
          if (pills[i]) selectV(pills[i], i);
          break;
        }
      }
    }
  }

  /* ── Patch loadProduct: renderColorPicker aanroepen ──────────── */
  (function() {
    var _origLoadProduct = loadProduct;
    loadProduct = function(id) {
      _origLoadProduct.call(this, id);
      renderColorPicker();
    };
  })();


/* ═══════ Live stabilisatie: product-handle naar juiste prototype-product ═══════ */
function mzSelectDozenVariantByParts(kleur, breedte, inhoud) {
  loadProduct('dozen-tape');
  try {
    dozenKleur = kleur.charAt(0).toUpperCase() + kleur.slice(1).toLowerCase();
    dozenBreedte = String(breedte);
    dozenInhoud = parseInt(inhoud, 10);
    renderDozenColorRow();
    renderDozenBreedteRow();
    renderDozenInhoudRow();
    setDozenCV();
  } catch (e) {
    console.warn('Kon doosvariant niet direct selecteren:', e);
  }
  showScreen('s-product');
}

function mzLoadProductFromHandle(handle) {
  handle = String(handle || '').toLowerCase().replace(/^\/+|\/+$/g, '');
  var m;

  m = handle.match(/^moozers-washi-tape-(geel|paars)-(19|24|36|50)mm$/);
  if (m) {
    loadProductVariant(m[1] === 'paars' ? 'washi-tape-paars' : 'washi-tape', m[2]);
    return true;
  }

  m = handle.match(/^moozers-maskeerfolie-(1500|2700)mm$/);
  if (m) {
    loadProductVariant('maskeerfolie', m[1] + (m[1] === '2700' ? 'mm × 20m' : 'mm × 30m'));
    return true;
  }

  if (handle === 'moozers-maskeerpapier-300mm-x-20m') {
    loadProduct('maskeerpapier');
    return true;
  }

  if (handle.replace(/®/g, '') === 'moozers-joint-mesh-gaasband-50mm-x-90m') {
    loadProduct('joint-mesh-gaasband');
    return true;
  }

  m = handle.match(/^moozers-schuurpad-dubbelzijdig-p(80|100|120|150|180|220|240|320)$/);
  if (m) {
    loadProductVariant('schuurpad', 'P' + m[1]);
    return true;
  }

  m = handle.match(/^moozers-apex-abrasives-p(80|100|120|150|180|220|240|320)-100x150mm$/);
  if (m) {
    loadProductVariant('schuurpapier', 'P' + m[1]);
    return true;
  }

  m = handle.match(/^moozers-apex-abrasives-schuurschijf-150mm-p(40|60|80|100|120|150|180|320|400|600|800|1200|3000)$/);
  if (m) {
    loadProductVariant('schuurschijf', 'P' + m[1]);
    return true;
  }

  if (handle === 'moozers-glasschraper') {
    loadProduct('glasschraper');
    return true;
  }

  m = handle.match(/^doos-moozers-washi-tape-(geel|paars)-(19|24|36|50)mm-(24|36|54|72)rollen$/);
  if (m) {
    mzSelectDozenVariantByParts(m[1], m[2], m[3]);
    return true;
  }

  // Apex Mesh schuurgaas — drie maten (150mm / 125mm / 80x133mm), vijf korrels
  m = handle.replace(/®/g, '').match(/^moozers-apex-mesh-p(150|180|220|240|320)-(150|125|80x133)mm-schuurgaas-50-stuks/);
  if (m) {
    var meshKorrel = 'P' + m[1];
    var meshMaatMap = { '150': '150mm', '125': '125mm', '80x133': '80×133mm' };
    var meshMaat = meshMaatMap[m[2]] || '150mm';
    if (typeof loadMesh === 'function') loadMesh(meshMaat, meshKorrel);
    return true;
  }

  return false;
}
window.mzLoadProductFromHandle = mzLoadProductFromHandle;

// ── Apex Mesh: 2D-picker (maat × korrel) ─────────────────────────────────
var _meshMaat   = '150mm';
var _meshKorrel = 'P150';

// Zoek een variant in een mesh-CATALOG-product op basis van maat en korrel
function _meshFindVariant(product, maat, korrel) {
  if (!product || !product.variants) return null;
  for (var i = 0; i < product.variants.length; i++) {
    var v = product.variants[i];
    if (v.maat === maat && v.korrel === korrel) return v;
  }
  return null;
}

// Geeft array van korrels die voor de opgegeven maat beschikbaar zijn (volgorde CATALOG)
function _meshKorrelForMaat(product, maat) {
  if (!product || !product.variants) return ['P150','P180','P220','P240','P320'];
  var result = [];
  product.variants.forEach(function(v) {
    if (v.maat === maat && result.indexOf(v.korrel) < 0) result.push(v.korrel);
  });
  return result.length ? result : ['P150','P180','P220','P240','P320'];
}

// ── loadMesh: dispatcher voor beide Apex Mesh-producten ──────────────────────
// Wordt door history-IIFE (v90) gewrapt → URL-update automatisch
// Gebruikt loadProduct('apex-mesh-rond') of loadProduct('apex-mesh-80x133')
// zodat de bestaande s-product layout zonder aanpassingen werkt.
function loadMesh(maat, korrel) {
  _meshMaat   = maat   || '150mm';
  _meshKorrel = korrel || 'P150';

  if (_meshMaat === '80×133mm') {
    // ── Apex Mesh 80×133mm: eigen productpagina ───────────────────────────────
    var p80 = CATALOG['apex-mesh-80x133'];
    if (!p80) return;
    var idx80 = 0;
    for (var i = 0; i < p80.variants.length; i++) {
      if (p80.variants[i].korrel === _meshKorrel) { idx80 = i; break; }
    }
    p80.defaultVariantIndex = idx80;
    loadProduct('apex-mesh-80x133');
  } else {
    // ── Apex Mesh Rond (125mm + 150mm): gezamenlijke productpagina ────────────
    var pR = CATALOG['apex-mesh-rond'];
    if (!pR) return;
    // Zorg dat korrel geldig is voor gekozen maat
    var beschikbaar = _meshKorrelForMaat(pR, _meshMaat);
    if (beschikbaar.indexOf(_meshKorrel) < 0) _meshKorrel = beschikbaar[0] || 'P150';
    var idxR = 0;
    for (var j = 0; j < pR.variants.length; j++) {
      if (pR.variants[j].maat === _meshMaat && pR.variants[j].korrel === _meshKorrel) { idxR = j; break; }
    }
    pR.defaultVariantIndex = idxR;
    loadProduct('apex-mesh-rond');
  }
}

// ── Pill-handlers ─────────────────────────────────────────────────────────────
// Beiden roepen loadMesh aan → history-wrapper vangt dit op → URL-update
function selectMeshMaat(maat) {
  // Behoud huidige korrel indien geldig voor nieuwe maat
  var beschikbaar = _meshKorrelForMaat(CATALOG['apex-mesh-rond'], maat);
  var k = (beschikbaar.indexOf(_meshKorrel) >= 0) ? _meshKorrel : (beschikbaar[0] || 'P150');
  loadMesh(maat, k);
}

function selectMeshKorrel(korrel) {
  loadMesh(_meshMaat, korrel);
}

// Compat-stub: updateMeshCta wordt nergens meer nodig, s-product gebruikt updateCtaPrice
function updateMeshCta() {
  if (typeof updateCtaPrice === 'function') updateCtaPrice();
}




/* ═══════ Cartprijs direct vóór checkout synchroniseren ═══════ */
(function(){
  function mzIsCartScreenActive() {
    var el = document.getElementById('s-cart');
    return !!(el && el.classList.contains('active'));
  }
  function mzSyncCartDisplaySoon(delay, force) {
    if (typeof mzScheduleDisplayCartShopifySync !== 'function') return;
    if (!Array.isArray(cart) || !cart.length) return;
    mzScheduleDisplayCartShopifySync(delay == null ? 0 : delay, !!force);
  }

  if (typeof showScreen === 'function') {
    var originalShowScreenCartPrice = showScreen;
    showScreen = function(id) {
      var out = originalShowScreenCartPrice.apply(this, arguments);
      if (id === 's-cart') setTimeout(function(){ mzSyncCartDisplaySoon(650, true); }, 0);
      return out;
    };
  }

  if (typeof goToCart === 'function') {
    var originalGoToCartCartPrice = goToCart;
    goToCart = function() {
      var out = originalGoToCartCartPrice.apply(this, arguments);
      setTimeout(function(){ mzSyncCartDisplaySoon(650, true); }, 0);
      return out;
    };
  }

  function mzAfterCartChanged() {
    if (mzIsCartScreenActive()) setTimeout(function(){ mzSyncCartDisplaySoon(160, true); }, 0);
  }

  if (typeof cartSetQty === 'function') {
    var originalCartSetQtyCartPrice = cartSetQty;
    cartSetQty = function() {
      var out = originalCartSetQtyCartPrice.apply(this, arguments);
      mzAfterCartChanged();
      return out;
    };
  }

  if (typeof cartQty === 'function') {
    var originalCartQtyCartPrice = cartQty;
    cartQty = function() {
      var out = originalCartQtyCartPrice.apply(this, arguments);
      mzAfterCartChanged();
      return out;
    };
  }

  if (typeof removeItem === 'function') {
    var originalRemoveItemCartPrice = removeItem;
    removeItem = function() {
      var out = originalRemoveItemCartPrice.apply(this, arguments);
      mzAfterCartChanged();
      return out;
    };
  }

  document.addEventListener('DOMContentLoaded', function(){
    if (mzIsCartScreenActive()) mzSyncCartDisplaySoon(0, true);
  });
})();

/* ═══════ v100: één betrouwbare route-initialisatie op basis van de echte URL ═══════ */
(function() {
  'use strict';

  var MZ_NATIVE_SCREEN_ROUTES = {
    '/': 's-home',
    '/cart': 's-cart',
    '/search': 's-home',
    '/collections': 's-collection',
    '/collections/all': 's-collection',
    '/collections/bestsellers': 's-home',
    '/collections/washi-tape': 's-collection',
    '/collections/dozen-washi-tape': 's-coll-dozen',
    '/collections/maskeerfolie': 's-coll-maskeer',
    '/collections/schuur-materialen': 's-coll-schuur',
    '/collections/apex-mesh': 's-coll-apex',
    '/collections/gereedschap': 's-coll-gereedschap',
    '/pages/zakelijk-bestellen': 's-zakelijk',
    '/pages/bestel-zonder-btw': 's-zakelijk',
    '/pages/bestellen-zonder-btw': 's-zakelijk',
    '/pages/over-ons': 's-over',
    '/pages/contact': 's-contact',
    '/pages/verzending': 's-verzending',
    '/pages/faq': 's-faq',
    '/pages/privacybeleid': 's-privacy',
    '/pages/privacy': 's-privacy',
    '/pages/algemene-voorwaarden': 's-av',
    '/blogs/nieuws': 's-blog'
  };

  function mzNativeNormalizePath(value) {
    var raw = String(value == null ? '' : value);
    try {
      if (/^https?:\/\//i.test(raw)) raw = new URL(raw).pathname;
    } catch (e) {}
    raw = raw.split('?')[0].split('#')[0];
    try { raw = decodeURI(raw); } catch (e2) {}
    raw = raw.replace(/\/+$/, '');
    return (raw || '/').toLowerCase();
  }

  function mzNativeActivateScreen(id) {
    var target = document.getElementById(id);
    if (!target || !target.classList || !target.classList.contains('screen')) return false;

    /* Laat bestaande wrappers hun lokale neveneffecten uitvoeren, maar dwing
       daarna altijd exact één zichtbaar scherm af. */
    if (typeof window.showScreen === 'function') {
      try { window.showScreen(id); } catch (e) {}
    }

    document.querySelectorAll('.screen').forEach(function(screen) {
      screen.classList.toggle('active', screen === target);
      if (screen !== target) screen.scrollTop = 0;
    });
    target.scrollTop = 0;

    try {
      document.documentElement.classList.toggle('mz-cart-screen-active', id === 's-cart');
      if (document.body) document.body.classList.toggle('mz-cart-screen-active', id === 's-cart');
      window.scrollTo(0, 0);
    } catch (e2) {}

    /* Bescherm tegen een vertraagde oudere initialisatie die alsnog Home activeert. */
    setTimeout(function() {
      var currentTarget = document.getElementById(id);
      if (!currentTarget) return;
      document.querySelectorAll('.screen').forEach(function(screen) {
        screen.classList.toggle('active', screen === currentTarget);
      });
    }, 0);

    return true;
  }

  function mzNativeOpenProduct(path) {
    var rawHandle = path.slice('/products/'.length).split('/')[0];
    var handle = rawHandle;
    try { handle = decodeURIComponent(rawHandle); } catch (e) {}

    var loaded = false;
    if (typeof window.mzLoadProductFromHandle === 'function') {
      try { loaded = !!window.mzLoadProductFromHandle(handle); } catch (e2) { loaded = false; }
    }

    /* Alle huidige Moozers-producthandles worden door mzLoadProductFromHandle
       afgehandeld. Toon alleen het productscherm wanneer het product echt geladen is. */
    if (!loaded) return false;
    return mzNativeActivateScreen('s-product');
  }

  function mzNativeShowAccount(path) {
    var loggedIn = !!((window.__MOOZERS_ACCOUNT || {}).loggedIn);
    mzNativeActivateScreen('s-account');
    setTimeout(function() {
      try {
        if (loggedIn && typeof window.setCustomerPanelMode === 'function') {
          window.setCustomerPanelMode(path === '/account/addresses' ? 'addresses' : 'orders');
        } else if (typeof window.setAccountScreenMode === 'function') {
          window.setAccountScreenMode(path === '/account/register' ? 'register' : 'login');
        }
      } catch (e) {}
    }, 0);
    return true;
  }

  function mzApplyLocationRoute(pathOverride) {
    var path = mzNativeNormalizePath(
      pathOverride != null ? pathOverride : ((window.location && window.location.pathname) || '/')
    );

    if (path.indexOf('/products/') === 0) return mzNativeOpenProduct(path);

    if (path.indexOf('/account') === 0 || path.indexOf('/authentication') === 0 || path.indexOf('/challenge') === 0) {
      return mzNativeShowAccount(path);
    }

    var screenId = MZ_NATIVE_SCREEN_ROUTES[path];
    if (!screenId && path.indexOf('/blogs/nieuws/') === 0) screenId = 's-article';

    if (!screenId) {
      var initial = window.__MOOZERS_INITIAL_SCREEN || '';
      if (initial && initial !== 'auto') screenId = initial;
    }
    if (!screenId) screenId = 's-home';

    var handled = mzNativeActivateScreen(screenId);
    if (handled && screenId === 's-cart' && typeof window.renderCart === 'function') {
      try { window.renderCart(); } catch (e) {}
    }
    if (handled && path === '/collections/bestsellers') {
      setTimeout(function() {
        var bestsellers = document.getElementById('bestsellers-section');
        if (bestsellers) bestsellers.scrollIntoView({ block: 'start' });
      }, 80);
    }
    return handled;
  }

  /* Compatibiliteit voor bestaande interne aanroepen. Deze functie wisselt alleen
     het zichtbare scherm en manipuleert de browsergeschiedenis niet. */
  window.mzApplyLocationRoute = mzApplyLocationRoute;
  window.mzRouteInApp = function(pathname) {
    return mzApplyLocationRoute(pathname);
  };

  function mzInitNativeRoute() {
    mzApplyLocationRoute();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mzInitNativeRoute, { once: true });
  } else {
    setTimeout(mzInitNativeRoute, 0);
  }

  /* pageshow herstelt ook correct na terugnavigeren uit checkout of bfcache. */
  window.addEventListener('pageshow', function() {
    setTimeout(mzInitNativeRoute, 0);
  });
})();


// Herstel opgeslagen BTW-nummer na route/init.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function(){ if (typeof syncB2BState === 'function') { syncB2BState(); if (typeof renderCart === 'function') renderCart(); } });
} else {
  setTimeout(function(){ if (typeof syncB2BState === 'function') { syncB2BState(); if (typeof renderCart === 'function') renderCart(); } }, 0);
}


// v26: force repaint of mobile sticky add-to-cart after screen/product changes.
(function(){
  function mzRefreshMobileStickyCart(){
    var sticky = document.querySelector('#s-product .sticky-cta');
    if (!sticky) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 767px)').matches) return;
    // Repaint fixes mobile preview/iframe cases where fixed children inside scroll containers do not draw immediately.
    sticky.style.willChange = 'transform';
    sticky.style.transform = 'translateZ(0)';
    setTimeout(function(){ sticky.style.willChange = ''; }, 180);
  }
  document.addEventListener('DOMContentLoaded', mzRefreshMobileStickyCart);
  // Start de Shopify-prijscontrole direct zodra de productkaarten in de DOM staan.
  // De load-handler blijft als vangnet voor zeer trage assets of preview-iframes.
  document.addEventListener('DOMContentLoaded', function(){
    setTimeout(function(){ try { if (typeof mzApplyCardSaleBadges === 'function') mzApplyCardSaleBadges(); } catch(e) {} }, 0);
  });
  window.addEventListener('load', function(){
    setTimeout(function(){ try { if (typeof mzApplyCardSaleBadges === 'function') mzApplyCardSaleBadges(); } catch(e) {} }, 500);
    setTimeout(function(){ try { if (typeof mzSyncCollectionLiveStockCards === 'function') mzSyncCollectionLiveStockCards(); } catch(e) {} }, 650);
  }, { once:true });
  window.addEventListener('resize', mzRefreshMobileStickyCart, { passive: true });
  window.addEventListener('orientationchange', function(){ setTimeout(mzRefreshMobileStickyCart, 120); }, { passive: true });
  var origShowScreen = window.showScreen;
  if (typeof origShowScreen === 'function') {
    window.showScreen = function(id){
      var out = origShowScreen.apply(this, arguments);
      if (id === 's-product') setTimeout(mzRefreshMobileStickyCart, 0);
      return out;
    };
  }
})();

/* v33 — directe voorraadcontrole in de winkelwagen
   Doel: niet pas bij checkout ontdekken dat er te weinig voorraad is.
   Werking:
   - Bij typen/klikken in de winkelwagen wordt voorraad direct gecontroleerd.
   - Als Shopify een maximum meldt, tonen we dat direct bij de regel en blokkeren we checkout.
   - De uiteindelijke checkout blijft Shopify's bron van waarheid.
*/
(function(){
  var stockTimer = null;
  var stockSeq = 0;
  var stockCache = {}; // key -> { limit: number|null, checkedQty: number }
  var stockInProgress = false;

  function mzEsc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function(ch){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[ch];
    });
  }

  function mzLineKey(item) {
    if (!item) return '';
    var handle = item.shopifyHandle || (typeof mzInferShopifyHandle === 'function' ? mzInferShopifyHandle(item.title, item.label, item.img) : '') || '';
    var variant = String(item.variantSize || item.label || item.title || '').toLowerCase().replace(/\s+/g,' ').trim();
    return handle + '|' + variant;
  }

  function mzStockItemName(item) {
    if (!item) return 'Dit product';
    var name = String(item.title || item.name || '').replace(/\s+/g, ' ').trim();
    var variant = String(item.variantSize || item.label || '').replace(/\s+/g, ' ').trim();
    if (variant && name.toLowerCase().indexOf(variant.toLowerCase()) < 0) name += ' ' + variant;
    name = name.replace(/\s+×\s+/g, ' × ').replace(/\s+x\s+/ig, ' × ').trim();
    return name || 'Dit product';
  }

  function mzBuildStockIssue(item, limit, wantedQty) {
    var name = mzStockItemName(item);
    var wanted = Math.max(0, parseInt(wantedQty, 10) || 0);
    if (limit != null) {
      limit = Math.max(0, parseInt(limit, 10) || 0);
      if (limit <= 0) return name + ' is niet meer op voorraad. Verwijder dit product of kies een alternatief.';
      return name + ' heeft onvoldoende voorraad. Er zijn nog maximaal ' + limit + ' stuks beschikbaar; je hebt ' + wanted + ' in de winkelwagen.';
    }
    return name + ' heeft onvoldoende voorraad. Verlaag het aantal of kies een alternatief.';
  }

  function mzGroupQuantities() {
    var groups = {};
    (cart || []).forEach(function(item, i){
      var key = mzLineKey(item);
      if (!groups[key]) groups[key] = { key: key, qty: 0, indexes: [], item: item };
      groups[key].qty += Math.max(0, parseInt(item.qty, 10) || 0);
      groups[key].indexes.push(i);
    });
    return groups;
  }

  function mzExtractStockLimitFromText(text) {
    var s = String(text || '');
    var m = s.match(/slechts\s+(\d+)/i) || s.match(/only\s+(\d+)/i) || s.match(/maximum(?:\s+of)?\s+(\d+)/i) || s.match(/maximaal\s+(\d+)/i);
    if (m && m[1] != null) return Math.max(0, parseInt(m[1], 10) || 0);
    return null;
  }

  function mzLooksLikeStockError(text) {
    var l = String(text || '').toLowerCase();
    return l.indexOf('voorraad') >= 0 || l.indexOf('beschikbaarheid') >= 0 || l.indexOf('not enough') >= 0 || l.indexOf('sold out') >= 0 || l.indexOf('available') >= 0 || l.indexOf('inventory') >= 0 || l.indexOf('slechts') >= 0;
  }

  function mzVariantLimit(v) {
    if (!v) return null;
    // Belangrijk: product .js geeft per shop/market niet altijd een betrouwbare inventory_quantity terug.
    // In eerdere versies werden producten daardoor onterecht als niet op voorraad gemarkeerd.
    // We blokkeren alleen direct wanneer Shopify expliciet aangeeft dat de variant niet beschikbaar is.
    // Voor aantallen boven de voorraad gebruiken we daarna de officiële /cart/add.js-check als bron van waarheid.
    if (v.available === false) return 0;
    return null;
  }

  function mzFindLiveVariant(product, item) {
    var variants = product && product.variants ? product.variants : [];
    var wanted = String(item.variantSize || item.label || item.title || '').toLowerCase();
    var found = null;
    if (wanted) {
      for (var i = 0; i < variants.length; i++) {
        var vtxt = String([variants[i].title, variants[i].option1, variants[i].option2, variants[i].option3].join(' ')).toLowerCase();
        if (vtxt.indexOf(wanted) >= 0 || wanted.indexOf(vtxt) >= 0) { found = variants[i]; break; }
      }
    }
    if (!found) {
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].available !== false) { found = variants[j]; break; }
      }
    }
    if (!found && variants.length) found = variants[0];
    return found;
  }

  function mzResolveVariantDetail(item) {
    var handle = item.shopifyHandle || (typeof mzInferShopifyHandle === 'function' ? mzInferShopifyHandle(item.title, item.label, item.img) : '');
    if (!handle) return Promise.reject(new Error('Geen Shopify-product gekoppeld.'));
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function(res){
      if (!res.ok) throw new Error('Product niet gevonden in Shopify: ' + handle);
      return res.json();
    }).then(function(product){
      var variant = mzFindLiveVariant(product, item);
      if (!variant || !variant.id) throw new Error('Geen variant gevonden in Shopify.');
      return { handle: handle, product: product, variant: variant, variantId: variant.id };
    });
  }


  // De oude destructieve voorraadprobe (snapshot → clear → add → restore) is verwijderd.
  // Exacte aantallen worden één keer gecontroleerd in de definitieve checkout-sync.
  function mzCheckGroup(group) {
    var key = group.key;
    var wantedQty = Math.max(0, parseInt(group.qty, 10) || 0);
    var item = group.item;
    if (!item || wantedQty <= 0) return Promise.resolve({ key: key, ok: true });

    var cached = stockCache[key];
    if (cached && cached.limit != null) {
      return Promise.resolve({ key: key, limit: cached.limit, checkedQty: wantedQty, fromCache: true });
    }
    if (cached && cached.checkedQty >= wantedQty && cached.ok) {
      return Promise.resolve({ key: key, ok: true, checkedQty: cached.checkedQty, fromCache: true });
    }

    return mzResolveVariantDetail(item).then(function(detail){
      var directLimit = mzVariantLimit(detail.variant);
      if (directLimit != null) {
        return { key: key, limit: directLimit, checkedQty: wantedQty, direct: true };
      }
      if (detail.variant && detail.variant.available === false) {
        return { key: key, limit: 0, checkedQty: wantedQty, direct: true };
      }
      // Geen destructieve clear/add-voorraadprobe op de achtergrond. Die maakte
      // de echte cart tijdelijk leeg en leverde dubbele requests op. Shopify controleert
      // het exacte maximum definitief in de checkout-sync; hier is `available` voldoende.
      return { key: key, ok: true, checkedQty: wantedQty, unknown: true };
    }).catch(function(err){
      return { key: key, ok: true, unknown: true, raw: err && err.message ? err.message : String(err) };
    });
  }

  function mzApplyStockResult(group, result) {
    var key = group.key;
    var limit = result && result.limit != null ? Math.max(0, parseInt(result.limit, 10) || 0) : null;
    var stockProblem = !!(result && result.stockError && result.ok !== true);
    if (limit != null) {
      stockCache[key] = { limit: limit, checkedQty: group.qty, ok: group.qty <= limit };
    } else if (result && result.ok) {
      stockCache[key] = { limit: null, checkedQty: Math.max(group.qty, (stockCache[key] && stockCache[key].checkedQty) || 0), ok: true };
    }

    group.indexes.forEach(function(i){
      var item = cart[i];
      if (!item) return;
      item._stockChecking = false;
      item._stockLimit = limit;
      item._stockIssue = '';
      if (limit != null && group.qty > limit) {
        item._stockIssue = mzBuildStockIssue(item, limit, group.qty);
      } else if (stockProblem) {
        item._stockIssue = mzBuildStockIssue(item, null, group.qty);
      }
    });
  }

  function mzApplyKnownStockLimits() {
    var groups = mzGroupQuantities();
    Object.keys(groups).forEach(function(key){
      var group = groups[key];
      var cached = stockCache[key];
      var limit = cached && cached.limit != null ? cached.limit : null;
      group.indexes.forEach(function(i){
        var item = cart[i];
        if (!item) return;
        if (limit != null) {
          item._stockLimit = limit;
          item._stockIssue = group.qty > limit ? mzBuildStockIssue(item, limit, group.qty) : '';
        } else {
          item._stockIssue = '';
        }
      });
    });
  }

  function mzDecorateCartStockLines() {
    if (!Array.isArray(cart)) return;
    var nodes = document.querySelectorAll('#cart-items .cart-item');
    nodes.forEach(function(node, i){
      var item = cart[i];
      if (!item) return;
      var old = node.querySelector('.ci-stock-limit-msg');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      var input = node.querySelector('.ci-qty-input');
      if (input && item._stockLimit != null) input.setAttribute('max', String(item._stockLimit));
      var msg = '';
      var cls = 'ci-stock-limit-msg';
      var stockLine = node.querySelector('.ci-stock');
      if (stockLine) stockLine.textContent = mzCartStockLabel(item);
      if (item._stockChecking) {
        // Stil controleren: geen tijdelijke tekst tonen aan de klant.
        msg = '';
      } else if (item._stockIssue) {
        msg = item._stockIssue;
        cls += ' ci-stock-limit-msg--error';
      } else if (item._stockLimit != null && item._stockLimit > 0) {
        // Geen extra groene regel tonen. De normale voorraadregel zegt al hoeveel er beschikbaar is.
        msg = '';
      }
      if (msg) {
        var div = document.createElement('div');
        div.className = cls;
        div.textContent = msg;
        var anchor = node.querySelector('.ci-stock') || node.querySelector('.ci-variant') || node.querySelector('.ci-name');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(div, anchor.nextSibling);
      }
    });
  }

  function mzGetCartStockProblem() {
    if (!Array.isArray(cart)) return '';
    for (var i = 0; i < cart.length; i++) {
      if (cart[i] && cart[i]._stockIssue) return cart[i]._stockIssue;
    }
    return '';
  }

  function mzHasCheckingItems() {
    return Array.isArray(cart) && cart.some(function(item){ return item && item._stockChecking; });
  }

  function mzUpdateCheckoutAvailability() {
    var problem = mzGetCartStockProblem();
    document.querySelectorAll('.btn-checkout').forEach(function(btn){
      var loading = btn.classList.contains('mz-silent-loading') || btn.getAttribute('aria-busy') === 'true';
      if (loading) return;
      if (problem) {
        btn.disabled = true;
        btn.classList.add('mz-checkout-blocked');
      } else {
        btn.disabled = false;
        btn.classList.remove('mz-checkout-blocked');
      }
    });
  }

  function mzShowStockProblemNotice() {
    // De voorraadmelding staat direct bij het betreffende product.
    // Geen extra algemene rode melding tonen, anders ziet de klant dezelfde fout dubbel.
    if (!mzHasCheckingItems() && !mzGetCartStockProblem()) {
      if (typeof mzClearCartNotice === 'function') mzClearCartNotice();
    }
  }

  function mzValidateCartStock(showNotice) {
    if (!Array.isArray(cart) || !cart.length) {
      stockInProgress = false;
      return Promise.resolve(true);
    }
    var mySeq = ++stockSeq;
    var groups = mzGroupQuantities();
    var keys = Object.keys(groups);
    if (!keys.length) return Promise.resolve(true);

    stockInProgress = true;
    keys.forEach(function(key){
      var group = groups[key];
      var cached = stockCache[key];
      var needsCheck = !(cached && ((cached.limit != null) || (cached.checkedQty >= group.qty && cached.ok)));
      group.indexes.forEach(function(i){
        if (cart[i]) cart[i]._stockChecking = needsCheck;
      });
    });
    if (typeof renderCart === 'function') renderCart();

    var chain = Promise.resolve();
    keys.forEach(function(key){
      chain = chain.then(function(){
        if (mySeq !== stockSeq) return null;
        var freshGroups = mzGroupQuantities();
        var group = freshGroups[key];
        if (!group) return null;
        return mzCheckGroup(group).then(function(result){
          if (mySeq !== stockSeq) return null;
          var again = mzGroupQuantities()[key];
          if (again) mzApplyStockResult(again, result || {});
          if (typeof renderCart === 'function') renderCart();
          return result;
        });
      });
    });

    return chain.then(function(){
      if (mySeq !== stockSeq) return true;
      stockInProgress = false;
      mzApplyKnownStockLimits();
      if (typeof renderCart === 'function') renderCart();
      if (showNotice) mzShowStockProblemNotice();
      return !mzGetCartStockProblem();
    }).catch(function(){
      if (mySeq === stockSeq) stockInProgress = false;
      if (typeof renderCart === 'function') renderCart();
      return !mzGetCartStockProblem();
    });
  }

  function mzScheduleStockValidation() {
    if (mzCheckoutInProgress) return;
    mzApplyKnownStockLimits();
    if (typeof renderCart === 'function') renderCart();
    mzShowStockProblemNotice();
    clearTimeout(stockTimer);
    stockTimer = setTimeout(function(){ if (mzCheckoutInProgress) return; mzValidateCartStock(true); }, 220);
  }

  // Render-hook: toon voorraadmelding per winkelwagenregel en blokkeer checkout als nodig.
  if (typeof renderCart === 'function') {
    var originalRenderCartV33 = renderCart;
    renderCart = function(){
      var out = originalRenderCartV33.apply(this, arguments);
      mzApplyKnownStockLimits();
      mzDecorateCartStockLines();
      mzUpdateCheckoutAvailability();
      return out;
    };
  }

  if (typeof cartSetQty === 'function') {
    var originalCartSetQtyV33 = cartSetQty;
    cartSetQty = function(i, value){
      var out = originalCartSetQtyV33.apply(this, arguments);
      mzScheduleStockValidation();
      return out;
    };
  }

  if (typeof cartQty === 'function') {
    var originalCartQtyV33 = cartQty;
    cartQty = function(i, d){
      var out = originalCartQtyV33.apply(this, arguments);
      mzScheduleStockValidation();
      return out;
    };
  }

  if (typeof addToCart === 'function') {
    var originalAddToCartV33 = addToCart;
    addToCart = function(){
      var before = Array.isArray(cart) ? cart.length : 0;
      var out = originalAddToCartV33.apply(this, arguments);
      if (Array.isArray(cart) && cart.length > before) mzScheduleStockValidation();
      return out;
    };
  }

  if (typeof quickAdd === 'function') {
    var originalQuickAddV33 = quickAdd;
    quickAdd = function(){
      var out = originalQuickAddV33.apply(this, arguments);
      mzScheduleStockValidation();
      return out;
    };
  }

  // Checkout gebruikt bewust géén aparte voorraad-precheck meer.
  // De definitieve Shopify-cart-sync in goToLiveCheckout controleert zelf of alle
  // gevraagde aantallen werkelijk zijn toegevoegd en toont dan een productspecifieke
  // fout. Zo kan een geannuleerde of verouderde achtergrondcontrole checkout niet
  // meer blokkeren met de generieke melding ‘Pas het aantal aan om af te rekenen.’.



  // V51: controleer voorraad meteen wanneer de klant de winkelwagen opent of aantallen typt.
  // Dit draait op de achtergrond; de klant ziet alleen een concrete melding bij het betreffende product.
  window.mzScheduleStockValidation = mzScheduleStockValidation;
  window.mzValidateCartStock = mzValidateCartStock;

  if (typeof showScreen === 'function') {
    var originalShowScreenV51 = showScreen;
    showScreen = function(id){
      var out = originalShowScreenV51.apply(this, arguments);
      if (id === 's-cart') setTimeout(function(){ mzScheduleStockValidation(); }, 0);
      return out;
    };
  }

  if (typeof goToCart === 'function') {
    var originalGoToCartV51 = goToCart;
    goToCart = function(){
      var out = originalGoToCartV51.apply(this, arguments);
      setTimeout(function(){ mzScheduleStockValidation(); }, 0);
      return out;
    };
  }

  var mzQtyInputTimer = null;
  document.addEventListener('input', function(e){
    var inp = e.target && e.target.closest && e.target.closest('.ci-qty-input');
    if (!inp) return;
    clearTimeout(mzQtyInputTimer);
    mzQtyInputTimer = setTimeout(function(){
      var idx = parseInt(inp.getAttribute('data-cart-index'), 10);
      if (typeof cartSetQty === 'function') cartSetQty(idx, inp.value);
    }, 220);
  }, true);

  document.addEventListener('DOMContentLoaded', function(){
    setTimeout(function(){
      if (typeof renderCart === 'function') renderCart();
      mzScheduleStockValidation();
    }, 100);
  });
})();

/* v72: mobiele winkelwagen-scroll stabiliseren */
(function(){
  function mzSetCartViewportHeight(){
    try {
      var h = window.innerHeight || document.documentElement.clientHeight || 0;
      if (h > 320) document.documentElement.style.setProperty('--mz-cart-vh', h + 'px');
    } catch(e) {}
  }
  function mzIsCartActive(){
    var cartScreen = document.getElementById('s-cart');
    return !!(cartScreen && cartScreen.classList.contains('active'));
  }
  function mzSyncCartScreenState(){
    mzSetCartViewportHeight();
    var active = mzIsCartActive();
    document.documentElement.classList.toggle('mz-cart-screen-active', active);
    if (document.body) document.body.classList.toggle('mz-cart-screen-active', active);
    if (active) {
      var scroller = document.querySelector('#s-cart.active .cart-scrollable');
      if (scroller && scroller.scrollHeight <= scroller.clientHeight + 4) scroller.scrollTop = 0;
    }
  }

  if (typeof showScreen === 'function') {
    var mzOriginalShowScreenV72 = showScreen;
    showScreen = window.showScreen = function(id){
      mzOriginalShowScreenV72(id);
      mzSyncCartScreenState();
      if (id === 's-cart') {
        var scroller = document.querySelector('#s-cart.active .cart-scrollable');
        if (scroller) scroller.scrollTop = 0;
      }
    };
  }

  window.addEventListener('resize', mzSyncCartScreenState, { passive: true });
  window.addEventListener('orientationchange', function(){ setTimeout(mzSyncCartScreenState, 250); }, { passive: true });
  document.addEventListener('DOMContentLoaded', mzSyncCartScreenState);
// v20: vanaf-prijs Dozen Tape initialiseren op DOM-ready
document.addEventListener('DOMContentLoaded', function() {
  mzUpdateDozenVanafPrijs();
  mzRefreshDozenVanafPrijsFromShopify();
});
  setTimeout(mzSyncCartScreenState, 50);
})();

/* v73: mobiele paginahoogte stabiel houden om lege onderruimte te voorkomen */
(function(){
  function mzSetAppViewportHeight(){
    try {
      var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight || document.documentElement.clientHeight || 0;
      if (h > 320) document.documentElement.style.setProperty('--mz-app-vh', Math.round(h) + 'px');
    } catch(e) {}
  }
  function mzTrimInactiveScreenScroll(){
    try {
      var active = document.querySelector('.screen.active');
      if (!active) return;
      var screens = document.querySelectorAll('.screen');
      screens.forEach(function(screen){
        if (screen !== active) screen.scrollTop = 0;
      });
      if (active.id !== 's-cart') {
        document.documentElement.classList.remove('mz-cart-screen-active');
        if (document.body) document.body.classList.remove('mz-cart-screen-active');
      }
    } catch(e) {}
  }
  if (typeof showScreen === 'function') {
    var mzOriginalShowScreenV73 = showScreen;
    showScreen = window.showScreen = function(id){
      mzSetAppViewportHeight();
      var result = mzOriginalShowScreenV73.apply(this, arguments);
      setTimeout(mzTrimInactiveScreenScroll, 0);
      return result;
    };
  }
  window.addEventListener('resize', mzSetAppViewportHeight, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', mzSetAppViewportHeight, { passive: true });
  window.addEventListener('orientationchange', function(){ setTimeout(mzSetAppViewportHeight, 250); }, { passive: true });
  document.addEventListener('DOMContentLoaded', function(){ mzSetAppViewportHeight(); setTimeout(mzTrimInactiveScreenScroll, 80); });
  setTimeout(mzSetAppViewportHeight, 50);
})();

/* v74: reset document-scroll na screenwissel zodat mobiele blauwe header niet buiten beeld blijft */
(function(){
  function mzForceMobileHeaderVisible(id){
    try {
      var screen = document.getElementById(id) || document.querySelector('.screen.active');
      if (!screen) return;

      /* Sinds v73 scrollt op mobiel vooral het document i.p.v. de losse .screen.
         Reset beide, want anders opent een nieuwe pagina soms halverwege zonder header. */
      screen.scrollTop = 0;
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      if (typeof window.scrollTo === 'function') window.scrollTo(0, 0);

      var header = null;
      for (var i = 0; i < screen.children.length; i++) {
        if (screen.children[i].classList && screen.children[i].classList.contains('header')) {
          header = screen.children[i];
          break;
        }
      }
      if (header) {
        header.style.display = 'flex';
        header.style.visibility = 'visible';
        header.style.opacity = '1';
      }
    } catch(e) {}
  }

  if (typeof showScreen === 'function') {
    var mzOriginalShowScreenV74 = showScreen;
    showScreen = window.showScreen = function(id){
      var result = mzOriginalShowScreenV74.apply(this, arguments);
      mzForceMobileHeaderVisible(id);
      setTimeout(function(){ mzForceMobileHeaderVisible(id); }, 0);
      setTimeout(function(){ mzForceMobileHeaderVisible(id); }, 80);
      return result;
    };
  }

  document.addEventListener('DOMContentLoaded', function(){
    var active = document.querySelector('.screen.active');
    if (active) setTimeout(function(){ mzForceMobileHeaderVisible(active.id); }, 0);
  });
})();

// v11: canonical bijwerken bij pilwissels (Apex Mesh)
function mzSetCanonical(url) {
  if (!url) return;
  try {
    var abs = (url.indexOf('http') === 0) ? url
      : (window.location.protocol + '//' + window.location.host + url);
    var el = document.querySelector('link[rel="canonical"]');
    if (el) { el.href = abs; } else {
      el = document.createElement('link'); el.rel = 'canonical'; el.href = abs;
      (document.head || document.documentElement).appendChild(el);
    }
  } catch(e) {}
}

// ── v100: interne storefront-links gebruiken native Shopify-navigatie ──────
// Er wordt bewust geen document-brede click-handler, preventDefault of pushState
// meer gebruikt. Daardoor kan de URL nooit los raken van de zichtbare pagina.
// Na iedere echte paginalaad selecteert mzApplyLocationRoute hierboven het juiste
// bestaande Moozers-scherm op basis van window.location.pathname.

// ── v91: SEO-schema injector (Product + BreadcrumbList + H1 per scherm) ─────
;(function(){
  'use strict';
  var MZ_CDN    = 'https://www.moozers.nl/cdn/shop/files/';
  var MZ_ORIGIN = 'https://www.moozers.nl';

  // H1 per SPA-scherm (zichtbaar voor Googlebot; visueel verborgen via aria-hidden op andere schermen)
  var MZ_H1_MAP = {
    's-home':             'Professionele schildermaterialen kopen bij Moozers',
    's-collection':       'Washi Tape kopen – MOOZERS',
    's-coll-maskeer':     'Maskeerfolie kopen – MOOZERS',
    's-coll-schuur':      'Schuurmaterialen kopen – MOOZERS',
    's-coll-apex':       'Apex Mesh schuurnetten kopen – MOOZERS',
    's-coll-dozen':       'Dozen Washi Tape kopen – MOOZERS',
    's-coll-gereedschap': 'Gereedschap kopen – MOOZERS',
    's-zakelijk':         'Zakelijk bestellen bij MOOZERS',
    's-over':             'Over MOOZERS',
    's-contact':          'Contact – MOOZERS',
    's-blog':             'MOOZERS Blog – Schilderstips',
    's-mesh':             'Apex Mesh schuurnetten – MOOZERS'
  };
  var MZ_H1_DEFAULT = 'Professionele schildermaterialen kopen bij Moozers';

  // Canonieke product-URL per CATALOG-id
  var MZ_SCHEMA_URL = {
    'washi-tape':       '/products/moozers-washi-tape-geel-24mm',
    'washi-tape-paars': '/products/moozers-washi-tape-paars-24mm',
    'maskeerfolie':     '/products/moozers-maskeerfolie-1500mm',
    'maskeerpapier':    '/products/moozers-maskeerpapier-300mm-x-20m',
    'schuurpapier':     '/collections/schuur-materialen',
    'schuurpad':        '/products/moozers-schuurpad-dubbelzijdig-p120',
    'schuurschijf':     '/collections/schuur-materialen',
    'dozen-tape':       '/products/doos-moozers-washi-tape-geel-24mm-36rollen',
    'glasschraper':     '/products/moozers-glasschraper',
    'joint-mesh-gaasband': '/products/moozers®-joint-mesh-gaasband-50mm-x-90m',
    'apex-mesh-rond':     '/products/moozers®-apex-mesh-p150-150mm-schuurgaas-50-stuks',
    'apex-mesh-80x133':   '/products/moozers®-apex-mesh-p150-80x133mm-schuurgaas-50-stuks'
  };

  // Variant-specifieke URL (Washi/Maskeerfolie hebben eigen product-URL per maat)
  var MZ_VARIANT_URL = {
    'washi-tape|19':                '/products/moozers-washi-tape-geel-19mm',
    'washi-tape|24':                '/products/moozers-washi-tape-geel-24mm',
    'washi-tape|36':                '/products/moozers-washi-tape-geel-36mm',
    'washi-tape|50':                '/products/moozers-washi-tape-geel-50mm',
    'washi-tape-paars|24':          '/products/moozers-washi-tape-paars-24mm',
    'washi-tape-paars|36':          '/products/moozers-washi-tape-paars-36mm',
    'maskeerfolie|1500mm × 30m': '/products/moozers-maskeerfolie-1500mm',
    'maskeerfolie|2700mm × 20m': '/products/moozers-maskeerfolie-2700mm',
    // apex-mesh-rond (maat als variant-groep)
    'apex-mesh-rond|150mm':        '/products/moozers®-apex-mesh-p150-150mm-schuurgaas-50-stuks',
    'apex-mesh-rond|125mm':        '/products/moozers®-apex-mesh-p150-125mm-schuurgaas-50-stuks',
    // apex-mesh-80x133 (korrel als variant-groep; maat is altijd 80×133mm)
    'apex-mesh-80x133|P150':       '/products/moozers®-apex-mesh-p150-80x133mm-schuurgaas-50-stuks',
    'apex-mesh-80x133|P180':       '/products/moozers®-apex-mesh-p180-80x133mm-schuurgaas-50-stuks',
    'apex-mesh-80x133|P220':       '/products/moozers®-apex-mesh-p220-80x133mm-schuurgaas-50-stuks',
    'apex-mesh-80x133|P240':       '/products/moozers®-apex-mesh-p240-80x133mm-schuurgaas-50-stuks',
    'apex-mesh-80x133|P320':       '/products/moozers®-apex-mesh-p320-80x133mm-schuurgaas-50-stuks'
  };

  function mzSchemaUrl(productId, variantSize) {
    // Gebruik de actuele URL als die al correct is (na pushState)
    var curPath = typeof window !== 'undefined' && window.location ? window.location.pathname : '';
    if (curPath && curPath.indexOf('/products/') === 0) {
      return MZ_ORIGIN + curPath;
    }
    if (variantSize) {
      var vKey = productId + '|' + variantSize;
      if (MZ_VARIANT_URL[vKey]) return MZ_ORIGIN + MZ_VARIANT_URL[vKey];
    }
    return MZ_ORIGIN + (MZ_SCHEMA_URL[productId] || '/');
  }

  function mzImgUrl(v) {
    if (!v || !v.img) return '';
    var raw = String(v.img);
    if (/^https?:\/\//i.test(raw)) return raw;
    return MZ_CDN + raw + (v.imgV ? '?v=' + v.imgV : '');
  }

  function mzUpdateH1(text) {
    /* H1 wordt bijgewerkt via de zichtbare paginatitel (#p-name, .coll-h, .hero-h) */
  }

  function mzUpsertSchema(schemaArr) {
    var el = document.getElementById('mz-ld-product');
    if (!el) {
      el = document.createElement('script');
      el.type  = 'application/ld+json';
      el.id    = 'mz-ld-product';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schemaArr);
  }

  function mzRemoveProductSchema() {
    var el = document.getElementById('mz-ld-product');
    if (el) el.parentNode.removeChild(el);
  }

  function mzBuildSchemas(product, variant) {
    var url  = mzSchemaUrl(product.id, variant ? variant.size : null);
    var img  = mzImgUrl(variant);
    // Structured data volgt dezelfde live Shopify-voorraadstatus als de productpagina.
    var avail = (variant && mzVariantStockState(variant) === 'loaded' && variant.inStock)
      ? 'https://schema.org/InStock'
      : 'https://schema.org/OutOfStock';
    var price  = variant && variant.priceIncl ? (+variant.priceIncl).toFixed(2) : '0.00';
    var pname  = (variant && variant.title) ? variant.title : (product.id || 'product');
    var brand  = (product.brand || 'MOOZERS').replace('®', '');
    var catUrl = MZ_ORIGIN + (product.navLink ? product.navLink.replace(MZ_ORIGIN,'') : '/');

    var d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    var priceValidUntil = d.toISOString().slice(0, 10);

    var productSchema = {
      '@context': 'https://schema.org/',
      '@type':    'Product',
      'name':     pname,
      'image':    img ? [img] : [],
      'brand':    { '@type': 'Brand', 'name': brand },
      'url':      url,
      'offers': {
        '@type':          'Offer',
        'priceCurrency':  'EUR',
        'price':          price,
        'priceValidUntil': priceValidUntil,
        'availability':   avail,
        'url':            url,
        'seller':         { '@type': 'Organization', 'name': 'MOOZERS' }
      }
    };

    var breadcrumb = {
      '@context': 'https://schema.org',
      '@type':    'BreadcrumbList',
      'itemListElement': [
        { '@type':'ListItem', 'position':1, 'name':'Home',              'item': MZ_ORIGIN + '/'   },
        { '@type':'ListItem', 'position':2, 'name': product.category || 'Producten', 'item': catUrl },
        { '@type':'ListItem', 'position':3, 'name': pname,             'item': url    }
      ]
    };

    return [productSchema, breadcrumb];
  }

  // ── Wrap loadProduct ──────────────────────────────────────────
  if (typeof loadProduct === 'function') {
    var _mzSEO_origLP = loadProduct;
    loadProduct = window.loadProduct = function(id) {
      _mzSEO_origLP.apply(this, arguments);
      try {
        var p  = (typeof CATALOG !== 'undefined') ? CATALOG[id] : null;
        if (!p) return;
        var v  = p.variants[p.defaultVariantIndex] || p.variants[0];
        mzUpsertSchema(mzBuildSchemas(p, v));
        mzUpdateH1(v ? v.title : p.id);
      } catch(e) {}
    };
  }

  // ── Wrap loadProductVariant (variant-specifiek) ───────────────
  if (typeof loadProductVariant === 'function') {
    var _mzSEO_origLPV = loadProductVariant;
    loadProductVariant = window.loadProductVariant = function(id, sz) {
      _mzSEO_origLPV.apply(this, arguments);
      try {
        var p = (typeof CATALOG !== 'undefined') ? CATALOG[id] : null;
        if (!p) return;
        var szStr = String(sz == null ? '' : sz).toLowerCase().replace(/\s+/g,'').replace('mm','');
        var v = null;
        for (var i = 0; i < p.variants.length; i++) {
          var cands = [p.variants[i].size, p.variants[i].label, p.variants[i].title].map(function(x){
            return String(x == null ? '' : x).toLowerCase().replace(/\s+/g,'').replace('mm','');
          });
          if (cands.indexOf(szStr) !== -1) { v = p.variants[i]; break; }
        }
        if (!v) v = p.variants[p.defaultVariantIndex] || p.variants[0];
        mzUpsertSchema(mzBuildSchemas(p, v));
        mzUpdateH1(v ? v.title : p.id);
      } catch(e) {}
    };
  }

  // ── Wrap showScreen (H1 + schema-cleanup buiten product) ─────
  if (typeof showScreen === 'function') {
    var _mzSEO_origSS = showScreen;
    showScreen = window.showScreen = function(id) {
      _mzSEO_origSS.apply(this, arguments);
      try {
        if (id !== 's-product') {
          mzRemoveProductSchema();
          mzUpdateH1(MZ_H1_MAP[id] || MZ_H1_DEFAULT);
        }
      } catch(e) {}
    };
  }

  // setDozenCV wrapper — canonical URL + schema bij elke dozen-variantwissel
  // Dekt: directe URL-landing, interne SPA-nav, kleur/breedte/inhoud-wissel
  if (typeof setDozenCV === 'function') {
    var _mzSEO_origSetDozenCV = setDozenCV;
    setDozenCV = window.setDozenCV = function() {
      _mzSEO_origSetDozenCV.apply(this, arguments);
      try {
        // cv is gezet door originele setDozenCV; dozen-varianten hebben .kleur
        var v = (typeof cv !== 'undefined' && cv && cv.kleur) ? cv : null;
        if (!v) return;
        var p = CATALOG && CATALOG['dozen-tape'];
        if (!p) return;
        // Canonieke product-URL: altijd op basis van de actieve variant
        var productPath = '/products/doos-moozers-washi-tape-'
          + v.kleur.toLowerCase() + '-' + v.breedte + 'mm-' + v.inhoud + 'rollen';
        // Browser-URL bijwerken
        try { history.replaceState(history.state, '', productPath); } catch(e2) {}
        // Schema injecteren
        mzUpdateH1(v.title || p.id);
        mzUpsertSchema(mzBuildSchemas(p, v));
      } catch(e) {}
    };
  }
})();
